import { CKEditor } from '@ckeditor/ckeditor5-react';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import { faArrowDown, faArrowUp, faCalendarAlt, faCheckCircle, faCircleXmark, faDownload, faEnvelope, faFileLines, faFilePdf, faFilter, faPencil, faPlus, faSearch, faSliders, faSort, faTimes, faTimesCircle, faTrash, faUpload, faUser, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import * as FileSaver from 'file-saver';
// import moment from 'moment';
import React, { Component } from 'react';
import { Alert, Badge, Button, Col, Dropdown, Form, InputGroup, Modal, Nav, Offcanvas, Row, Spinner, ButtonGroup } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { DateRangePicker } from 'react-date-range';
import Flatpickr from 'react-flatpickr';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import XLSX from 'sheetjs-style';
import { GET, POST } from '../../api';
import SampleXL from '../../assets/sample_crm.xlsx';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { handleFormErrors } from '../../helpers/form_helpers';
import { t } from '../../helpers/translation_helper';
import { getUrlParam, isInt } from '../../helpers/general_helpers';
import Pagination from '../_partials/Pagination';
import LeadCard from './LeadCard';
import LeadTasks from './LeadTasks';
import { styleV3_1 } from '../../helpers/style_v3.1_helper';
import DatePicker from "@deskpro/react-datepicker-hijri";
import moment from "moment-hijri";

import "@deskpro/react-datepicker-hijri/dist/react-datepicker.css";
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';

var Chance = require('chance');
var chance = new Chance();
let cancelToken;
const apiURL = process.env.REACT_APP_API_URL;

class Leads extends Component {
  searchFieldRef = React.createRef();
  import_data = React.createRef();
  picture = React.createRef();
  child_eid_page = React.createRef();
  child_eid_page_back = React.createRef();
  child_residency_copy = React.createRef();
  prev_school_rep_doc = React.createRef();
  child_passport = React.createRef();
  visa_page = React.createRef();
  birth_certcopy = React.createRef();
  vaccination_copy = React.createRef();
  med_formcopy = React.createRef();
  father_id_attachment = React.createRef();
  father_id_attachment_back = React.createRef();
  father_passport_attachment = React.createRef();
  father_visa_attachment = React.createRef();
  mother_id_attachment = React.createRef();
  mother_id_attachment_back = React.createRef();
  mother_passport_attachment = React.createRef();
  mother_visa_attachment = React.createRef();
  signature = React.createRef();
  indemnity_formcopy = React.createRef();
  child_lastyear_report = React.createRef();
  child_transfer_doc = React.createRef();
  sponsor_noc = React.createRef();
  document1 = React.createRef();
  document2 = React.createRef();
  document3 = React.createRef();
  document4 = React.createRef();
  document5 = React.createRef();
  family_card_doc = React.createRef();



  deleteConfirm = {
    show: false,
    id: 0,
    action: () => { }
  }

  centerWeekend = this.props.authData.centerData.weekend_days.split(',');

  livingStatus = [
    { value: 1, label: 'Both Parents' },
    { value: 2, label: 'Father' },
    { value: 3, label: 'Mother' },
    { value: 4, label: 'Others' },
  ];

  readingProf = [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' }
  ];
  writingProf = [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' }
  ];
  speakingProf = [
    { value: 'Beginner', label: 'Beginner' },
    { value: 'Intermediate', label: 'Intermediate' },
    { value: 'Advanced', label: 'Advanced' }
  ];

  defaultFormFields = {
    waiting_id: 0,
    parent_name: '',
    primary_contact: 'Father',
    phone1: '',
    email1: '',
    country_id: null,
    child_name: '',
    child_birth: '',
    gender: 'M',
    waiting_date: moment().format('YYYY-MM-DD'),
    visitby_id: null,
    referral_id: null,
    employee_id: null,
    class_id: null,
    joining_date: '',
    joining_note: '',
    notes: '',
    term_id: '',
    monday: this.centerWeekend.includes('monday') ? 0 : 1,
    tuesday: this.centerWeekend.includes('tuesday') ? 0 : 1,
    wednesday: this.centerWeekend.includes('wednesday') ? 0 : 1,
    thursday: this.centerWeekend.includes('thursday') ? 0 : 1,
    friday: this.centerWeekend.includes('friday') ? 0 : 1,
    saturday: this.centerWeekend.includes('saturday') ? 0 : 1,
    sunday: this.centerWeekend.includes('sunday') ? 0 : 1,
    previous_nursery: '',
    reasontoleaveprev: '',
    commentonprev: '',
  };

  taskFields = {
    ls_id: null,
    noenrolment_id: null,
    no_reg_reason: '',
    task_duedate: moment().format('YYYY-MM-DD'),
    task_reminder_date: moment().format('YYYY-MM-DD'),
    task_desc1: '',
    task_desc2: '',
    attachment1: '',
    attachment2: '',
    attachment3: '',
  };

  bulkMailFields = {
    cet_id: 0,
    cet_subject: '',
    cet_template: '',
  };

  noteFields = {
    wn_id: 0,
    wn_note: '',
  };

  formUrlFields = {
    admission_email_subject: 'Admission Form',
    admission_parent_email: '',
    admission_payment_url: '',
    email_template: '',
  };

  filterFields = {
    filter_date_range: {
      startDate: moment().subtract(3, 'months').toDate(),
      endDate: new Date(),
      key: 'selection',
    },
    filter_approved_date: {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection',
    },
    filter_approved_date_enable: false,
    filter_date_range_enable: false,
    filter_age: '',
    filter_nationality: '',
    filter_source: '',
    filter_referral: '',
    filter_class: '',
    filter_status: '',
    filter_leadstatus: [],
    filter_joining_date: '',
    filter_enable: false,
    filter_admission: ''
  };

  admissionFormFields = {
    child_name: '',
    child_first_name: '',
    child_middle_name: '',
    child_last_name: '',
    passport_number: '',
    passport_validity: '',
    residency_number: '',
    residency_validity: '',
    arabic_name: '',
    child_family_name: '',
    child_family_name_2: '',
    birth_date: '',
    birth_date2: '',
    birth_city: '',
    gender: '',
    country_id: '',
    country_id2: '',
    father_nationality: '',
    mother_nationality: '',
    religion: '',
    id_number: '',
    sponsor_role: '',
    father_name: '',
    father_name_2: '',
    father_id_number: '',
    father_income: '',
    mother_income: '',
    grandfather_name: '',
    father_passport_num: '',
    father_passport_validity: '',
    father_residency_number: '',
    father_residency_validity: '',
    father_education: '',
    mother_education: '',
    father_mobile: '',
    father_workphone: '',
    father_email: '',
    father_employer: '',
    father_position: '',
    mother_passport_num: '',
    mother_passport_validity: '',
    mother_residency_number: '',
    mother_residency_validity: '',
    home_address: '',
    home_city: '',
    home_street: '',
    home_phone: '',
    home_pobox: '',
    livingstatus_type: '',
    livingstatus_desc: '',
    child_school_leaving_reason: '',
    full_term_delivery: '',
    spouse_role: '',
    mother_name: '',
    mother_mobile: '',
    mother_workphone: '',
    mother_email: '',
    mother_employer: '',
    mother_position: '',
    child_siblings: '',
    child_siblings_age: '',
    child_school_attending: '',
    emergency_contact1: '',
    emergency_relation1: '',
    emergency_phone1: '',
    emergency_contact2: '',
    emergency_relation2: '',
    emergency_phone2: '',
    emergency_contact3: '',
    emergency_relation3: '',
    emergency_phone3: '',
    sponsor_name: '',
    sponsor_desc: '',
    sponsor_phone1: '',
    sponsor_phone2: '',
    sponsor_email: '',
    nanny_name: '',
    nanny_phone: '',
    driver_name: '',
    driver_phone: '',
    current_curr: '',
    picture: '',
    picture_prev: '',
    picture_delete_flag: null,
    attending_times: '',
    child_eid_page: '',
    child_eid_page_prev: '',
    child_eid_page_delete_flag: null,
    child_eid_page_back: '',
    child_eid_page_back_prev: '',
    child_eid_page_back_delete_flag: null,
    child_residency_copy: '',
    child_residency_copy_prev: '',
    child_residency_copy_delete_flag: null,
    prev_school_rep_doc: '',
    prev_school_rep_doc_prev: '',
    prev_school_rep_doc_delete_flag: null,
    child_passport: '',
    child_passport_prev: '',
    child_passport_delete_flag: null,
    visa_page: '',
    visa_page_prev: '',
    visa_page_delete_flag: null,
    birth_certcopy: '',
    birth_certcopy_prev: '',
    birth_certcopy_delete_flag: null,
    vaccination_copy: '',
    vaccination_copy_prev: '',
    vaccination_copy_delete_flag: null,
    med_formcopy: '',
    med_formcopy_prev: '',
    med_formcopy_delete_flag: null,
    father_id_attachment: '',
    father_id_attachment_prev: '',
    father_id_attachment_delete_flag: null,
    father_id_attachment_back: '',
    father_id_attachment_back_prev: '',
    father_id_attachment_back_delete_flag: null,
    father_passport_attachment: '',
    father_passport_attachment_prev: '',
    father_passport_attachment_delete_flag: null,
    father_visa_attachment: '',
    father_visa_attachment_prev: '',
    father_visa_attachment_delete_flag: null,
    mother_id_attachment: '',
    mother_id_attachment_prev: '',
    mother_id_attachment_delete_flag: null,
    mother_id_attachment_back: '',
    mother_id_attachment_back_prev: '',
    mother_id_attachment_back_delete_flag: null,
    mother_passport_attachment: '',
    mother_passport_attachment_prev: '',
    mother_passport_attachment_delete_flag: null,
    mother_visa_attachment: '',
    mother_visa_attachment_prev: '',
    mother_visa_attachment_delete_flag: null,
    indemnity_formcopy: '',
    indemnity_formcopy_prev: '',
    indemnity_formcopy_delete_flag: null,
    child_lastyear_report: '',
    child_lastyear_report_prev: '',
    child_lastyear_report_delete_flag: null,
    child_transfer_doc: '',
    child_transfer_doc_prev: '',
    child_transfer_doc_delete_flag: null,
    sponsor_noc: '',
    sponsor_noc_prev: '',
    sponsor_noc_delete_flag: null,
    document1: '',
    document1_prev: '',
    document1_delete_flag: null,
    document2: '',
    document2_prev: '',
    document2_delete_flag: null,
    document3: '',
    document3_prev: '',
    document3_delete_flag: null,
    document4: '',
    document4_prev: '',
    document4_delete_flag: null,
    document5: '',
    document5_prev: '',
    document5_delete_flag: null,
    family_card_doc: '',
    family_card_doc_prev: '',
    family_card_doc_delete_flag: null,
    child_position_family: '',
    child_prev_settings: '',
    child_prev_settings_details: '',
    first_lang: '',
    second_lang: '',
    third_lang: '',
    home_language: '',
    father_language: '',
    mother_language: '',
    child_religion_food_clothing_desc: '',
    child_diet_milktype: '',
    child_diet_milktype_preparation: '',
    child_diet_milktype_qty: '',
    child_diet_milktype_freq: '',
    child_weaningfood: '',
    child_weaningfood_volume: '',
    child_weaningfood_freq: '',
    child_weaningfood_snack: '',
    child_weaningfood_maincourse: '',
    child_weaningfood_puddings: '',
    child_sleep_time: '',
    child_sleep_mins: '',
    child_sleep_comforters: '',
    child_use_toilet: [],
    child_use_toilet_0: '',
    child_use_toilet_1: '',
    child_use_toilet_2: '',
    child_use_drinkcup: 'No',
    child_use_cutlery: '',
    child_relate_children: 0,
    child_relate_familiar_adults: 0,
    child_take_turns: 0,
    notes: '',
    child_toys: '',
    child_activities: '',
    child_distress: '',
    child_extra_info: '',
    emergency_treatment: 0,
    pic_nursery: 1,
    pic_media: 1,
    pic_social: 1,
    take_pictures: 1,
    allow_pic: 1,
    staff_child: 1,
    check_acknowledgement: 0,
    child_sen: 0,
    admin_medication_1: 0,
    admin_medication_2: 0,
    medical_examination: 0,
    health_condition: 0,
    medicines: '',
    medical_note: '',
    special_disabilities: '',
    health_insurance_num: '',
    health_insurance_company: '',
    health_insurance_type: '',
    medical_emergency_fileno: '',
    child_evaluated_by: '',
    bloodgroup: '',
    child_weight: '',
    child_height: '',
    allergies: '',
    previous_enroll: 0,
    transport_required: 0,
    transport: '',
    radio_covid_diagnosed_family: 0,
    covid_diagnosed_family: '',
    covid_close_contact: 0,
    covid_symptoms: 0,
    radio_covid_international_travel: 'No',
    covid_international_travel: '',
    medical_emergency_name: '',
    medical_emergency_doc: '',
    medical_emergency_clinic: '',
    medical_emergency_phone: '',
    radio_leela_allergies: 'No',
    leela_allergies: '',
    radio_leela_dietry_intolerances: 'No',
    leela_dietry_intolerances: '',
    radio_leela_special_req: 'No',
    leela_special_req: '',
    allergies: '',
    allergic_reactions: '',
    childChronics: [],
    childImmunizations: [],
    childIllnesses: [],
    childAllergies: [],
    childConditions: [],
    attending_days: [],
    signature: '',
    signature_prev: '',
    signature_delete_flag: null,
    num_of_days: '',
    food_tasting: 0,
    term_id: '',
    centerlic_id: '',
    term_d_id: '',
    agegroup_id: '',
    classmain_id: ''
  };

  childChronicFields = {
    childChronicID: 0,
    childChronic: '',
    childChronicDesc: '',
    childChronicDate: '',
  };

  childImmunizationFields = {
    childImmuneVaccineID: 0,
    childImmuneVaccine: '',
    childImmuneDate: '',
    childImmuneDose: '',
  };

  childIllnessFields = {
    childIllnessID: 0,
    childIllness: '',
    childIllnessDesc: '',
    childIllnessDate: '',
  };

  childAllergyFields = {
    childAllergyID: 0,
    childAllergy: '',
    childAllergyDesc: '',
    childAllergyDate: '',
  };

  childConditionFields = {
    childCondition: '',
    childConditionDesc: '',
    childConditionDate: '',
  };

  siblingFields = {
    adm_sib_id: 0,
    adm_sib_name: '',
    adm_sib_dob: '',
    adm_sib_school: '',
    adm_sib_gender: 'M',
  };

  admissionFormTabs = [
    { tabID: 'tab_one', tabName: 'Application' },
    { tabID: 'tab_eleven', tabName: 'Siblings' },
    { tabID: 'tab_eight', tabName: 'Registration Info' },
    { tabID: 'tab_two', tabName: 'Required Documents' },
    { tabID: 'tab_three', tabName: 'Individual Profile Care & Plan' },
    { tabID: 'tab_four', tabName: 'Visual Media Consent' },
    { tabID: 'tab_five', tabName: 'Clinic Information' },
    { tabID: 'tab_six', tabName: 'Food & Other Allergy' },
    { tabID: 'tab_seven', tabName: 'Child Medical' },
    { tabID: 'tab_ten', tabName: 'Countries' },
    { tabID: 'tab_twelve', tabName: 'Q&A' },
    { tabID: 'tab_nine', tabName: 'Terms & Conditions' },
  ];

  leadFormTabs = [
    { tabID: 'lead_form_tab_one', tabName: 'Lead' },
    { tabID: 'lead_form_tab_two', tabName: 'Details' },
    { tabID: 'lead_form_tab_three', tabName: 'Joining Days' },
    { tabID: 'lead_form_tab_four', tabName: 'Select Days' },
    { tabID: 'lead_form_tab_five', tabName: 'Previous Institution' },
  ];

  filterStatus = [
    { value: 'R', label: 'Registered' },
    { value: 'Y', label: 'Open' },
    { value: 'N', label: 'Lost' },
  ];

  filterAdmission = [
    { value: '1', label: 'Linked Admission Data' },
    { value: '0', label: 'No Admission Data' },
  ];

  state = {
    ...this.defaultFormFields,
    ...this.taskFields,
    ...this.bulkMailFields,
    ...this.noteFields,
    ...this.formUrlFields,
    siblingFields: { ...this.siblingFields },
    working: false,
    isEditing: false,
    showFormModal: false,
    visitbys: [],
    noEnrReasons: [],
    referrals: [],
    operators: [],
    classes: [],
    leadStatusList: [],
    emailTemplates: [],
    countries: [],
    nationalities: [],
    ddl_allergies: [],
    ddl_illnesses: [],
    ddl_classmain: [],
    ddl_agegroup: [],
    ddl_centerlic: [],
    ddl_terms_default: [],
    vaccines: [],
    languages: [],
    terms: [],
    cdt: {
      fetching: false,
      search: '',
      rows: 10,
      offset: 0,
      order: 'w.waiting_id',
      dir: 'DESC',
      lastPage: 0,
      page: 0,
      totalRecords: 0,
      rowsOptions: [10, 25, 50, -1],
      columns: [
        {
          id: 'w.waiting_id',
          column: 'waiting_id',
          name: 'ID',
          visibility: true,
          sortable: true,
          width: 200,
        },
        {
          id: 'waiting_tasks_count',
          column: 'waiting_tasks_count',
          name: 'Tasks',
          visibility: true,
          sortable: true,
        },
        // {
        //   id: 'last_task',
        //   column: 'last_task',
        //   name: 'Last Task',
        //   visibility: true,
        //   sortable: false
        // },
        {
          id: 'ls.ls_abbreviation',
          column: 'ls_abbreviation',
          name: 'Flow',
          visibility: true,
          sortable: false,
          width: 150,
        },
        {
          id: 'w.interested',
          column: 'interested',
          name: 'Status',
          visibility: true,
          sortable: false,
        },
        {
          id: 'w.term_name',
          column: 'term_name',
          name: 'Term',
          visibility: true,
          sortable: false,
        },
        {
          id: 'w.waiting_date',
          column: 'waiting_date',
          name: 'Inquiry Date',
          visibility: true,
          sortable: true,
        },
        {
          id: 'e.employee_name',
          column: 'employee_name',
          name: 'Operator',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.parent_name',
          column: 'parent_name',
          name: 'Parent Name',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.email1',
          column: 'email1',
          name: 'Email',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.phone1',
          column: 'phone1',
          name: 'Phone',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.child_name',
          column: 'child_name',
          name: 'Child Name',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.child_birth',
          column: 'child_birth',
          name: 'DOB',
          visibility: true,
          sortable: true,
          width: 150,
        },
        {
          id: 'cn.name_en',
          column: 'name_en',
          name: 'Nationality',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.joining_date',
          column: 'joining_date',
          name: 'Exp. Joining',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.joining_note',
          column: 'joining_note',
          name: 'Joining Notes',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.previous_nursery',
          column: 'previous_nursery',
          name: 'Previous School',
          visibility: true,
          sortable: true,
        },
        {
          id: 'v.visitby_name',
          column: 'visitby_name',
          name: 'Source',
          visibility: true,
          sortable: true,
        },
        {
          id: 'r.referral_name',
          column: 'referral_name',
          name: 'Referral',
          visibility: true,
          sortable: true,
        },
        {
          id: 'c.class_theme',
          column: 'class_theme',
          name: 'Class',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.reg_date',
          column: 'reg_date',
          name: 'Reg. Date',
          visibility: true,
          sortable: true,
        },
        {
          id: 'ne.noenrolment_name',
          column: 'noenrolment_name',
          name: 'No Enroll Reason',
          visibility: true,
          sortable: true,
        },
        {
          id: 'w.no_reg_reason',
          column: 'no_reg_reason',
          name: 'Reason Explanation',
          visibility: true,
          sortable: true,
        },
        {
          id: 'admissions.num_of_days',
          column: 'num_of_days',
          name: 'Number of Days',
          visibility: true,
          sortable: true,
        },
        {
          id: 'admission_extra_info.attending_times',
          column: 'attending_times',
          name: 'Attending Times',
          visibility: true,
          sortable: true,
        },
        {
          id: 'admissions.id_number',
          column: 'id_number',
          name: 'Child ID Number',
          visibility: true,
          sortable: true,
        },
      ],
      data: [],
    },
    bulkMailModal: {
      show: false,
    },
    notesModal: {
      show: false,
      id: 0,
      cdt: {
        fetching: false,
        search: '',
        rows: 5,
        offset: 0,
        order: 'wn.wn_id',
        dir: 'DESC',
        lastPage: 0,
        page: 0,
        totalRecords: 0,
        rowsOptions: [10, 25, 50, 'All'],
        columns: [
          {
            id: 'wn.wn_id',
            column: 'wn_id',
            name: 'Actions',
            visibility: true,
            sortable: true,
          },
          {
            id: 'wn.wn_note',
            column: 'wn_note',
            name: 'Note',
            visibility: true,
            sortable: true,
          },
          {
            id: 'wn.created_by_name',
            column: 'created_by_name',
            name: 'Created',
            visibility: true,
            sortable: true,
          },
          {
            id: 'wn.updated_by_name',
            column: 'updated_by_name',
            name: 'Updated',
            visibility: true,
            sortable: true,
          },
        ],
        data: [],
      },
      waitingObject: null
    },
    formUrlModal: {
      show: false,
      id: 0,
    },
    paymentUrlModal: {
      show: false,
      id: 0,
    },
    admissionFormModal: {
      show: false,
      id: 0,
      fetching: false,
      activeTab: 'tab_one',
      admissioncountries: [],
      siblings: [],
      qna: [],
      ...this.admissionFormFields,
      ...this.childChronicFields,
      ...this.childImmunizationFields,
      ...this.childIllnessFields,
      ...this.childAllergyFields,
      ...this.childConditionFields,
    },
    tasksModal: {
      show: false,
      fetching: false,
      data: [],
      id: 0,
      payload: null,
      waitingObject: null
    },
    filter: {
      show: false,
      showDateRange: false,
      showApprovedDateRange: false,
      ...this.filterFields,
    },
    importingData: false,
    admissionStatusAlert: false,
    admissionApproveAlert: false,
    lead: null,
    admission_id: null,
    movingProfile: null,
    waitingObject: null,
    deleteConfirm: this.deleteConfirm,
    activeLeadFormTab: 'lead_form_tab_one'
  };

  componentDidMount() {
    // Apply v3.1 styles
    document.body.classList.add('style-v3-1');
    const { search, rows: limit, order, dir } = this.state.cdt;
    let getUrlParamData = getUrlParam()
    if (getUrlParamData.filter) {
      this.getSetDDLs(this.filterAndFetch);
    } else {
      this.getSetDDLs();
      this.fetch({
        search,
        limit,
        order,
        dir,
        page: 0,
      });
    }
  }



  componentWillUnmount() {
    // Remove v3.1 styles
    document.body.classList.remove('style-v3-1');
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.authData.centerData.center_id !=
      this.props.authData.centerData.center_id
    ) {
      const { search, rows: limit, order, dir } = this.state.cdt;
      this.fetch({
        search,
        limit,
        order,
        dir,
        page: 0,
      });
      this.getSetDDLs();
    }
  }

  getSetDDLs = async (callback = () => { }) => {
    try {
      const response = await axios.all([
        GET('waiting/get-countries'),
        GET('waiting/get-sources'),
        GET('waiting/get-referrals'),
        GET('waiting/get-operators'),
        GET('waiting/get-classes'),
        GET('waiting/get-lead-status'),
        GET('waiting/get-center-email-templates'),
        GET('waiting/get-vaccine'),
        GET('waiting/get-languages'),
        GET('waiting/get-religions'),
        GET('waiting/get-no-enr-reasons'),
        GET('waiting/get-terms'),
        GET('waiting/get-allergy'),
        GET('waiting/get-illness'),
        GET('waiting/get-classmain'),
        GET('waiting/get-age-groups'),
        GET('waiting/get-centerlic'),
        GET('waiting/get-terms-default'),
      ]);

      // Countries
      const countries = response[0].data.map((item) => {
        return {
          value: item.country_id,
          label: item.name_en,
        };
      });
      const nationalities = response[0].data.map((item) => {
        return {
          ...item,
          value: item.name_en,
          label: item.name_en,
        };
      });

      // Visitbys
      const visitbys = response[1].data.map((item) => {
        return {
          value: item.visitby_id,
          label: item.visitby_name,
        };
      });

      // Referrals
      const referrals = response[2].data.map((item) => {
        return {
          value: item.referral_id,
          label: item.referral_name,
        };
      });

      // Operators
      const operators = response[3].data.map((item) => {
        return {
          value: item.employee_id,
          label: item.employee_name,
        };
      });

      // Classes
      const classes = response[4].data.map((item) => {
        return {
          value: item.class_id,
          label: item.class_theme,
        };
      });

      // Lead Status
      const leadStatusList = response[5].data.map((item) => {
        return {
          ...item,
          value: item.ls_id,
          label: item.ls_abbreviation,
        };
      });

      // Email Templates
      const emailTemplates = response[6].data.map((item) => {
        return {
          ...item,
          value: item.cet_id,
          label: item.cet_name,
        };
      });

      // Vaccines
      const vaccines = response[7].data.map((item) => {
        return {
          ...item,
          value: item.vaccine_id,
          label: item.vaccine_name,
        };
      });

      // Languages
      const languages = response[8].data.map((item) => {
        return {
          ...item,
          value: item.lang_id,
          label: item.lang_name,
        };
      });

      // Religions
      const religions = response[9].data.map((item) => {
        return {
          ...item,
          value: item.religion_id,
          label: item.religion_name,
        };
      });

      // No Enrollment Reasons
      const noEnrReasons = response[10].data.map((item) => {
        return {
          ...item,
          value: item.noenrolment_id,
          label: item.noenrolment_name,
        };
      });

      // Terms
      const terms = response[11].data.map((item) => {
        return {
          ...item,
          value: item.term_id,
          label: item.term_name,
        };
      });

      // Allergy
      const ddl_allergies = response[12].data.map((item) => {
        return {
          ...item,
          value: item.allergy_name,
          label: item.allergy_name,
        };
      });

      // Allergy
      const ddl_illnesses = response[13].data.map((item) => {
        return {
          ...item,
          value: item.illness_name,
          label: item.illness_name,
        };
      });

      // Classmain
      const ddl_classmain = response[14].data.map((item) => {
        return {
          ...item,
          value: item.classmain_id,
          label: item.classmain_name,
        };
      });
      // Agegroup
      const ddl_agegroup = response[15].data.map((item) => {
        return {
          ...item,
          value: item.agegroup_id,
          label: item.agegroup_code,
        };
      });
      // Centerlic
      const ddl_centerlic = response[16].data.map((item) => {
        return {
          ...item,
          value: item.centerlic_id,
          label: item.reg_year,
        };
      });
      // Terms Default
      const ddl_terms_default = response[17].data.map((item) => {
        return {
          ...item,
          value: item.term_d_id,
          label: item.term_d_name,
        };
      });



      this.setState({
        countries,
        nationalities,
        visitbys,
        referrals,
        operators,
        classes,
        leadStatusList,
        emailTemplates,
        vaccines,
        languages,
        religions,
        noEnrReasons,
        terms,
        ddl_allergies,
        ddl_illnesses,
        ddl_classmain,
        ddl_agegroup,
        ddl_centerlic,
        ddl_terms_default,
      }, () => callback());
    } catch (err) {
      console.log('err', err);
    }
  };

  filterAndFetch = () => {
    let getUrlParamData = getUrlParam()
    let filter = getUrlParamData.filter
    // console.log('filter', filter);
    const { search, rows: limit, order, dir } = this.state.cdt;
    let newFilter = {
      show: false,
      showDateRange: false,
      showApprovedDateRange: false,
      ...this.filterFields,
    }
    if (filter == 'totalLeads') {
      newFilter.filter_leadstatus = this.state.leadStatusList.filter((v) => v.admission_status_id == 1)
      newFilter.filter_admission = this.filterAdmission.find((v) => v.value == 0)
    } else if (filter == 'totalApplicants') {
      newFilter.filter_leadstatus = this.state.leadStatusList.filter((v) => ![7, 8, 12].includes(v.admission_status_id))
      newFilter.filter_admission = this.filterAdmission.find((v) => v.value == 1)
    }
    else if (filter == 'totalLeads7Days') {
      newFilter.filter_leadstatus = this.state.leadStatusList.filter((v) => v.admission_status_id == 1)
      newFilter.filter_date_range.startDate = moment().subtract(7, 'days').toDate()
      newFilter.filter_date_range.endDate = new Date()
      newFilter.filter_date_range_enable = true
    } else if (filter == 'totalRegistered') {
      newFilter.filter_leadstatus = this.state.leadStatusList.filter((v) => v.admission_status_id == 7 && v.admission_status_id != 12)
      newFilter.filter_admission = this.filterAdmission.find((v) => v.value == 1)
    } else if (filter == 'totalLost') {
      newFilter.filter_leadstatus = this.state.leadStatusList.filter((v) => v.admission_status_id == 12)
      newFilter.filter_status = this.filterStatus.find((v) => v.value == 'N')
    }
    newFilter.filter_enable = true
    // console.log('newFilter', newFilter);
    this.setState({
      filter: newFilter,
    }, () => {
      this.fetch({
        search,
        limit,
        order,
        dir,
        page: 0,
      })
    })
  }

  fetch = async (params) => {
    this.setState({
      cdt: {
        ...this.state.cdt,
        fetching: true,
      },
    });

    const {
      filter_date_range,
      filter_approved_date,
      filter_approved_date_enable,
      filter_date_range_enable,
      filter_age,
      filter_nationality,
      filter_source,
      filter_referral,
      filter_class,
      filter_status,
      filter_admission,
      filter_leadstatus,
      filter_joining_date,
      filter_enable
    } = this.state.filter;

    if (cancelToken) {
      cancelToken.abort();
    }
    cancelToken = new AbortController();

    let filterParams;

    if (filter_enable) {
      filterParams = {
        filter_age: filter_age?.value,
        filter_nationality: filter_nationality?.value,
        filter_source: filter_source?.value,
        filter_referral: filter_referral?.value,
        filter_class: filter_class?.value,
        filter_status: filter_status?.value,
        filter_admission: filter_admission?.value,
        filter_leadstatus: filter_leadstatus.map((v) => v.value),
        filter_joining_date: filter_joining_date ?? '',
      };

      if (filter_date_range_enable) {
        filterParams.filter_date_range =
          moment(filter_date_range.startDate).format('YYYY-MM-DD') +
          ' -- ' +
          moment(filter_date_range.endDate).format('YYYY-MM-DD');
      }

      if (filter_approved_date_enable) {
        filterParams.filter_approved_date =
          moment(filter_approved_date.startDate).format('YYYY-MM-DD') +
          ' -- ' +
          moment(filter_date_range.endDate).format('YYYY-MM-DD');
      }
    }

    let fData = new FormData()
    fData.append('filterParams', JSON.stringify(filterParams))
    try {
      const res = await POST('waiting/get', fData, {
        signal: cancelToken.signal,
        params: {
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
        },
      });

      if (res.status === 200) {
        this.setState({
          cdt: {
            ...this.state.cdt,
            fetching: false,
            search: params.search,
            rows: parseInt(params.limit),
            offset: parseInt(params.page) * parseInt(params.limit),
            order: params.order,
            dir: params.dir,
            page: params.page,
            totalRecords: parseInt(res.data.total_count_filtered),
            lastPage: Math.ceil(
              parseInt(res.data.total_count_filtered) / parseInt(params.limit)
            ),
            data: res.data.data.map((item) => {
              return {
                uid: chance.guid(),
                ...item,
              };
            }),
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        cdt: {
          ...this.state.cdt,
          fetching: false,
        },
      });
    }
  };

  handleOpenFormModal = () => {
    this.setState({
      showFormModal: true,
    });
  };

  handleCloseFormModal = () => {
    this.setState({
      showFormModal: false,
      isEditing: false,
      ...this.defaultFormFields,
    });
  };

  showHideColumn = (column_index) => {
    const columns = this.state.cdt.columns;
    columns[column_index].visibility = !columns[column_index].visibility;
    this.setState({ ctd: { ...this.state.ctd, columns } });
  };

  exportExcel = async () => {
    const excelData = this.state.cdt.data.map((item) => {
      const row = {};
      this.state.cdt.columns
        .filter((column) => column.visibility)
        .map((column) => {
          if (column.name !== 'Actions') {
            row[column.name] = item[column.column];
          }

          if (column.name == "Attending Times") {
            let attendingTimes = item[column.column];
            if (attendingTimes) {
              try {
                const parsed = JSON.parse(attendingTimes);
                if (Array.isArray(parsed) && parsed.length > 0 && parsed[0].time) {
                  row[column.name] = parsed.map((t) => t.time).join(', ');
                } else {
                  row[column.name] = '';
                }
              } catch {
                row[column.name] = '';
              }
            } else {
              row[column.name] = '';
            }
          }
        });
      return row;
    });

    const fileName =
      'Communication Source Export ' + moment().format('DD-MM-YYYY');
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const ws = XLSX.utils.json_to_sheet(excelData);

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });

    FileSaver.saveAs(data, fileName + fileExtension);
  };

  saveUpdate = async () => {
    const { authData } = this.props;
    const { center_id } = authData.centerData;

    this.setState({ working: true });

    const {
      isEditing,
      waiting_id,
      parent_name,
      primary_contact,
      phone1,
      email1,
      country_id,
      child_name,
      child_birth,
      birth_city,
      gender,
      waiting_date,
      visitby_id,
      referral_id,
      employee_id,
      class_id,
      joining_date,
      joining_note,
      notes,
      term_id,
      monday,
      tuesday,
      wednesday,
      thursday,
      friday,
      saturday,
      sunday,
      previous_nursery,
      reasontoleaveprev,
      commentonprev,
    } = this.state;

    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append(
      'waitingData',
      JSON.stringify({
        waiting_id,
        parent_name,
        primary_contact,
        phone1,
        email1,
        country_id: country_id?.value,
        child_name,
        child_birth,
        gender,
        waiting_date,
        visitby_id: visitby_id?.value,
        referral_id: referral_id?.value,
        employee_id: employee_id?.value,
        class_id: class_id?.value,
        term_id: term_id?.value,
        joining_date,
        joining_note,
        notes,
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        saturday,
        sunday,
        previous_nursery,
        reasontoleaveprev,
        commentonprev,
      })
    );

    try {
      let res;

      if (isEditing) {
        res = await POST('waiting/update', fData);
      } else {
        res = await POST('waiting/insert', fData);
      }

      if (res.data.type) {
        this.setState({ working: false });
        toast.success(t(res.data.message));
        this.fetch({
          search: this.state.cdt.search,
          limit: this.state.cdt.rows,
          order: this.state.cdt.order,
          dir: this.state.cdt.dir,
          page: this.state.cdt.page,
        });
        this.handleCloseFormModal();
      } else {
        if (res.data.messageType == 'custom_error') {
          toast.error(t(res.data.message));
        } else {
          handleFormErrors(res.data.data);
        }
        this.setState({ working: false });
      }
    } catch (err) {
      console.log('err', err);

      toast.error(t('Something went wrong!'));

      this.setState({ working: false });
    }
  };

  edit = (data) => {
    // console.table(data);

    this.setState({
      isEditing: true,
      waiting_id: data.waiting_id,
      parent_name: data.parent_name,
      primary_contact: data.primary_contact,
      phone1: data.phone1,
      email1: data.email1,
      country_id: { value: data.country_id, label: data.name_en },
      child_name: data.child_name,
      child_birth: data.child_birth,
      gender: data.gender,
      waiting_date: data.waiting_date,
      visitby_id: { value: data.visitby_id, label: data.visitby_name },
      referral_id: { value: data.referral_id, label: data.referral_name },
      employee_id: { value: data.employee_id, label: data.employee_name },
      class_id: { value: data.class_id, label: data.class_theme },
      term_id: { value: data.term_id, label: data.term_name },
      joining_date: data.joining_date,
      joining_note: data.joining_note,
      notes: data.notes,
      monday: data.monday,
      tuesday: data.tuesday,
      wednesday: data.wednesday,
      thursday: data.thursday,
      friday: data.friday,
      saturday: data.saturday,
      sunday: data.sunday,
      previous_nursery: data.previous_nursery,
      reasontoleaveprev: data.reasontoleaveprev,
      commentonprev: data.commentonprev,
    });
    this.handleOpenFormModal();
  };

  handleOpenNotesModal = (waitingObject) => {
    const { search, rows: limit, order, dir } = this.state.notesModal.cdt;

    this.setState(
      {
        notesModal: {
          ...this.state.notesModal,
          show: true,
          id: waitingObject.waiting_id,
          waitingObject
        },
      },
      () =>
        this.getNotes({
          search,
          limit,
          order,
          dir,
          page: 0,
          id: waitingObject.waiting_id,
        })
    );
  };

  handleCloseNotesModal = () => {
    this.setState({
      notesModal: {
        ...this.state.notesModal,
        show: false,
      },
      ...this.noteFields,
    });
  };

  saveNote = async () => {
    this.setState({ working: true });

    const { wn_id, wn_note } = this.state;

    const fData = new FormData();
    fData.append(
      'noteData',
      JSON.stringify({
        wn_id,
        wn_note,
        waiting_id: this.state.notesModal.id,
      })
    );

    try {
      const res = await POST('waiting/save-note', fData);

      if (res.data.type) {
        this.setState({
          working: false,
          ...this.noteFields,
        });
        toast.success(t(res.data.message));
        this.getNotes({
          search: '',
          limit: this.state.notesModal.cdt.rows,
          order: this.state.notesModal.cdt.order,
          dir: this.state.notesModal.cdt.dir,
          page: 0,
          id: this.state.notesModal.id,
        });
      } else {
        if (res.data.messageType == 'custom_error') {
          toast.error(t(res.data.message));
        } else {
          handleFormErrors(res.data.data);
        }
        this.setState({ working: false });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleOpenBulkMailModal = () => {
    this.setState({
      bulkMailModal: {
        show: true,
      },
    });
  };

  handleCloseBulkMailModal = () => {
    this.setState({
      bulkMailModal: {
        show: false,
      },
      ...this.bulkMailFields,
    });
  };

  getNotes = async (params) => {
    this.setState({
      notesModal: {
        ...this.state.notesModal,
        cdt: {
          ...this.state.notesModal.cdt,
          fetching: true,
        },
      },
    });

    if (cancelToken) {
      cancelToken.abort();
    }
    cancelToken = new AbortController();

    try {
      const res = await GET('waiting/get-notes', {
        signal: cancelToken.signal,
        params: {
          waiting_id: params.id,
          search: params.search,
          order: params.order,
          dir: params.dir,
          limit: params.limit,
          offset: parseInt(params.page) * parseInt(params.limit),
        },
      });
      if (res.status === 200) {
        this.setState({
          notesModal: {
            ...this.state.notesModal,
            cdt: {
              ...this.state.notesModal.cdt,
              fetching: false,
              search: params.search,
              rows: parseInt(params.limit),
              offset: parseInt(params.page) * parseInt(params.limit),
              order: params.order,
              dir: params.dir,
              page: params.page,
              totalRecords: parseInt(res.data.total_count_filtered),
              lastPage: Math.ceil(
                parseInt(res.data.total_count_filtered) / parseInt(params.limit)
              ),
              data: res.data.data.map((item) => {
                return {
                  uid: chance.guid(),
                  ...item,
                };
              }),
            },
          },
        });
      }
    } catch (err) {
      console.log('err', err);
      this.setState({
        notesModal: {
          ...this.state.notesModal,
          cdt: {
            ...this.state.notesModal.cdt,
            fetching: false,
          },
        },
      });
    }
  };

  editNote = (data) => {
    this.setState({
      wn_id: data.wn_id,
      wn_note: data.wn_note,
    });
  };

  deleteNote = async () => {
    try {
      const res = await GET('waiting/delete-note', {
        params: {
          wn_id: this.state.deleteConfirm.id,
        },
      });
      this.setState({
        notesModal: {
          ...this.state.notesModal,
          cdt: {
            ...this.state.notesModal.cdt,
            data: this.state.notesModal.cdt.data.filter(
              (item) => item.wn_id != this.state.deleteConfirm.id
            ),
          },
        },
        deleteConfirm: this.deleteConfirm
      });
      toast.success(t(res.data.message));
    } catch (err) {
      console.log(err);
      toast.error(t('Something went wrong!'));
    }
  };

  handleOpenFormUrlModal = (admission_id) => {
    this.setState(
      {
        formUrlModal: {
          show: true,
          id: admission_id,
        },
      },
      () => this.getFormUrlEmail(admission_id)
    );
  };

  handleCloseFormUrlModal = () => {
    this.setState({
      formUrlModal: {
        show: false,
        id: 0,
      },
      ...this.formUrlFields,
    });
  };

  getFormUrlEmail = async (admission_id) => {
    try {
      const res = await axios.all([
        GET('waiting/get-admission-setup'),
        GET('waiting/get-admission-form', {
          params: {
            admission_id,
          },
        }),
      ]);


      let ad_text1 = res[0].data.ad_text1;
      if (ad_text1) {
        ad_text1 = ad_text1.replace(
          '^^parent_name^^',
          res[1].data.data.parent_name
        );
        ad_text1 = ad_text1.replace(
          '^^student_name^^',
          res[1].data.data.child_name
        );
        ad_text1 = ad_text1.replace(
          '^^form_url^^',
          res[1].data.data.share_registration_form_url
        );
        ad_text1 = ad_text1.replace(
          '^^form_url_kyc^^',
          res[1].data.data.share_registration_form_url_kyc
        );
      }

      this.setState({
        admission_parent_email: res[1].data.data.parent_email,
        email_template: ad_text1 ? ad_text1 : '',
      });
    } catch (err) {
      console.log(err);
    }
  };

  sendFormUrlEmail = async () => {
    this.setState({ working: true });

    const admission_id = this.state.formUrlModal.id;

    const fData = new FormData();
    fData.append('admission_id', admission_id);
    fData.append('body', this.state.email_template);
    fData.append('subject', this.state.admission_email_subject);
    fData.append('parent_email', this.state.admission_parent_email);

    try {
      const res = await POST('waiting/send-admission-email', fData);
      console.log(res);
      this.setState({ working: false });
      this.handleCloseFormUrlModal();
    } catch (err) {
      console.log(err);
      this.setState({ working: false });
    }
  };

  handleOpenPaymentUrlModal = (admission_id) => {
    this.setState(
      {
        paymentUrlModal: {
          show: true,
          id: admission_id,
        },
      },
      () => this.getPaymentUrlEmail(admission_id)
    );
  };

  handleClosePaymentUrlModal = () => {
    this.setState({
      paymentUrlModal: {
        show: false,
        id: 0,
      },
      ...this.formUrlFields,
    });
  };

  getPaymentUrlEmail = async (admission_id) => {
    try {
      const res = await axios.all([
        GET('waiting/get-admission-setup'),
        GET('waiting/get-admission-form', {
          params: {
            admission_id,
          },
        }),
      ]);

      let ad_text2 = res[0].data.ad_text2;
      ad_text2 = ad_text2.replace(
        '^^parent_name^^',
        res[1].data.data.parent_name
      );
      ad_text2 = ad_text2.replace(
        '^^student_name^^',
        res[1].data.data.child_name
      );
      // ad_text2 = ad_text2.replace(
      //   "^^form_url^^",
      //   res[1].data.data.share_registration_form_url
      // );

      this.setState({
        admission_parent_email: res[1].data.data.parent_email,
        email_template: ad_text2,
      });
    } catch (err) {
      console.log(err);
    }
  };

  sendPaymentUrlEmail = async () => {
    this.setState({ working: true });

    const admission_id = this.state.formUrlModal.id;

    let body = this.state.email_template;
    body = body.replace('^^payment_url^^', this.state.admission_payment_url);

    const fData = new FormData();
    fData.append('admission_id', admission_id);
    fData.append('body', body);
    fData.append('subject', this.state.admission_email_subject);
    fData.append('parent_email', this.state.admission_parent_email);

    try {
      const res = await POST('waiting/send-admission-email', fData);
      console.log(res);
      this.setState({ working: false });
      this.handleClosePaymentUrlModal();
    } catch (err) {
      console.log(err);
      this.setState({ working: false });
    }
  };

  handleOpenAdmissionFormModal = async (admission_id) => {

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    this.setState({
      admissionFormModal: {
        ...this.state.admissionFormModal,
        activeTab: 'tab_one',
        show: true,
        fetching: true,
        id: admission_id,
      },
    });

    try {
      const fData = new FormData();
      fData.append('admission_id', admission_id);

      const res = await POST('waiting/get-admission-data', fData);

      let gender = {
        value: res.data.admission.gender,
        label: res.data.admission.gender == 'M' ? 'Male' : 'Female',
      };
      let child_diet_milktype = {
        value: res.data.admission_extra_info.child_diet_milktype,
        label: res.data.admission_extra_info.child_diet_milktype,
      }

      let country_id = {
        value: res.data.admission.country_id,
        label: this.state.countries.find(
          (item) => item.value == res.data.admission.country_id
        )?.label,
      };

      let country_id2 = {
        value: res.data.admission.country_id2,
        label: this.state.countries.find(
          (item) => item.value == res.data.admission.country_id2
        )?.label,
      };

      // console.log('res.data.admission.father_nationality', isInt(res.data.admission.father_nationality));

      let father_nationality = {
        value: res.data.admission.father_nationality,
        label: res.data.admission.father_nationality,
      };
      if (isInt(res.data.admission.father_nationality)) {
        let find_father_nationality = this.state.nationalities.find((item) => item.country_id == res.data.admission.father_nationality)
        if (find_father_nationality) {
          father_nationality = {
            value: find_father_nationality.value,
            label: find_father_nationality.label,
          };
        }
      }

      let mother_nationality = {
        value: res.data.admission.mother_nationality,
        label: res.data.admission.mother_nationality,
      };
      if (isInt(res.data.admission.mother_nationality)) {
        let find_mother_nationality = this.state.nationalities.find((item) => item.country_id == res.data.admission.mother_nationality)
        if (find_mother_nationality) {
          mother_nationality = {
            value: find_mother_nationality.value,
            label: find_mother_nationality.label,
          };
        }
      }

      let religion = {
        value: res.data.admission_extra_info.religion,
        label: this.state.religions.find(
          (item) => item.value == res.data.admission_extra_info.religion
        )?.label,
      };

      let first_lang = {
        value: this.state.languages.find(
          (item) => item.label == res.data.admission.first_lang
        )?.value,
        label: res.data.admission?.first_lang,
      };

      let second_lang = {
        value: this.state.languages.find(
          (item) => item.label == res.data.admission.second_lang
        )?.value,
        label: res.data.admission?.second_lang,
      };

      let third_lang = {
        value: this.state.languages.find(
          (item) => item.label == res.data.admission.third_lang
        )?.value,
        label: res.data.admission?.third_lang,
      };

      let term_id = {
        value: res.data.admission.term_id,
        label: this.state.terms.find(
          (item) => item.value == res.data.admission.term_id
        )?.label,
      };
      let centerlic_id = {
        value: res.data.admission.centerlic_id,
        label: this.state.ddl_centerlic.find(
          (item) => item.value == res.data.admission.centerlic_id
        )?.label,
      };
      let term_d_id = {
        value: res.data.admission.term_d_id,
        label: this.state.ddl_terms_default.find(
          (item) => item.value == res.data.admission.term_d_id
        )?.label,
      };
      let agegroup_id = {
        value: res.data.admission.agegroup_id,
        label: this.state.ddl_agegroup.find(
          (item) => item.value == res.data.admission.agegroup_id
        )?.label,
      };
      let classmain_id = {
        value: res.data.admission.classmain_id,
        label: this.state.ddl_classmain.find(
          (item) => item.value == res.data.admission.classmain_id
        )?.label,
      };

      let home_language = {
        value: this.state.languages.find(
          (item) => item.label == res.data.admission.home_language
        )?.value,
        label: res.data.admission?.home_language,
      };

      let father_language = {
        value: this.state.languages.find(
          (item) => item.label == res.data.admission.father_language
        )?.value,
        label: res.data.admission?.father_language,
      };

      let mother_language = {
        value: this.state.languages.find(
          (item) => item.label == res.data.admission.mother_language
        )?.value,
        label: res.data.admission?.mother_language,
      };

      let sponsor_role = {
        value: res.data.admission_extra_info.sponsor_role,
        label: res.data.admission_extra_info.sponsor_role,
      };

      let spouse_role = {
        value: res.data.admission_extra_info.spouse_role,
        label: res.data.admission_extra_info.spouse_role,
      };

      let child_position_family = {
        value: res.data.admission_extra_info.child_position_family,
        label: res.data.admission_extra_info.child_position_family,
      };

      let child_prev_settings = {
        value: res.data.admission_extra_info.child_prev_settings,
        label: res.data.admission_extra_info.child_prev_settings,
      };

      let child_use_cutlery = {
        value: res.data.admission_extra_info.child_use_cutlery,
        label: res.data.admission_extra_info.child_use_cutlery,
      };

      let child_toilet = res.data.admission_extra_info
        ? JSON.parse(res.data.admission_extra_info.child_use_toilet)
        : '';

      let attending_times = res.data.admission_extra_info.attending_times;
      if (attending_times) {
        attending_times = JSON.parse(
          res.data.admission_extra_info.attending_times
        );
        if (Array.isArray(attending_times) && attending_times.length > 0) {
          attending_times = attending_times[0]['time'];
        }
        // if (Array.isArray(attending_times)) {
        //   attending_times = JSON.parse(res.data.admission_extra_info.attending_times)[0]['time']
        // } else {
        //   attending_times = attending_times.toLowerCase()
        // }
      }

      let livingstatus_type = {
        value: res.data.admission?.livingstatus_type,
        label: this.livingStatus.find(
          (item) => item.value == res.data.admission.livingstatus_type
        )?.label,
      };

      let reading_prof = {
        value: res.data.admission?.reading_prof,
        label: this.readingProf.find(
          (item) => item.value == res.data.admission.reading_prof
        )?.label,
      };

      let writing_prof = {
        value: res.data.admission?.writing_prof,
        label: this.writingProf.find(
          (item) => item.value == res.data.admission.writing_prof
        )?.label,
      };

      let speaking_prof = {
        value: res.data.admission?.speaking_prof,
        label: this.speakingProf.find(
          (item) => item.value == res.data.admission.speaking_prof
        )?.label,
      };

      let childChronics = [];
      let childImmunizations = [];
      let childIllnesses = [];
      let childAllergies = [];
      let childConditions = [];
      res.data.children_health.map((v, i) => {
        const uuid = chance.guid();
        if (v.child_health_type == 'Illness') {
          childIllnesses.push({
            uuid: uuid,
            child_health_id: v.child_health_id,
            illness: v.child_health_name,
            date: v.child_health_date,
            desc: v.child_health_desc,
          })
        } else if (v.child_health_type == 'Allergy') {
          childAllergies.push({
            uuid: uuid,
            child_health_id: v.child_health_id,
            allergy: v.child_health_name,
            date: v.child_health_date,
            desc: v.child_health_desc,
          })
        } else if (v.child_health_type == 'Condition') {
          childConditions.push({
            uuid: uuid,
            child_health_id: v.child_health_id,
            condition: v.child_health_name,
            date: v.child_health_date,
            desc: v.child_health_desc,
          })
        } else if (v.child_health_type == 'Vaccination') {
          childImmunizations.push({
            vaccine_uuid: uuid,
            child_health_id: v.child_health_id,
            vaccine_name: v.child_health_name,
            dose_date: v.child_health_date,
            dose_number: v.child_health_desc,
            vaccination_dose_file_old: v.child_health_attachment
          })
        } else if (v.child_health_type == 'Chronic Illness') {
          childChronics.push({
            uuid: uuid,
            child_health_id: v.child_health_id,
            illness: v.child_health_name,
            date: v.child_health_date,
            desc: v.child_health_desc,
          })
        }
      })
      if (res.data.admission.birth_date) {
        res.data.admission.birth_date = moment(res.data.admission.birth_date).format('YYYY-MM-DD')
      }
      if (res.data.admission.birth_date2) {
        res.data.admission.birth_date2 = moment(res.data.admission.birth_date2).format('iYYYY-iMM-iDD')
      }
      let admissioncountries = res.data.admissioncountries;
      let siblings = res.data.siblings;
      let qna = res.data.qna;

      this.setState({
        admissionFormModal: {
          ...this.state.admissionFormModal,
          ...res.data.admission,
          ...res.data.admission_extra_info,
          joining_date: moment(res.data.admission_extra_info.joining_date).format('YYYY-MM-DD'),
          gender,
          child_diet_milktype,
          country_id,
          country_id2,
          father_nationality,
          mother_nationality,
          religion,
          sponsor_role,
          term_id,
          centerlic_id,
          term_d_id,
          agegroup_id,
          classmain_id,
          spouse_role,
          picture_prev: res.data.admission.picture
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.picture
            : '',
          child_eid_page_prev: res.data.admission.child_eid_page
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.child_eid_page
            : '',
          child_eid_page_back_prev: res.data.admission_extra_info
            .child_eid_page_back
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.child_eid_page_back
            : '',
          child_residency_copy_prev: res.data.admission.child_residency_copy
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.child_residency_copy
            : '',
          prev_school_rep_doc_prev: res.data.admission.prev_school_rep_doc
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.prev_school_rep_doc
            : '',
          child_passport_prev: res.data.admission.child_passport
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.child_passport
            : '',
          visa_page_prev: res.data.admission.visa_page
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.visa_page
            : '',
          birth_certcopy_prev: res.data.admission.birth_certcopy
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.birth_certcopy
            : '',
          vaccination_copy_prev: res.data.admission.vaccination_copy
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.vaccination_copy
            : '',
          med_formcopy_prev: res.data.admission.med_formcopy
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.med_formcopy
            : '',
          father_id_attachment_prev: res.data.admission_extra_info
            .father_id_attachment
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.father_id_attachment
            : '',
          father_id_attachment_back_prev: res.data.admission_extra_info
            .father_id_attachment_back
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.father_id_attachment_back
            : '',
          father_passport_attachment_prev: res.data.admission_extra_info
            .father_passport_attachment
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.father_passport_attachment
            : '',
          father_visa_attachment_prev: res.data.admission_extra_info
            .father_visa_attachment
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.father_visa_attachment
            : '',
          mother_id_attachment_prev: res.data.admission_extra_info
            .mother_id_attachment
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.mother_id_attachment
            : '',
          mother_id_attachment_back_prev: res.data.admission_extra_info
            .mother_id_attachment_back
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.mother_id_attachment_back
            : '',
          mother_passport_attachment_prev: res.data.admission_extra_info
            .mother_passport_attachment
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.mother_passport_attachment
            : '',
          mother_visa_attachment_prev: res.data.admission_extra_info
            .mother_visa_attachment
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.mother_visa_attachment
            : '',
          indemnity_formcopy_prev: res.data.admission.indemnity_formcopy
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.indemnity_formcopy
            : '',
          child_lastyear_report_prev: res.data.admission_extra_info.child_lastyear_report
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.child_lastyear_report
            : '',
          child_transfer_doc_prev: res.data.admission_extra_info.child_transfer_doc
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.child_transfer_doc
            : '',
          sponsor_noc_prev: res.data.admission.sponsor_noc
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.sponsor_noc
            : '',
          document1_prev: res.data.admission.document1
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.document1
            : '',
          document2_prev: res.data.admission.document2
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.document2
            : '',
          document3_prev: res.data.admission.document3
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.document3
            : '',
          document4_prev: res.data.admission.document4
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.document4
            : '',
          document5_prev: res.data.admission.document5
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.document5
            : '',
          family_card_doc_prev: res.data.admission.family_card_doc
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission.family_card_doc
            : '',
          signature_prev: res.data.admission_extra_info.signature
            ? regionalStorageURL + this.props.authData.centerData.center_uuid +
            '/admissions_school/' +
            res.data.admission_extra_info.signature
            : '',
          fetching: false,
          child_position_family,
          child_prev_settings,
          first_lang,
          second_lang,
          third_lang,
          home_language,
          father_language,
          mother_language,
          attending_days: (res.data.admission_extra_info && res.data.admission_extra_info.attending_days) ? JSON.parse(res.data.admission_extra_info.attending_days) : [],
          child_use_toilet_0: child_toilet
            ? { value: child_toilet[0], label: child_toilet[0] }
            : '',
          child_use_toilet_1: child_toilet
            ? { value: child_toilet[1], label: child_toilet[1] }
            : '',
          child_use_toilet_2: child_toilet
            ? { value: child_toilet[2], label: child_toilet[2] }
            : '',
          child_use_cutlery,
          attending_times: attending_times,
          num_of_days: res.data.admission.num_of_days,
          food_tasting: res.data.admission_extra_info.food_tasting,
          childIllnesses,
          childAllergies,
          childConditions,
          childImmunizations,
          childChronics,
          livingstatus_type,
          reading_prof,
          writing_prof,
          speaking_prof,
          admissioncountries,
          siblings,
          qna
        },
      });
    } catch (err) {
      console.log(err);
    }

    // this.setState({
    //   admissionFormModal: {
    //     ...this.state.admissionFormModal,
    //     show: true,
    //     id: admission_id,
    //   },
    // });
  };

  handleCloseAdmissionFormModal = () => {
    this.setState({
      admissionFormModal: {
        ...this.state.admissionFormModal,
        show: false,
        id: 0,
        ...this.admissionFormFields,
        childChronics: [],
        childImmunizations: [],
        childIllnesses: [],
        childAllergies: [],
        childConditions: [],
      },
    });
  };

  switchTab = async (e) => {
    // leadObject.waitingtasks.find((v) => [6, 7, 8].includes(v.admission_status_id))
    // if ($Admissions -> admission_status == 6 || $Admissions -> admission_status == 7) {
    //   $returnData = array('type' => false, 'messageType' => 'info', 'messageTitle' => 'Info!', 'message' => 'Application already approved', 'data' => null, 'rawData' => null);
    //   return json_encode($returnData);
    //   Yii:: $app -> end();
    // } elseif($Admissions -> admission_status == 8) {
    //   $returnData = array('type' => false, 'messageType' => 'info', 'messageTitle' => 'Info!', 'message' => 'Application already rejected', 'data' => null, 'rawData' => null);
    //   return json_encode($returnData);
    //   Yii:: $app -> end();
    // }


    const {
      picture,
      child_name,
      child_first_name,
      child_middle_name,
      child_last_name,
      passport_number,
      passport_validity,
      residency_number,
      residency_validity,
      arabic_name,
      child_family_name,
      child_family_name_2,
      birth_date,
      birth_date2,
      birth_city,
      gender,
      country_id,
      country_id2,
      father_nationality,
      mother_nationality,
      religion,
      id_number,
      sponsor_role,
      father_name,
      father_name_2,
      father_id_number,
      father_income,
      mother_income,
      grandfather_name,
      father_passport_num,
      father_passport_validity,
      father_residency_number,
      father_residency_validity,
      mother_passport_num,
      mother_passport_validity,
      mother_residency_number,
      mother_residency_validity,
      father_education,
      mother_education,
      father_mobile,
      father_workphone,
      father_email,
      father_employer,
      father_position,
      home_address,
      home_city,
      home_street,
      home_phone,
      home_pobox,
      livingstatus_type,
      livingstatus_desc,
      child_school_leaving_reason,
      full_term_delivery,
      spouse_role,
      mother_name,
      mother_mobile,
      mother_workphone,
      mother_email,
      mother_employer,
      mother_position,
      child_siblings,
      child_siblings_age,
      child_school_attending,
      emergency_contact1,
      emergency_relation1,
      emergency_phone1,
      emergency_contact2,
      emergency_relation2,
      emergency_phone2,
      emergency_contact3,
      emergency_relation3,
      emergency_phone3,
      sponsor_name,
      sponsor_desc,
      sponsor_phone1,
      sponsor_phone2,
      sponsor_email,
      nanny_name,
      nanny_phone,
      driver_name,
      driver_phone,
      current_curr,
      attending_times,
      child_eid_page,
      child_eid_page_back,
      child_residency_copy,
      prev_school_rep_doc,
      child_passport,
      visa_page,
      birth_certcopy,
      vaccination_copy,
      med_formcopy,
      father_id_attachment,
      father_id_attachment_back,
      father_passport_attachment,
      father_visa_attachment,
      mother_id_attachment,
      mother_id_attachment_back,
      mother_passport_attachment,
      mother_visa_attachment,
      indemnity_formcopy,
      child_lastyear_report,
      child_transfer_doc,
      sponsor_noc,
      document1,
      document2,
      document3,
      document4,
      document5,
      family_card_doc,
      child_position_family,
      child_prev_settings,
      child_prev_settings_details,
      first_lang,
      second_lang,
      third_lang,
      home_language,
      father_language,
      mother_language,
      child_religion_food_clothing_desc,
      child_diet_milktype,
      child_diet_milktype_preparation,
      child_diet_milktype_qty,
      child_diet_milktype_freq,
      child_weaningfood,
      child_weaningfood_volume,
      child_weaningfood_freq,
      child_weaningfood_snack,
      child_weaningfood_maincourse,
      child_weaningfood_puddings,
      child_sleep_time,
      child_sleep_mins,
      child_sleep_comforters,
      child_use_toilet,
      child_use_toilet_0,
      child_use_toilet_1,
      child_use_toilet_2,
      child_use_drinkcup,
      child_use_cutlery,
      child_relate_children,
      child_relate_familiar_adults,
      child_take_turns,
      notes,
      child_toys,
      child_activities,
      child_distress,
      child_extra_info,
      emergency_treatment,
      pic_nursery,
      pic_media,
      pic_social,
      take_pictures,
      allow_pic,
      staff_child,
      check_acknowledgement,
      child_sen,
      admin_medication_1,
      admin_medication_2,
      medical_examination,
      health_condition,
      medicines,
      medical_note,
      special_disabilities,
      health_insurance_num,
      health_insurance_company,
      health_insurance_type,
      medical_emergency_fileno,
      child_evaluated_by,
      bloodgroup,
      child_weight,
      child_height,
      allergies,
      previous_enroll,
      transport_required,
      transport,
      radio_covid_diagnosed_family,
      covid_diagnosed_family,
      covid_close_contact,
      covid_symptoms,
      radio_covid_international_travel,
      covid_international_travel,
      medical_emergency_name,
      medical_emergency_doc,
      medical_emergency_clinic,
      medical_emergency_phone,
      radio_leela_allergies,
      leela_allergies,
      radio_leela_dietry_intolerances,
      leela_dietry_intolerances,
      radio_leela_special_req,
      leela_special_req,
      allergies: allergies_text,
      allergic_reactions,
      childChronics,
      childImmunizations,
      childIllnesses,
      childAllergies,
      childConditions,
      attending_days,
      signature,
      joining_date,
      num_of_days,
      food_tasting,
      reading_prof,
      writing_prof,
      speaking_prof,
      term_id,
      centerlic_id,
      term_d_id,
      agegroup_id,
      classmain_id,
    } = this.state.admissionFormModal;

    try {
      const fData = new FormData();
      fData.append('admission_id', this.state.admissionFormModal.id);

      let validateAllPrevious = true;
      // if (e.target.dataset.tabName != 'tab_one') {
      //   validateAllPrevious = true;
      // }

      fData.append('validateAllPrevious', validateAllPrevious);
      fData.append('tabName', e.target.dataset.tabName);
      fData.append(
        'Admissions',
        JSON.stringify({
          child_name,
          child_first_name,
          child_middle_name,
          child_last_name,
          passport_number,
          passport_validity,
          residency_number,
          residency_validity,
          arabic_name,
          staff_child,
          check_acknowledgement,
          child_sen,
          health_condition,
          medicines,
          medical_note,
          bloodgroup,
          allergies: allergies_text,
          previous_enroll,
          transport_required,
          transport,
          birth_date,
          birth_date2,
          birth_city,
          gender: gender ? gender.value : 'M',
          country_id: country_id ? country_id.value : '',
          country_id2: country_id2 ? country_id2.value : '',
          father_nationality: father_nationality ? father_nationality.value : '',
          mother_nationality: mother_nationality ? mother_nationality.value : '',
          term_id: term_id ? term_id.value : '',
          centerlic_id: centerlic_id ? centerlic_id.value : '',
          term_d_id: term_d_id ? term_d_id.value : '',
          agegroup_id: agegroup_id ? agegroup_id.value : '',
          classmain_id: classmain_id ? classmain_id.value : '',
          id_number,
          father_name,
          father_name_2,
          father_id_number,
          grandfather_name,
          father_education,
          mother_education,
          father_mobile,
          father_workphone,
          father_email,
          father_employer,
          father_position,
          home_address,
          home_city,
          home_street,
          home_phone,
          home_pobox,
          livingstatus_type: livingstatus_type ? livingstatus_type.value : '',
          livingstatus_desc,
          mother_name,
          mother_mobile,
          mother_workphone,
          mother_email,
          mother_employer,
          mother_position,
          emergency_contact1,
          emergency_relation1,
          emergency_phone1,
          emergency_contact2,
          emergency_relation2,
          emergency_phone2,
          emergency_contact3,
          emergency_relation3,
          emergency_phone3,
          sponsor_name,
          sponsor_desc,
          sponsor_phone1,
          sponsor_phone2,
          sponsor_email,
          nanny_name,
          nanny_phone,
          driver_name,
          driver_phone,
          current_curr,
          first_lang: first_lang ? first_lang.label : '',
          second_lang: second_lang ? second_lang.label : '',
          third_lang: third_lang ? third_lang.label : '',
          home_language: home_language ? home_language.label : '',
          father_language: father_language ? father_language.label : '',
          mother_language: mother_language ? mother_language.label : '',
          notes,
          allergies,
          num_of_days,
          reading_prof: reading_prof ? reading_prof.value : '',
          writing_prof: writing_prof ? writing_prof.value : '',
          speaking_prof: speaking_prof ? speaking_prof.value : '',
        })
      );
      fData.append(
        'AdmissionExtraInfo',
        JSON.stringify({
          religion: religion ? religion.value : '',
          sponsor_role: sponsor_role ? sponsor_role.value : '',
          spouse_role: spouse_role ? spouse_role.value : '',
          child_siblings,
          child_siblings_age,
          child_school_attending,
          attending_times: attending_times
            ? JSON.stringify([{ time: attending_times }])
            : null,
          child_position_family: child_position_family
            ? child_position_family.value
            : '',
          child_prev_settings: child_prev_settings
            ? child_prev_settings.value
            : '',
          child_prev_settings_details,
          child_religion_food_clothing_desc,
          child_diet_milktype: child_diet_milktype
            ? child_diet_milktype.value
            : '',
          child_diet_milktype_preparation,
          child_diet_milktype_qty,
          child_diet_milktype_freq,
          child_weaningfood,
          child_weaningfood_volume,
          child_weaningfood_freq,
          child_weaningfood_snack,
          child_weaningfood_maincourse,
          child_weaningfood_puddings,
          child_sleep_time,
          child_sleep_mins,
          child_sleep_comforters,
          child_use_toilet: [
            child_use_toilet_0 ? child_use_toilet_0.value : null,
            child_use_toilet_1 ? child_use_toilet_1.value : null,
            child_use_toilet_2 ? child_use_toilet_2.value : null,
          ],
          child_use_drinkcup,
          child_use_cutlery: child_use_cutlery.value,
          child_relate_children,
          child_relate_familiar_adults,
          child_take_turns,
          child_toys,
          child_activities,
          child_distress,
          child_extra_info,
          emergency_treatment,
          pic_nursery,
          pic_media,
          pic_social,
          take_pictures,
          allow_pic,
          covid_diagnosed_family,
          covid_close_contact,
          covid_symptoms,
          radio_covid_international_travel,
          covid_international_travel,
          medical_emergency_name,
          medical_emergency_doc,
          medical_emergency_clinic,
          medical_emergency_phone,
          radio_leela_allergies,
          leela_allergies,
          radio_leela_dietry_intolerances,
          leela_dietry_intolerances,
          radio_leela_special_req,
          leela_special_req,
          allergic_reactions,
          attending_days,
          joining_date,
          food_tasting,
          father_income,
          mother_income,
          father_passport_num,
          father_passport_validity,
          father_residency_number,
          father_residency_validity,
          mother_passport_num,
          mother_passport_validity,
          mother_residency_number,
          mother_residency_validity,
          child_weight,
          child_height,
          health_insurance_num,
          health_insurance_company,
          health_insurance_type,
          medical_emergency_fileno,
          child_evaluated_by,
          child_family_name,
          child_family_name_2,
          child_school_leaving_reason,
          full_term_delivery,
          special_disabilities,
          admin_medication_1,
          admin_medication_2,
          medical_examination
        })
      );
      fData.append('picture', picture);
      fData.append('child_eid_page', child_eid_page);
      fData.append('child_eid_page_back', child_eid_page_back);
      fData.append('child_residency_copy', child_residency_copy);
      fData.append('prev_school_rep_doc', prev_school_rep_doc);
      fData.append('child_passport', child_passport);
      fData.append('visa_page', visa_page);
      fData.append('birth_certcopy', birth_certcopy);
      fData.append('vaccination_copy', vaccination_copy);
      fData.append('med_formcopy', med_formcopy);
      fData.append('father_id_attachment', father_id_attachment);
      fData.append('father_id_attachment_back', father_id_attachment_back);
      fData.append('father_passport_attachment', father_passport_attachment);
      fData.append('father_visa_attachment', father_visa_attachment);
      fData.append('mother_id_attachment', mother_id_attachment);
      fData.append('mother_id_attachment_back', mother_id_attachment_back);
      fData.append('mother_passport_attachment', mother_passport_attachment);
      fData.append('mother_visa_attachment', mother_visa_attachment);
      fData.append('indemnity_formcopy', indemnity_formcopy);
      fData.append('child_lastyear_report', child_lastyear_report);
      fData.append('child_transfer_doc', child_transfer_doc);
      fData.append('sponsor_noc', sponsor_noc);
      fData.append('document1', document1);
      fData.append('document2', document2);
      fData.append('document3', document3);
      fData.append('document4', document4);
      fData.append('document5', document5);
      fData.append('family_card_doc', family_card_doc);
      fData.append('signature', signature);

      childIllnesses.map((v, i) => {
        fData.append('child_illness[uuid][]', v.uuid);
        fData.append('child_illness[child_health_id][' + v.uuid + ']', v.child_health_id);
        fData.append('child_illness[illness][' + v.uuid + ']', v.illness);
        fData.append('child_illness[date][' + v.uuid + ']', v.date);
        fData.append('child_illness[desc][' + v.uuid + ']', v.desc);
      })
      childImmunizations.map((v, i) => {
        fData.append('Vaccination[vaccine_uuid][]', v.vaccine_uuid);
        fData.append('Vaccination[child_health_id][' + v.vaccine_uuid + ']', v.child_health_id);
        fData.append('Vaccination[vaccine_name][' + v.vaccine_uuid + ']', v.vaccine_name);
        fData.append('Vaccination[dose_date][' + v.vaccine_uuid + ']', v.dose_date);
        fData.append('Vaccination[dose_number][' + v.vaccine_uuid + ']', v.dose_number);
      })
      childAllergies.map((v, i) => {
        fData.append('child_allergies[uuid][]', v.uuid);
        fData.append('child_allergies[child_health_id][' + v.uuid + ']', v.child_health_id);
        fData.append('child_allergies[allergy][' + v.uuid + ']', v.allergy);
        fData.append('child_allergies[date][' + v.uuid + ']', v.date);
        fData.append('child_allergies[desc][' + v.uuid + ']', v.desc);
      })
      childChronics.map((v, i) => {
        fData.append('child_chronic_diseases[uuid][]', v.uuid);
        fData.append('child_chronic_diseases[child_health_id][' + v.uuid + ']', v.child_health_id);
        fData.append('child_chronic_diseases[illness][' + v.uuid + ']', v.illness);
        fData.append('child_chronic_diseases[date][' + v.uuid + ']', v.date);
        fData.append('child_chronic_diseases[desc][' + v.uuid + ']', v.desc);
      })
      childConditions.map((v, i) => {
        fData.append('child_conditions[uuid][]', v.uuid);
        fData.append('child_conditions[child_health_id][' + v.uuid + ']', v.child_health_id);
        fData.append('child_conditions[condition][' + v.uuid + ']', v.condition);
        fData.append('child_conditions[date][' + v.uuid + ']', v.date);
        fData.append('child_conditions[desc][' + v.uuid + ']', v.desc);
      })

      const res = await POST('waiting/save-admission-parent', fData);

      if (res.data.type) {
        toast.success(t(res.data.message));

        if (e.target.dataset.tabName !== 'tab_finish') {
          this.setState({
            admissionFormModal: {
              ...this.state.admissionFormModal,
              activeTab: e.target.dataset.tabName,
            },
          });
        }

        this.fetch({
          search: this.state.cdt.search,
          limit: this.state.cdt.rows,
          order: this.state.cdt.order,
          dir: this.state.cdt.dir,
          page: this.state.cdt.page,
        });

      } else {
        if (res.data.messageType == 'custom_error') {
          toast.error(t(res.data.message));
        } else if (res.data.message == 'Application already approved') {
          toast.info(t(res.data.message));
        } else {
          handleFormErrors(res.data.data);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  addChronic = () => {
    const { childChronics, childChronic, childChronicDesc, childChronicDate } =
      this.state.admissionFormModal;

    const uuid = chance.guid();

    childChronics.push({
      uuid,
      child_health_id: 0,
      illness: childChronic.value,
      desc: childChronicDesc,
      date: childChronicDate,
    });
    this.setState({
      admissionFormModal: {
        ...this.state.admissionFormModal,
        ...this.childChronicFields,
        childChronics,
      },
    });

  };

  addImmunization = () => {
    const {
      childImmunizations,
      childImmuneVaccine,
      childImmuneDose,
      childImmuneDate,
    } = this.state.admissionFormModal;

    const uuid = chance.guid();

    childImmunizations.push({
      vaccine_uuid: uuid,
      child_health_id: 0,
      vaccine_name: childImmuneVaccine.label,
      dose_number: childImmuneDose.value,
      dose_date: childImmuneDate,
    });
    this.setState({
      admissionFormModal: {
        ...this.state.admissionFormModal,
        ...this.childImmunizationFields,
        childImmunizations,
      },
    });
  };

  addIllness = () => {
    const { childIllnesses, childIllness, childIllnessDesc, childIllnessDate } =
      this.state.admissionFormModal;

    const uuid = chance.guid();

    childIllnesses.push({
      uuid,
      child_health_id: 0,
      illness: childIllness.value,
      desc: childIllnessDesc,
      date: childIllnessDate,
    });
    this.setState({
      admissionFormModal: {
        ...this.state.admissionFormModal,
        ...this.childIllnessFields,
        childIllnesses,
      },
    });
  };

  addAllergy = () => {
    const { childAllergies, childAllergy, childAllergyDesc, childAllergyDate } =
      this.state.admissionFormModal;

    const uuid = chance.guid();

    childAllergies.push({
      uuid,
      child_health_id: 0,
      allergy: childAllergy.value,
      desc: childAllergyDesc,
      date: childAllergyDate,
    });
    this.setState({
      admissionFormModal: {
        ...this.state.admissionFormModal,
        ...this.childAllergyFields,
        childAllergies,
      },
    });
  };

  addCondition = () => {
    const {
      childConditions,
      childCondition,
      childConditionDesc,
      childConditionDate,
    } = this.state.admissionFormModal;

    const uuid = chance.guid();

    childConditions.push({
      uuid,
      child_health_id: 0,
      condition: childCondition.value,
      desc: childConditionDesc,
      date: childConditionDate,
    });
    this.setState({
      admissionFormModal: {
        ...this.state.admissionFormModal,
        ...this.childConditionFields,
        childConditions,
      },
    });
  };

  deleteMedicalRecord = (index, collection) => {
    const records = this.state.admissionFormModal[collection];
    records.splice(index, 1);
    this.setState({
      admissionFormModal: {
        ...this.state.admissionFormModal,
        [collection]: records,
      },
    });
  };

  handleAttendingDays = (day) => {
    let { attending_days } = this.state.admissionFormModal;

    if (attending_days.includes(day)) {
      const dayIndex = attending_days.findIndex((item) => item == day);
      if (dayIndex !== -1) {
        attending_days.splice(dayIndex, 1);
      }
    } else {
      attending_days.push(day);
    }

    this.setState({
      admissionFormModal: {
        ...this.state.admissionFormModal,
        attending_days,
      },
    });
  };

  previewFile = (e) => {
    const reader = new FileReader();

    const selectedFile = e.target.files[0];

    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    }

    if (
      !selectedFile.type.includes('image') &&
      !selectedFile.type.includes('pdf')
    ) {
      toast.error(t('Only image or PDF file is allowed!'));
      return;
    }

    reader.onload = (readerEvent) => {
      if (selectedFile.type.includes('image')) {
        this.setState({
          admissionFormModal: {
            ...this.state.admissionFormModal,
            [e.target.name + '_prev']: readerEvent.target.result,
            [e.target.name]: e.target.files[0],
          },
        });
      } else if (selectedFile.type.includes('pdf')) {
        this.setState({
          admissionFormModal: {
            ...this.state.admissionFormModal,
            [e.target.name + '_prev']: 'pdf',
            [e.target.name]: e.target.files[0],
          },
        });
      }
    };
  };

  sendBulkMail = async () => {
    this.setState({
      working: true,
    });

    const { authData } = this.props;
    const { email1 } = authData.centerData;

    const { cet_subject, cet_template } = this.state;

    const { filter_date_range, filter_age, filter_nationality, filter_source, filter_referral, filter_class, filter_status, filter_leadstatus, filter_joining_date, filter_admission } = this.state.filter;

    const fData = new FormData();
    fData.append('cet_subject', cet_subject);
    fData.append('cet_template', cet_template);
    fData.append(
      'filter_date_range',
      moment(filter_date_range.startDate).format('YYYY-MM-DD') +
      ' -- ' +
      moment(filter_date_range.endDate).format('YYYY-MM-DD')
    );

    if (filter_age) {
      fData.append('filter_age', filter_age.value);
    }

    if (filter_nationality) {
      fData.append('filter_nationality', filter_nationality.value);
    }

    if (filter_source) {
      fData.append('filter_source', filter_source.value);
    }

    if (filter_referral) {
      fData.append('filter_referral', filter_referral.value);
    }

    if (filter_class) {
      fData.append('filter_class', filter_class.value);
    }

    if (filter_status) {
      fData.append('filter_status', filter_status.value);
    }

    if (filter_admission) {
      fData.append('filter_admission', filter_admission.value);
    }

    if (filter_leadstatus) {
      fData.append('filter_leadstatus', JSON.stringify(filter_leadstatus.map((v) => v.value)))
    }

    if (filter_joining_date) {
      fData.append('filter_joining_date', filter_joining_date);
    }

    try {
      const res = await POST('waiting/send-bulk-mail', fData, {
        params: {
          email1,
        },
      });

      if (res.data.type) {
        toast.success(t(res.data.message));
        this.handleCloseBulkMailModal();
      } else {
        if (res.data.messageType == 'custom_error') {
          toast.error(t(res.data.message));
        } else {
          handleFormErrors(res.data.data);
        }
        this.setState({ working: false });
      }
    } catch (err) {
      console.log(err);
      this.setState({
        working: false,
      });
    }
  };

  exportData = () => {
    const { filter_date_range, filter_age, filter_nationality, filter_source, filter_referral, filter_class, filter_status, filter_leadstatus, filter_joining_date, filter_admission } = this.state.filter;

    let exportUrl = apiURL + '/waiting/export-data?'
    exportUrl += `filter_date_range=${moment(filter_date_range.startDate).format('YYYY-MM-DD') + ' -- ' + moment(filter_date_range.endDate).format('YYYY-MM-DD')}`
    if (filter_age) {
      exportUrl += '&filter_age=' + filter_age.value
    }
    if (filter_nationality) {
      exportUrl += '&filter_nationality=' + filter_nationality.value
    }
    if (filter_source) {
      exportUrl += '&filter_source=' + filter_source.value
    }
    if (filter_referral) {
      exportUrl += '&filter_referral=' + filter_referral.value
    }
    if (filter_joining_date) {
      exportUrl += '&filter_joining_date=' + filter_joining_date
    }
    if (filter_class) {
      exportUrl += '&filter_class=' + filter_class.value
    }
    if (filter_status) {
      exportUrl += '&filter_status=' + filter_status.value
    }
    if (filter_admission) {
      exportUrl += '&filter_admission=' + filter_admission.value
    }
    if (filter_leadstatus) {
      exportUrl += '&filter_leadstatus=' + filter_leadstatus.map((v) => v.value).join(',')
    }
    exportUrl += '&auth_key=' + this.props.authData.authKey
    exportUrl += '&center_id=' + this.props.authData.centerData.center_id

    window.open(exportUrl);
  };

  importData = (e) => {
    this.setState({
      importingData: true,
    });

    const reader = new FileReader();

    const selectedFile = e.target.files[0];

    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    }

    if (
      !selectedFile.type.includes(
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      )
    ) {
      toast.error(t('Only Excel file is allowed!'));
      return;
    }

    reader.onload = async (readerEvent) => {
      const fData = new FormData();

      fData.append('import_file', e.target.files[0]);

      try {
        const res = await POST('waiting/import-data', fData);
        if (res.data.type) {
          toast.success(t(res.data.message));
        } else {
          toast.error(t(res.data.message));
        }
        this.setState({
          importingData: false,
        });
        this.import_data.current.value = '';
      } catch (err) {
        console.log(err);
        this.setState({
          importingData: false,
        });
        this.import_data.current.value = '';
      }
    };
  };

  downloadAdmissionForm = (admission_id) => {
    const { center_name, email1 } = this.props.authData.centerData;
    window.open(
      apiURL +
      `waiting/form-download?admission_id=${admission_id}&auth_key=${this.props.authData.authKey}&tenant_id=${this.props.authData.centerData.tenant_id}&center_id=${this.props.authData.centerData.center_id}&center_name=${center_name}&email1=${email1}`,
      '_blank'
    );
  };

  addCountrySchool = () => {
    const {
      admcntr_id,
      admcntr_year,
      admcntr_country,
      admcntr_school,
      admcntr_grade,
      admcntr_instruction,
      admcntr_referral,
      admcntr_ref_title,
      admcntr_email,
      admcntr_phone
    } = this.state.admissionFormModal;

    if (
      !admcntr_year &&
      !admcntr_country &&
      !admcntr_school &&
      !admcntr_grade &&
      !admcntr_instruction &&
      !admcntr_referral &&
      !admcntr_ref_title &&
      !admcntr_email &&
      !admcntr_phone
    ) {
      toast.error(t('Cannot add empty record!'));
      return;
    }
  }

  render() {

    const { auth_key } = this.props.authData;
    const { cdt, siblingFields } = this.state;

    return (
      <div>
        <div>
          <Row className='m-0'>
            <Col className='pe-0'>
              <div className='cdt-search' style={{ height: 38, width: '100%', borderRadius: 20 }}>
                <input
                  style={{
                    paddingLeft: 17
                  }}
                  type='text'
                  ref={this.searchFieldRef}
                  defaultValue={this.state.cdt.search}
                  onChange={(e) =>
                    this.fetch({
                      search: e.target.value,
                      limit: this.state.cdt.rows,
                      order: this.state.cdt.order,
                      dir: this.state.cdt.dir,
                      page: 0,
                    })
                  }
                  placeholder={t('Search...')}
                />
                <button
                  onClick={() => {
                    this.fetch({
                      search: '',
                      limit: this.state.cdt.rows,
                      order: this.state.cdt.order,
                      dir: this.state.cdt.dir,
                      page: 0,
                    });
                    this.searchFieldRef.current.value = '';
                  }}>
                  <FontAwesomeIcon
                    icon={this.state.cdt.search == '' ? faSearch : faXmark}
                    color={
                      brand_colors[this.props.defaultTheme.theme_id].color18
                    }
                  />
                </button>
              </div>
            </Col>
            <Col md={'auto'}>
              <div className='me-2' style={{ display: 'inline-block' }}>
                <Dropdown>
                  <Dropdown.Toggle variant="light"
                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }}>
                    {t('Show:') + ' ' + (this.state.cdt.rows == -1 ? 'All' : this.state.cdt.rows)}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {this.state.cdt.rowsOptions.map((row, index) =>
                      <Dropdown.Item onClick={() => this.fetch({
                        search: this.state.cdt.search,
                        limit: row,
                        order: this.state.cdt.order,
                        dir: this.state.cdt.dir,
                        page: this.state.cdt.page,
                      })
                      }
                        key={index}>{row == -1 ? 'All' : row}</Dropdown.Item>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className='me-2' style={{ display: 'inline-block' }}>
                <Dropdown>
                  <Dropdown.Toggle variant='light'
                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }} className='crm-options-btn'>
                    <FontAwesomeIcon
                      icon={faSort}
                      style={{ fontSize: 13, marginRight: 5 }}
                    />{t('Sort')}
                  </Dropdown.Toggle>

                  <Dropdown.Menu style={{ width: 180 }}>
                    {this.state.cdt.columns
                      .filter(column => column.sortable)
                      .map((column, index) => {
                        return (
                          <Dropdown.Item
                            key={index}
                            onClick={() => this.fetch({
                              search: this.state.cdt.search,
                              limit: this.state.cdt.rows,
                              order: column.id,
                              dir: (this.state.cdt.order == column.id) ? cdt.dir == 'ASC' ? 'DESC' : 'ASC' : 'DESC',
                              page: this.state.cdt.page,
                            })}
                            className='d-flex justify-content-between align-items-center'>
                            {t(column.name)}
                            {this.state.cdt.order == column.id &&
                              <FontAwesomeIcon
                                icon={this.state.cdt.dir == 'DESC' ? faArrowDown : faArrowUp}
                                style={{ fontSize: 12 }}
                              />}
                          </Dropdown.Item>
                        )
                      })}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div className='me-2' style={{ display: 'inline-block' }}>
                <Dropdown>
                  <Dropdown.Toggle variant='light'
                    style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }} className='crm-options-btn'>
                    <FontAwesomeIcon
                      icon={faSliders}
                      style={{ fontSize: 13, marginRight: 5 }}
                    />{t('Options')}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => this.handleOpenBulkMailModal()}> <FontAwesomeIcon
                      icon={faEnvelope}
                      style={{ marginRight: 5 }}
                    /> Bulk Mail</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.exportData()}><FontAwesomeIcon
                      icon={faUpload}
                      style={{ marginRight: 5 }}
                    />Export Data</Dropdown.Item>
                    <Dropdown.Item onClick={() => this.import_data.current.click()}>
                      <FontAwesomeIcon
                        icon={faDownload}
                        style={{ marginRight: 5 }}
                      />Import Data
                      <Form.Control
                        className='d-none'
                        ref={this.import_data}
                        type='file'
                        onChange={this.importData}
                        name='import_data'
                        accept='.xls, .xlsx'
                      />
                    </Dropdown.Item>
                    <Dropdown.Item href={SampleXL}>
                      <div style={{ paddingRight: 15 }}>
                        <div style={{
                          float: 'left',
                          height: 40
                        }}><FontAwesomeIcon
                            icon={faFileLines}
                            style={{ marginRight: 5 }}
                          /></div>Download Sample File <br /> for Import Data
                      </div>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <button
                onClick={() => this.exportExcel()}
                style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }}
                className='btn btn-light btn-sm me-2'>
                <FontAwesomeIcon
                  icon={faFileExcel}
                  style={{ marginRight: 5 }}
                />
                {t('Excel')}
              </button>
              <button
                onClick={() => this.setState({
                  filter: {
                    ...this.state.filter,
                    show: true,
                  }
                })}
                style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }}
                className='btn btn-warning btn-sm me-2'>
                <FontAwesomeIcon
                  icon={faFilter}
                  style={{ fontSize: 12, marginRight: 5 }}
                />
                {t('Filter')}
              </button>
              <button
                onClick={this.handleOpenFormModal}
                style={{ height: 36, borderRadius: 20, minWidth: 100, paddingInline: 16 }}
                className='btn btn-info btn-sm'>
                <FontAwesomeIcon
                  icon={faPlus}
                  color={
                    brand_colors[this.props.defaultTheme.theme_id].color8
                  }
                  style={{ fontSize: 15 }}
                /> {t('Add')}
              </button>
            </Col>
          </Row>
          {this.state.filter.filter_enable &&
            <Row className='m-0'>
              <Col>
                <div className='leads-filter-bar'>
                  <div className='d-flex'>
                    {this.state.filter.filter_date_range_enable &&
                      <button className='lead-filter-tag me-2'>{moment(this.state.filter.filter_date_range.startDate).format('DD-MM-YYYY')} - {moment(this.state.filter.filter_date_range.endDate).format('DD-MM-YYYY')}
                        {/* <FontAwesomeIcon
                  icon={faCircleXmark}
                  style={{ marginLeft: 3 }}
                /> */}
                      </button>
                    }
                    {this.state.filter.filter_approved_date_enable &&
                      <button className='lead-filter-tag me-2'>{moment(this.state.filter.filter_approved_date.startDate).format('DD-MM-YYYY')} - {moment(this.state.filter.filter_approved_date.endDate).format('DD-MM-YYYY')}
                        {/* <FontAwesomeIcon
                  icon={faCircleXmark}
                  style={{ marginLeft: 3 }}
                /> */}
                      </button>
                    }
                    {this.state.filter.filter_age &&
                      <button className='lead-filter-tag me-2'>{this.state.filter.filter_age.label}
                        {/* <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ marginLeft: 3 }}
                  /> */}
                      </button>
                    }
                    {this.state.filter.filter_nationality &&
                      <button className='lead-filter-tag me-2'>{this.state.filter.filter_nationality.label}
                        {/* <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ marginLeft: 3 }}
                  /> */}
                      </button>
                    }
                    {this.state.filter.filter_source &&
                      <button className='lead-filter-tag me-2'>{this.state.filter.filter_source.label}
                        {/* <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ marginLeft: 3 }}
                  /> */}
                      </button>
                    }
                    {this.state.filter.filter_referral &&
                      <button className='lead-filter-tag me-2'>{this.state.filter.filter_referral.label}
                        {/* <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ marginLeft: 3 }}
                  /> */}
                      </button>
                    }
                    {this.state.filter.filter_joining_date &&
                      <button className='lead-filter-tag me-2'>{moment(this.state.filter.filter_joining_date).format('DD-MM-YYYY')}
                        {/* <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ marginLeft: 3 }}
                  /> */}
                      </button>
                    }
                    {this.state.filter.filter_class &&
                      <button className='lead-filter-tag me-2'>{this.state.filter.filter_class.label}
                        {/* <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ marginLeft: 3 }}
                  /> */}
                      </button>
                    }
                    {this.state.filter.filter_status &&
                      <button className='lead-filter-tag me-2'>{this.state.filter.filter_status.label}
                        {/* <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ marginLeft: 3 }}
                  /> */}
                      </button>
                    }
                    {this.state.filter.filter_admission &&
                      <button className='lead-filter-tag me-2'>{this.state.filter.filter_admission.label}
                        {/* <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ marginLeft: 3 }}
                  /> */}
                      </button>
                    }
                    {this.state.filter.filter_leadstatus && this.state.filter.filter_leadstatus.map((v, i) => {
                      return <button key={i} className='lead-filter-tag me-2'>{v.label}
                        {/* <FontAwesomeIcon
                    icon={faCircleXmark}
                    style={{ marginLeft: 3 }}
                  /> */}
                      </button>
                    })}
                  </div>
                  <button className='lead-filter-tag'
                    onClick={() => this.setState({
                      filter: {
                        ...this.filterFields,
                        filter_enable: false,
                      }
                    }, () => this.fetch({
                      search: '',
                      limit: this.state.cdt.rows,
                      order: this.state.cdt.order,
                      dir: this.state.cdt.dir,
                      page: 0,
                    }))}
                    style={{
                      background: '#D13341',
                      color: '#fff'
                    }}>
                    <FontAwesomeIcon
                      icon={faCircleXmark}
                      style={{ marginRight: 4 }}
                    />{t('Clear Filters')}
                  </button>
                </div>
              </Col>
            </Row>
          }
        </div>

        <Row className='m-0'>
          <Col>
            <div className='grey-section d-flex leads-list' style={{ padding: 10, borderRadius: 20, marginTop: 10, height: this.state.filter.filter_enable ? 'calc(100vh - 275px)' : 'calc(100vh - 241px)', overflow: 'auto' }}>
              {this.state.cdt.fetching &&
                <div
                  style={{ flex: 1 }}
                  className='d-flex flex-column align-items-center justify-content-center'>
                  <Spinner as='span' animation='grow' size='sm' />{' '}
                  {t('Loading Data')}
                </div>
              }
              {!this.state.cdt.fetching && this.state.cdt.data.length === 0 &&
                <div
                  style={{ flex: 1 }}
                  className='d-flex flex-column align-items-center justify-content-center'>
                  {t('No Data Found')}
                </div>
              }
              {(!this.state.cdt.fetching && this.state.cdt.data.length !== 0) &&
                this.state.cdt.data.map((leadObject, leadIndex) =>
                  <LeadCard
                    key={leadIndex}
                    leadObject={leadObject}
                    edit={this.edit}
                    handleOpenTasksModal={() => this.setState({
                      waitingObject: leadObject
                    })}
                    handleOpenNotesModal={this.handleOpenNotesModal}
                    handleOpenFormUrlModal={this.handleOpenFormUrlModal}
                    handleOpenAdmissionFormModal={this.handleOpenAdmissionFormModal}
                    handleOpenPaymentUrlModal={this.handleOpenPaymentUrlModal}
                    downloadAdmissionForm={this.downloadAdmissionForm}
                  />
                )
              }
            </div>
          </Col>
        </Row>

        <Row style={{ margin: 0, marginTop: 10 }}>
          <Col>
            <Badge bg='dark'>
              Total Leads: <strong>{this.state.cdt.totalRecords}</strong>
            </Badge>
          </Col>
          <Col>
            <Pagination
              pageCount={this.state.cdt.lastPage || 1}
              forcePage={this.state.cdt.page}
              callbackParams={{
                search: this.state.cdt.search,
                limit: this.state.cdt.rows,
                order: this.state.cdt.order,
                dir: this.state.cdt.dir,
              }}
              callback={this.fetch}
            />
          </Col>
        </Row>

        {/* Lead Modal */}
        <Modal
          backdrop='static'
          keyboard={false}
          size={'xxl'}
          show={this.state.showFormModal}
          onHide={this.handleCloseFormModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {this.state.isEditing ? t('Edit') : t('Add')} {t('Lead')}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='custom-styled-form p-0'>
            <Row>
              <Col md={3}>
                <div style={{
                  height: 'calc(100vh - 200px)',
                  overflow: 'auto',
                  backgroundColor: '#F5F5F5',
                  padding: '10px 0'
                }}>
                  {this.leadFormTabs.map((tab, index) => (
                    <div
                      onClick={() => {
                        this.setState({ activeLeadFormTab: tab.tabID });
                        setTimeout(() => {
                          const targetElement = document.getElementById(tab.tabID);
                          if (targetElement) {
                            const elementPosition = targetElement.offsetTop;
                            const offsetPosition = elementPosition - 45;

                            const scrollContainer = targetElement.closest('[style*="overflow: auto"]');
                            if (scrollContainer) {
                              scrollContainer.scrollTo({
                                top: offsetPosition,
                                behavior: 'smooth'
                              });
                            }
                          }
                        }, 100);
                      }
                      }
                      className={
                        this.state.activeLeadFormTab ==
                          tab.tabID
                          ? 'active'
                          : ''
                      }
                      style={{
                        padding: '15px 25px',
                        cursor: 'pointer'
                      }}
                      data-tab-name={tab.id}>
                      <FontAwesomeIcon icon={faCheckCircle} style={{
                        color: this.state.activeLeadFormTab ==
                          tab.tabID
                          ? '#5BBD4A'
                          : '#DEDFE0',
                        marginRight: 10,
                        fontSize: 25,
                        position: 'relative',
                        top: 3
                      }} />{t(tab.tabName)}
                    </div>
                  ))}

                </div>
              </Col>
              <Col md={9}>
                <div style={{
                  height: 'calc(100vh - 200px)',
                  overflow: 'auto',
                  padding: '25px 15px 25px 5px'
                }}>
                  <Row id="lead_form_tab_one">
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Child Name')}</Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={this.state.child_name}
                          onChange={(e) =>
                            this.setState({ child_name: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Date of Birth')}</Form.Label>
                        <Flatpickr
                          options={{
                            static: true,
                          }}
                          className='form-control'
                          value={this.state.child_birth}
                          onChange={([date]) => {
                            this.setState({
                              child_birth: moment(date).format('YYYY-MM-DD'),
                            });
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Nationality')}</Form.Label>
                        <Select
                          classNamePrefix='custom-styled-select'
                          value={this.state.country_id}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          options={this.state.countries}
                          onChange={(obj) => this.setState({ country_id: obj })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Expected Joining Date')}</Form.Label>
                        <Flatpickr
                          options={{
                            static: true,
                          }}
                          className='form-control'
                          value={this.state.joining_date}
                          onChange={([date]) => {
                            this.setState({
                              joining_date: moment(date).format('YYYY-MM-DD'),
                            });
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Gender')}</Form.Label><br />
                        <ButtonGroup aria-label="Basic example">
                          <Button onClick={() => this.setState({ gender: 'M' })}
                            variant={this.state.gender == 'M' ? 'info' : 'outline-info'}>{t('Male')}</Button>
                          <Button onClick={() => this.setState({ gender: 'F' })}
                            variant={this.state.gender == 'F' ? 'info' : 'outline-info'}>{t('Female')}</Button>
                        </ButtonGroup>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Parent Name')}</Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={this.state.parent_name}
                          onChange={(e) =>
                            this.setState({ parent_name: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Phone 1')}</Form.Label>
                        <Form.Control
                          type='tel'
                          defaultValue={this.state.phone1}
                          onChange={(e) => this.setState({ phone1: e.target.value })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Email')}</Form.Label>
                        <Form.Control
                          type='email'
                          defaultValue={this.state.email1}
                          onChange={(e) => this.setState({ email1: e.target.value })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Primary Contact')}</Form.Label><br />
                        <ButtonGroup aria-label="Basic example">
                          <Button onClick={() => this.setState({ primary_contact: 'Father' })}
                            variant={this.state.primary_contact == 'Father' ? 'info' : 'outline-info'}>{t('Father')}</Button>
                          <Button onClick={() => this.setState({ primary_contact: 'Mother' })}
                            variant={this.state.primary_contact == 'Mother' ? 'info' : 'outline-info'}>{t('Mother')}</Button>
                        </ButtonGroup>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>{t('Details')}</h5>
                  <Row id="lead_form_tab_two">
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Inquiry Date')}</Form.Label>
                        <Flatpickr
                          options={{
                            static: true,
                          }}
                          className='form-control'
                          value={this.state.waiting_date}
                          onChange={([date]) => {
                            this.setState({
                              waiting_date: moment(date).format('YYYY-MM-DD'),
                            });
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Source')}</Form.Label>
                        <Select
                          classNamePrefix='custom-styled-select'
                          value={this.state.visitby_id}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          options={this.state.visitbys}
                          onChange={(obj) => this.setState({ visitby_id: obj })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Referral')}</Form.Label>
                        <Select
                          classNamePrefix='custom-styled-select'
                          value={this.state.referral_id}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          options={this.state.referrals}
                          onChange={(obj) => this.setState({ referral_id: obj })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Operator')}</Form.Label>
                        <Select
                          classNamePrefix='custom-styled-select'
                          value={this.state.employee_id}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          options={this.state.operators}
                          onChange={(obj) => this.setState({ employee_id: obj })}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>{t('Joining Details')}</h5>
                  <Row id="lead_form_tab_three">
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Class Name')}</Form.Label>
                        <Select
                          classNamePrefix='custom-styled-select'
                          value={this.state.class_id}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          options={this.state.classes}
                          onChange={(obj) => this.setState({ class_id: obj })}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Term')}</Form.Label>
                        <Select
                          classNamePrefix='custom-styled-select'
                          value={this.state.term_id}
                          options={this.state.terms}
                          onChange={(obj) => this.setState({ term_id: obj })}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          formatOptionLabel={(option) => (
                            <div>
                              {option.label}
                              {option.term_active == 1 && (
                                <span
                                  className='badge'
                                  style={{
                                    position: 'relative',
                                    top: -1,
                                    marginLeft: 5,
                                    backgroundColor: '#00d045',
                                  }}>
                                  ACTIVE
                                </span>
                              )}
                            </div>
                          )}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Joining Note')}</Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={this.state.joining_note}
                          onChange={(e) =>
                            this.setState({ joining_note: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Notes to Follow Up')}</Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={this.state.notes}
                          onChange={(e) => this.setState({ notes: e.target.value })}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>{t('Select Days')}</h5>
                  <Row id="lead_form_tab_four">
                    <Col md={1}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Sunday')}</Form.Label>
                        <div
                          style={{
                            paddingLeft: 10,
                          }}
                          className='p-3 pb-0'>
                          <Form.Check
                            type='switch'
                            id='sunday'
                            label={false}
                            onChange={() =>
                              this.setState({
                                sunday: this.state.sunday == 1 ? 0 : 1,
                              })
                            }
                            checked={this.state.sunday == 1}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={1}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Monday')}</Form.Label>
                        <div
                          style={{
                            paddingLeft: 10,
                          }}
                          className='p-3 pb-0'>
                          <Form.Check
                            type='switch'
                            id='monday'
                            label={false}
                            onChange={() =>
                              this.setState({
                                monday: this.state.monday == 1 ? 0 : 1,
                              })
                            }
                            checked={this.state.monday == 1}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={1}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Tuesday')}</Form.Label>
                        <div
                          style={{
                            paddingLeft: 10,
                          }}
                          className='p-3 pb-0'>
                          <Form.Check
                            type='switch'
                            id='tuesday'
                            label={false}
                            onChange={() =>
                              this.setState({
                                tuesday: this.state.tuesday == 1 ? 0 : 1,
                              })
                            }
                            checked={this.state.tuesday == 1}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={1}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Wednesday')}</Form.Label>
                        <div
                          style={{
                            paddingLeft: 10,
                          }}
                          className='p-3 pb-0'>
                          <Form.Check
                            type='switch'
                            id='wednesday'
                            label={false}
                            onChange={() =>
                              this.setState({
                                wednesday: this.state.wednesday == 1 ? 0 : 1,
                              })
                            }
                            checked={this.state.wednesday == 1}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={1}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Thursday')}</Form.Label>
                        <div
                          style={{
                            paddingLeft: 10,
                          }}
                          className='p-3 pb-0'>
                          <Form.Check
                            type='switch'
                            id='thursday'
                            label={false}
                            onChange={() =>
                              this.setState({
                                thursday: this.state.thursday == 1 ? 0 : 1,
                              })
                            }
                            checked={this.state.thursday == 1}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={1}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Friday')}</Form.Label>
                        <div
                          style={{
                            paddingLeft: 10,
                          }}
                          className='p-3 pb-0'>
                          <Form.Check
                            type='switch'
                            id='friday'
                            label={false}
                            onChange={() =>
                              this.setState({
                                friday: this.state.friday == 1 ? 0 : 1,
                              })
                            }
                            checked={this.state.friday == 1}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                    <Col md={1}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Saturday')}</Form.Label>
                        <div
                          style={{
                            paddingLeft: 10,
                          }}
                          className='p-3 pb-0'>
                          <Form.Check
                            type='switch'
                            id='saturday'
                            label={false}
                            onChange={() =>
                              this.setState({
                                saturday: this.state.saturday == 1 ? 0 : 1,
                              })
                            }
                            checked={this.state.saturday == 1}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>{t('Previous Institution')}</h5>
                  <Row id="lead_form_tab_five">
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Previous School')}</Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={this.state.previous_nursery}
                          onChange={(e) =>
                            this.setState({ previous_nursery: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Reason To Leave Prev.')}</Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={this.state.reasontoleaveprev}
                          onChange={(e) =>
                            this.setState({ reasontoleaveprev: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className='mb-2'>
                        <Form.Label>{t('Comment On Prev.')}</Form.Label>
                        <Form.Control
                          type='text'
                          defaultValue={this.state.commentonprev}
                          onChange={(e) =>
                            this.setState({ commentonprev: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseFormModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.working}
              variant='success'
              onClick={() => this.saveUpdate()}>
              {t('Save')}{' '}
              {this.state.working ? (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              ) : (
                ''
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Bulk Mail Modal */}
        <Modal
          size='lg'
          backdrop='static'
          keyboard={false}
          show={this.state.bulkMailModal.show}
          onHide={this.handleCloseBulkMailModal}>
          <Modal.Header closeButton>
            <Modal.Title>{t('Bulk Mail')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='custom-styled-form'>
            <Row>
              <Col md={4}>
                <Form.Group className='mb-3'>
                  <Form.Label style={{ height: 17 }}>
                    {t('Template')}
                  </Form.Label>
                  <Select
                    classNamePrefix='custom-styled-select'
                    value={this.state.cet_id}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                    }}
                    options={this.state.emailTemplates}
                    onChange={(obj) => {
                      this.setState({
                        cet_id: obj,
                        cet_template: obj.cet_template,
                      });
                    }}
                  />
                </Form.Group>
              </Col>
              <Col md={8}>
                <Form.Group className='mb-3'>
                  <Form.Label style={{ height: 17 }}>{t('Subject')}</Form.Label>
                  <Form.Control
                    type='text'
                    defaultValue={this.state.cet_subject}
                    onChange={(e) =>
                      this.setState({ cet_subject: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <CKEditor
                  data={this.state.cet_template}
                  config={{
                    ckfinder: {
                      uploadUrl:
                        apiURL +
                        '/authentication/ckeditor-upload?auth_key=' +
                        auth_key +
                        '&center_id=' +
                        this.props.authData.centerData.center_id,
                    },
                    toolbar: {
                      items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        '|',
                        'fontColor',
                        'fontFamily',
                        '|',
                        'numberedList',
                        'bulletedList',
                        '|',
                        'indent',
                        'outdent',
                        '|',
                        'link',
                        'blockQuote',
                        'imageUpload',
                        'insertTable',
                        '|',
                        'undo',
                        'redo',
                      ],
                    },
                    readOnly: true,
                  }}
                  editor={Editor}
                  onBlur={(event, editor) => {
                    // Array.from(editor.ui.componentFactory.names()).map(item => console.log(item));
                    const data = editor.getData();
                    this.setState({
                      cet_template: data,
                    });
                  }}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseBulkMailModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.working}
              variant='success'
              onClick={() => this.sendBulkMail()}>
              {t('Send Bulk Mail')}{' '}
              {this.state.working ? (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              ) : (
                ''
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Notes Modal */}
        <Modal
          backdrop='static'
          keyboard={false}
          size='xl'
          show={this.state.notesModal.show}
          onHide={this.handleCloseNotesModal}>
          <Modal.Header closeButton>
            <Modal.Title>{t('Notes')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div
              className='cdt-search'
              style={{
                width: '100%',
                marginLeft: 'auto',
              }}>
              <input
                type='text'
                value={this.state.notesModal.cdt.search}
                onChange={(e) =>
                  this.getNotes({
                    search: e.target.value,
                    limit: this.state.notesModal.cdt.rows,
                    order: this.state.notesModal.cdt.order,
                    dir: this.state.notesModal.cdt.dir,
                    page: 0,
                    id: this.state.notesModal.id,
                  })
                }
                placeholder={t('Search...')}
                style={{
                  height: 35
                }}
              />
              <button
                onClick={() => {
                  this.setState({
                    notesModal: {
                      ...this.state.notesModal,
                      cdt: {
                        ...this.state.notesModal.cdt,
                        search: '',
                      },
                    },
                  });
                  this.getNotes({
                    search: '',
                    limit: this.state.notesModal.cdt.rows,
                    order: this.state.notesModal.cdt.order,
                    dir: this.state.notesModal.cdt.dir,
                    page: 0,
                    id: this.state.notesModal.id,
                  });
                }}>
                <FontAwesomeIcon
                  icon={
                    this.state.notesModal.cdt.search == ''
                      ? faSearch
                      : faXmark
                  }
                  color={
                    brand_colors[this.props.defaultTheme.theme_id].color18
                  }
                />
              </button>
            </div>
            <div style={{ padding: '20px 10px 5px' }}>
              <Row>
                <Col md={6}><strong>{t('Parent Name:')}</strong> {this.state.notesModal.waitingObject?.parent_name}</Col>
                <Col md={6}><strong>{t('Student Name:')}</strong> {this.state.notesModal.waitingObject?.child_name}</Col>
                <Col md={6}><strong>{t('Email:')}</strong> {this.state.notesModal.waitingObject?.email1}</Col>
                <Col md={6}><strong>{t('Phone:')}</strong> {this.state.notesModal.waitingObject?.phone1}</Col>
              </Row>
            </div>
            <Row className='pt-1'>
              <Col md='12'>
                <Row>
                  {this.state.notesModal.cdt.fetching && (
                    <Col
                      md={12}
                      className='py-5 d-flex flex-column align-items-center'>
                      <Spinner as='span' animation='grow' size='sm' />{' '}
                      {t('Loading Data')}
                    </Col>
                  )}
                  {!this.state.notesModal.cdt.fetching &&
                    this.state.notesModal.cdt.data.length === 0 && (
                      <Col
                        md={12}
                        className='py-5 d-flex flex-column align-items-center'>
                        {t('No Data Found')}
                      </Col>
                    )}
                  {!this.state.notesModal.cdt.fetching &&
                    this.state.notesModal.cdt.data.length !== 0 && (
                      <Col md={12} className='pt-2'>
                        {this.state.notesModal.cdt.data
                          .map((item, index) =>
                            <div key={index} style={{
                              backgroundColor: '#FBFBFB',
                              padding: 15,
                              marginBottom: 10,
                              borderRadius: 10,
                            }}>
                              <Row className='mb-2'>
                                <Col>
                                  <span style={{
                                    display: 'inline-block',
                                    backgroundColor: '#E3E4E5',
                                    color: '#000',
                                    padding: '2px 5px',
                                    borderRadius: 5,
                                    fontSize: 14,
                                    marginRight: 10
                                  }}
                                  ><FontAwesomeIcon icon={faCalendarAlt} className='me-1' />{moment(item.created_on).format('DD-MM-YYYY')}</span>
                                  <span style={{
                                    display: 'inline-block',
                                    border: '#47BCE8 1px solid',
                                    color: '#47BCE8',
                                    padding: '2px 5px',
                                    borderRadius: 5,
                                    fontSize: 14,
                                  }}
                                  ><FontAwesomeIcon icon={faUser} className='me-1' />{item.created_by_name}</span>
                                </Col>
                                <Col className='text-end'>
                                  <Button
                                    title='Delete'
                                    onClick={() => this.setState({
                                      deleteConfirm: {
                                        show: true,
                                        id: item.wn_id,
                                        action: this.deleteNote
                                      }
                                    })}
                                    variant='danger'
                                    size='sm'
                                    className='me-1'>
                                    <FontAwesomeIcon icon={faTrash} />
                                  </Button>
                                  <Button
                                    title='Edit'
                                    onClick={() => this.editNote(item)}
                                    variant='warning'
                                    size='sm'
                                    className='me-1'>
                                    <FontAwesomeIcon icon={faPencil} />
                                  </Button>
                                </Col>
                              </Row>
                              {item.wn_note}
                            </div>
                          )}
                      </Col>
                    )}
                </Row>
                <div className='d-flex justify-content-center'>
                  <Pagination
                    pageCount={this.state.notesModal.cdt.lastPage || 1}
                    forcePage={this.state.notesModal.cdt.page}
                    callbackParams={{
                      search: this.state.notesModal.cdt.search,
                      limit: this.state.notesModal.cdt.rows,
                      order: this.state.notesModal.cdt.order,
                      dir: this.state.notesModal.cdt.dir,
                      id: this.state.notesModal.id,
                    }}
                    callback={this.getNotes}
                  />
                </div>
              </Col>
              <Col md='12' className='custom-styled-form'>
                <Form.Group className='mb-3'>
                  <Form.Label>{t('Note')}</Form.Label>
                  <Form.Control
                    value={this.state.wn_note}
                    onChange={(e) => this.setState({ wn_note: e.target.value })}
                    as='textarea'
                    rows={5}
                  />
                </Form.Group>
                <div className='d-flex justify-content-end'>
                  <Button
                    variant={this.state.wn_id != 0 ? 'warning' : 'primary'}
                    onClick={() => this.saveNote()}>
                    {this.state.wn_id != 0 ? t('Update') : t('Save')}
                  </Button>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>

        {/* Form URL Modal */}
        <Modal
          size='lg'
          backdrop='static'
          keyboard={false}
          show={this.state.formUrlModal.show}
          onHide={this.handleCloseFormUrlModal}>
          <Modal.Header closeButton>
            <Modal.Title>{t('Send Form URL to Parent')}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='custom-styled-form'>
            <Row>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>{t('Subject')}</Form.Label>
                  <Form.Control
                    type='text'
                    defaultValue={this.state.admission_email_subject}
                    onChange={(e) =>
                      this.setState({ admission_email_subject: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className='mb-3'>
                  <Form.Label>{t('Email')}</Form.Label>
                  <Form.Control
                    type='text'
                    disabled
                    defaultValue={this.state.admission_parent_email}
                    onChange={(e) =>
                      this.setState({ admission_parent_email: e.target.value })
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <CKEditor
                  data={this.state.email_template}
                  config={{
                    ckfinder: {
                      uploadUrl:
                        apiURL +
                        '/authentication/ckeditor-upload?auth_key=' +
                        auth_key +
                        '&center_id=' +
                        this.props.authData.centerData.center_id,
                    },
                    toolbar: {
                      items: [
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        '|',
                        'fontColor',
                        'fontFamily',
                        '|',
                        'numberedList',
                        'bulletedList',
                        '|',
                        'indent',
                        'outdent',
                        '|',
                        'link',
                        'blockQuote',
                        'imageUpload',
                        'insertTable',
                        '|',
                        'undo',
                        'redo',
                      ],
                    },
                    readOnly: true,
                  }}
                  editor={Editor}
                  onBlur={(event, editor) => {
                    // Array.from(editor.ui.componentFactory.names()).map(item => console.log(item));
                    const data = editor.getData();
                    this.setState({
                      email_template: data,
                    });
                  }}
                />
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleCloseFormUrlModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.working}
              variant='success'
              onClick={() => this.sendFormUrlEmail()}>
              {t('Send Email')}{' '}
              {this.state.working ? (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              ) : (
                ''
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Payment URL Modal */}
        <Modal
          size='lg'
          backdrop='static'
          keyboard={false}
          show={this.state.paymentUrlModal.show}
          onHide={this.handleClosePaymentUrlModal}>
          <Modal.Header closeButton>
            <Modal.Title>{t('Send Payment URL to Parent')}</Modal.Title>
          </Modal.Header>
          {this.state.paymentUrlModal.show &&

            <Modal.Body className='custom-styled-form'>
              <Row>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Subject')}</Form.Label>
                    <Form.Control
                      type='text'
                      defaultValue={this.state.admission_email_subject}
                      onChange={(e) =>
                        this.setState({ admission_email_subject: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Email')}</Form.Label>
                    <Form.Control
                      type='text'
                      disabled
                      defaultValue={this.state.admission_parent_email}
                      onChange={(e) =>
                        this.setState({ admission_parent_email: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className='mb-3'>
                    <Form.Label>{t('Payment URL')}</Form.Label>
                    <Form.Control
                      type='text'
                      defaultValue={this.state.admission_payment_url}
                      onChange={(e) =>
                        this.setState({ admission_payment_url: e.target.value })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <CKEditor
                    data={this.state.email_template}
                    config={{
                      ckfinder: {
                        uploadUrl:
                          apiURL +
                          '/authentication/ckeditor-upload?auth_key=' +
                          auth_key +
                          '&center_id=' +
                          this.props.authData.centerData.center_id,
                      },
                      toolbar: {
                        items: [
                          'heading',
                          '|',
                          'bold',
                          'italic',
                          '|',
                          'fontColor',
                          'fontFamily',
                          '|',
                          'numberedList',
                          'bulletedList',
                          '|',
                          'indent',
                          'outdent',
                          '|',
                          'link',
                          'blockQuote',
                          'imageUpload',
                          'insertTable',
                          '|',
                          'undo',
                          'redo',
                        ],
                      },
                      readOnly: true,
                    }}
                    editor={Editor}
                    onBlur={(event, editor) => {
                      // Array.from(editor.ui.componentFactory.names()).map(item => console.log(item));
                      const data = editor.getData();
                      this.setState({
                        email_template: data,
                      });
                    }}
                  />
                </Col>
              </Row>
            </Modal.Body>
          }
          <Modal.Footer>
            <Button
              variant='secondary'
              onClick={this.handleClosePaymentUrlModal}>
              {t('Close')}
            </Button>
            <Button
              disabled={this.state.working}
              variant='success'
              onClick={() => this.sendPaymentUrlEmail()}>
              {t('Send Email')}{' '}
              {this.state.working ? (
                <Spinner
                  as='span'
                  animation='grow'
                  size='sm'
                  role='status'
                  aria-hidden='true'
                />
              ) : (
                ''
              )}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Admission Form Modal */}
        <Modal
          centered
          size='xxl'
          backdrop='static'
          keyboard={false}
          show={this.state.admissionFormModal.show}
          onHide={this.handleCloseAdmissionFormModal}>
          <Modal.Header closeButton>
            <Modal.Title>{t('Admission Data')}</Modal.Title>
          </Modal.Header>
          {this.state.admissionFormModal.show &&
            <Modal.Body className='p-0'>
              {this.state.admissionFormModal.fetching && (
                <Row>
                  <Col
                    md={12}
                    className='py-5 d-flex flex-column align-items-center'>
                    <Spinner as='span' animation='grow' size='sm' />{' '}
                    {t('Loading Data')}
                  </Col>
                </Row>
              )}

              {!this.state.admissionFormModal.fetching && (
                <Row>
                  <Col sm={3}>
                    <div style={{
                      height: 'calc(100vh - 200px)',
                      overflow: 'auto',
                      backgroundColor: '#F5F5F5',
                      padding: '10px 0'
                    }}>
                      {this.admissionFormTabs.map((item, index) => (
                        <div
                          key={index}
                          onClick={this.switchTab}
                          className={
                            this.state.admissionFormModal.activeTab ==
                              item.tabID
                              ? 'active'
                              : ''
                          }
                          style={{
                            padding: '15px 25px',
                            cursor: 'pointer'
                          }}
                          data-tab-name={item.tabID}>
                          <FontAwesomeIcon icon={faCheckCircle} style={{
                            color: this.state.admissionFormModal.activeTab ==
                              item.tabID
                              ? '#5BBD4A'
                              : '#DEDFE0',
                            marginRight: 10,
                            fontSize: 25,
                            position: 'relative',
                            top: 3
                          }} />{t(item.tabName)}
                        </div>
                      ))}
                    </div>
                  </Col>
                  <Col sm={9}>
                    <div style={{
                      height: 'calc(100vh - 200px)',
                      overflow: 'auto',
                      padding: '25px 15px 25px 0'
                    }}>
                      {this.state.admissionFormModal.activeTab == 'tab_one' && (
                        <>
                          <Row className='m-0'>
                            <Col md={12}>
                              <h5>{t('Child Details')}</h5>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Child Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.child_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Child Arabic Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.arabic_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        arabic_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Family Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.child_family_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_family_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Family Arabic Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.child_family_name_2
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_family_name_2: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <Row className='m-0'>
                                <Col md={3}>
                                  <Form.Group className='mb-3'>
                                    <Form.Label>{t('Picture')}</Form.Label>
                                    <div
                                      style={{
                                        flexDirection: 'column',
                                      }}
                                      className='pic-prev d-flex justify-content-center'>
                                      <div
                                        style={{
                                          borderRadius: 5,
                                          borderStyle: 'dashed',
                                          borderWidth: 2,
                                          borderColor: '#ced4da',
                                          height: 150,
                                          display: 'flex',
                                          overflow: 'hidden',
                                        }}>
                                        {this.state.admissionFormModal.picture !==
                                          '' &&
                                          this.state.admissionFormModal.picture_prev !==
                                          '' ? (
                                          <div
                                            className='d-flex justify-content-center align-items-center'
                                            style={{
                                              flex: 1,
                                              position: 'relative',
                                            }}>
                                            <button
                                              style={{
                                                padding: 3,
                                                border: 3,
                                                background: 'none',
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                              }}
                                              onClick={() => {
                                                this.setState({
                                                  admissionFormModal: {
                                                    ...this.state.admissionFormModal,
                                                    picture: '',
                                                    picture_prev: '',
                                                    picture_delete_flag: false,
                                                  },
                                                });
                                                this.picture.current.value = null;
                                              }}>
                                              <FontAwesomeIcon
                                                icon={faTimesCircle}
                                                color='rgb(220, 53, 69)'
                                                style={{
                                                  fontSize: 20,
                                                }}
                                              />
                                            </button>
                                            <img
                                              src={
                                                this.state.admissionFormModal
                                                  .picture_prev
                                              }
                                              alt={t('Preview')}
                                              width='100'
                                            />
                                          </div>
                                        ) : (
                                          <button
                                            onClick={() =>
                                              this.picture.current.click()
                                            }
                                            style={{
                                              background: 'none',
                                              border: 0,
                                              flex: 1,
                                            }}>
                                            <FontAwesomeIcon
                                              icon={faPlus}
                                              style={{
                                                fontSize: 30,
                                              }}
                                            />
                                          </button>
                                        )}
                                      </div>
                                      <Form.Control
                                        className='d-none'
                                        ref={this.picture}
                                        type='file'
                                        onChange={this.previewFile}
                                        name='picture'
                                        accept='.jpg, .jpeg, .png'
                                      />
                                    </div>
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('DOB')}</Form.Label>
                                <Flatpickr
                                  options={{
                                    static: true,
                                  }}
                                  className='form-control'
                                  value={this.state.admissionFormModal.birth_date}
                                  onChange={([date]) => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        birth_date: moment(date).format('YYYY-MM-DD'),
                                      },
                                    });
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Gender')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.gender}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={[
                                    { value: 'M', label: 'Male' },
                                    { value: 'F', label: 'Female' },
                                  ]}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        gender: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t("Birth City")}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.birth_city
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        birth_city: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Nationality')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.country_id}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={this.state.countries}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        country_id: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('2nd Nationality')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.country_id2}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={this.state.countries}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        country_id2: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Religion')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.religion}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={this.state.religions}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        religion: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t("Child's ID")}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.id_number
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        id_number: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className='m-0'>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Child First Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.child_first_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_first_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Child Middle Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.child_middle_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_middle_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Child Last Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.child_last_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_last_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className='m-0'>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Passport Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.passport_number
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        passport_number: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Passport Validity')}</Form.Label>
                                <Flatpickr
                                  options={{
                                    static: true,
                                  }}
                                  className='form-control'
                                  value={this.state.admissionFormModal.passport_validity}
                                  onChange={([date]) => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        passport_validity: moment(date).format('YYYY-MM-DD'),
                                      },
                                    });
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Residency Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.residency_number
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        residency_number: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Residency Validity')}</Form.Label>
                                <Flatpickr
                                  options={{
                                    static: true,
                                  }}
                                  className='form-control'
                                  value={this.state.admissionFormModal.residency_validity}
                                  onChange={([date]) => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        residency_validity: moment(date).format('YYYY-MM-DD'),
                                      },
                                    });
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('DOB Hijri')}</Form.Label>
                                <DatePicker
                                  className='form-control'
                                  selected={this.state.admissionFormModal?.birth_date2}
                                  onChange={(date) => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        birth_date2: date,
                                      },
                                    });
                                  }}
                                  calendar="hijri"
                                />
                                {/* <Flatpickr
                                options={{
                                  static: true,
                                }}
                                className='form-control'
                                value={this.state.admissionFormModal.birth_date2}
                                onChange={([date]) => {
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      birth_date2: moment(date).format('YYYY-MM-DD'),
                                    },
                                  });
                                }}
                              /> */}
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className='m-0'>
                            <Col md={10}>
                              <Form.Group className='mb-3'>
                                <Form.Label>
                                  {t('Notes')}
                                </Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={this.state.admissionFormModal.notes}
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        notes: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={2} className='ps-0'>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Staff Child')}</Form.Label>
                                <div
                                  style={{
                                    paddingLeft: 10,
                                  }}
                                  className='p-3 pb-0 pt-2'>
                                  <Form.Check
                                    type='switch'
                                    id='staff_child'
                                    label={false}
                                    onChange={() =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          staff_child:
                                            this.state.admissionFormModal
                                              .staff_child == 1
                                              ? 0
                                              : 1,
                                        },
                                      })
                                    }
                                    checked={
                                      this.state.admissionFormModal.staff_child == 1
                                    }
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                            <Col md={10}>
                              <Form.Group className='mb-3'>
                                <Form.Label>
                                  {t('School Leaving Reason')}
                                </Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={this.state.admissionFormModal.child_school_leaving_reason}
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_school_leaving_reason: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={10}>
                              <Form.Group className='mb-3'>
                                <Form.Label>
                                  {t('Full Term Delivery')}
                                </Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={this.state.admissionFormModal.full_term_delivery}
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        full_term_delivery: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>

                            <Col md={12}>
                              <hr />
                            </Col>
                            <Col md={12}>
                              <h5>{t('Family Details')}</h5>
                            </Col>
                            {/* <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Role')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.sponsor_role}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={[
                                    { value: 'Father', label: 'Father' },
                                    { value: 'Mother', label: 'Mother' },
                                    { value: 'Guardian', label: 'Guardian' },
                                    { value: 'Other', label: 'Other' },
                                  ]}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        sponsor_role: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col> */}
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Full Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Arabic Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_name_2
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_name_2: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Mobile Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_mobile
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_mobile: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Work Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_workphone
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_workphone: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Email Address')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_email
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_email: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Place of Work')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_employer
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_employer: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Occupation')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_position
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_position: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Nationality')}</Form.Label>
                                <Select
                                  options={this.state.nationalities}
                                  value={this.state.admissionFormModal.father_nationality}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_nationality: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>
                                  {t('Language')}
                                </Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.father_language}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={this.state.languages}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_language: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('ID Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_id_number
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_id_number: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Education')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_education
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_education: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Income')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_income
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_income: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Grandfather Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.grandfather_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        grandfather_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Passport Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_passport_num
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_passport_num: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Passport Validity')}</Form.Label>
                                <Flatpickr
                                  options={{
                                    static: true,
                                  }}
                                  className='form-control'
                                  value={this.state.admissionFormModal.father_passport_validity}
                                  onChange={([date]) => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_passport_validity: moment(date).format('YYYY-MM-DD'),
                                      },
                                    });
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Residency Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.father_residency_number
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_residency_number: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Residency Validity')}</Form.Label>
                                <Flatpickr
                                  options={{
                                    static: true,
                                  }}
                                  className='form-control'
                                  value={this.state.admissionFormModal.father_residency_validity}
                                  onChange={([date]) => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        father_residency_validity: moment(date).format('YYYY-MM-DD'),
                                      },
                                    });
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Home Address')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.home_address
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        home_address: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Home City')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.home_city
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        home_city: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Home Street')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.home_street
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        home_street: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Home Phone')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.home_phone
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        home_phone: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Home Pobox')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.home_pobox
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        home_pobox: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Living Status')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.livingstatus_type}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={this.livingStatus}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        livingstatus_type: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={9}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Living Description')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.livingstatus_desc
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        livingstatus_desc: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <hr />
                            </Col>
                            <Col md={12}>
                              <h5>{t('Spouse Information')}</h5>
                            </Col>
                            {/* <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Role')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.spouse_role}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={[
                                    { value: 'Father', label: 'Father' },
                                    { value: 'Mother', label: 'Mother' },
                                    { value: 'Guardian', label: 'Guardian' },
                                    { value: 'Other', label: 'Other' },
                                  ]}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        spouse_role: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col> */}
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Full Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Mobile Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_mobile
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_mobile: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Work Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_workphone
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_workphone: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Email Address')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_email
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_email: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Place of Work')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_employer
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_employer: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Occupation')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_position
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_position: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Nationality')}</Form.Label>
                                <Select
                                  options={this.state.nationalities}
                                  value={this.state.admissionFormModal.mother_nationality}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_nationality: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>
                                  {t('Language')}
                                </Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.mother_language}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={this.state.languages}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_language: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Education')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_education
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_education: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Passport Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_passport_num
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_passport_num: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Passport Validity')}</Form.Label>
                                <Flatpickr
                                  options={{
                                    static: true,
                                  }}
                                  className='form-control'
                                  value={this.state.admissionFormModal.mother_passport_validity}
                                  onChange={([date]) => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_passport_validity: moment(date).format('YYYY-MM-DD'),
                                      },
                                    });
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Residency Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_residency_number
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_residency_number: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Residency Validity')}</Form.Label>
                                <Flatpickr
                                  options={{
                                    static: true,
                                  }}
                                  className='form-control'
                                  value={this.state.admissionFormModal.mother_residency_validity}
                                  onChange={([date]) => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_residency_validity: moment(date).format('YYYY-MM-DD'),
                                      },
                                    });
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Income')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.mother_income
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        mother_income: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <hr />
                            </Col>
                            <Col md={12}>
                              <h5>{t('Emergency Contact')}</h5>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.emergency_contact1
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_contact1: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Relation')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.emergency_relation1
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_relation1: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Contact Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.emergency_phone1
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_phone1: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}></Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.emergency_contact2
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_contact2: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Relation')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.emergency_relation2
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_relation2: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Contact Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.emergency_phone2
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_phone2: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}></Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.emergency_contact3
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_contact3: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Relation')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.emergency_relation3
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_relation3: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Contact Number')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.emergency_phone3
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_phone3: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <hr />
                            </Col>
                            <Col md={12}>
                              <h5>{t('Sponsor')}</h5>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.sponsor_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        sponsor_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Phone 1')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.sponsor_phone1
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        sponsor_phone1: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Phone 2')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.sponsor_phone2
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        sponsor_phone2: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Email')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.sponsor_email
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        sponsor_email: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Description')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.sponsor_desc
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        sponsor_desc: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={12}>
                              <hr />
                            </Col>
                            <Col md={12}>
                              <h5>{t('Other')}</h5>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Nanny Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.nanny_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        nanny_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Nanny Phone')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.nanny_phone
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        nanny_phone: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Driver Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.driver_name
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        driver_name: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Driver Phone')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.driver_phone
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        driver_phone: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Reading Proficiency')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.reading_prof}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={this.readingProf}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        reading_prof: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Writing Proficiency')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.writing_prof}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={this.writingProf}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        writing_prof: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Speaking Proficiency')}</Form.Label>
                                <Select
                                  value={this.state.admissionFormModal.speaking_prof}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={this.writingProf}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        speaking_prof: obj,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Current Curriculum')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.current_curr
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        current_curr: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_two' && (
                        <Row className='m-0'>
                          <Col md={12}>
                            <h5>{t('Registration Process')}</h5>
                          </Col>
                          <Col md={12}>
                            <p>
                              {t(
                                'The following documents are required to complete the registration process:'
                              )}
                            </p>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Child Documents')}</h5>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('ID Front')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal.child_eid_page !==
                                    '' &&
                                    this.state.admissionFormModal
                                      .child_eid_page_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              child_eid_page: '',
                                              child_eid_page_prev: '',
                                              child_eid_page_delete_flag: false,
                                            },
                                          });
                                          this.child_eid_page.current.value = null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .child_eid_page) && this.state.admissionFormModal
                                          .child_eid_page.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .child_eid_page) && this.state.admissionFormModal
                                              .child_eid_page.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div
                                          onClick={() => window.open(this.state.admissionFormModal.child_eid_page_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <embed
                                            src={this.state.admissionFormModal.child_eid_page_prev}
                                            style={{ width: '100%', height: '100%', pointerEvents: 'none' }}
                                          />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .child_eid_page_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .child_eid_page_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.child_eid_page.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.child_eid_page}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='child_eid_page'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('ID Back')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .child_eid_page_back !== '' &&
                                    this.state.admissionFormModal
                                      .child_eid_page_back_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              child_eid_page_back: '',
                                              child_eid_page_back_prev: '',
                                              child_eid_page_back_delete_flag: false,
                                            },
                                          });
                                          this.child_eid_page_back.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .child_eid_page_back) && this.state.admissionFormModal
                                          .child_eid_page_back.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .child_eid_page_back) && this.state.admissionFormModal
                                              .child_eid_page_back.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .child_eid_page_back_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .child_eid_page_back_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .child_eid_page_back_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.child_eid_page_back.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.child_eid_page_back}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='child_eid_page_back'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Residency')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .child_residency_copy !== '' &&
                                    this.state.admissionFormModal
                                      .child_residency_copy_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              child_residency_copy: '',
                                              child_residency_copy_prev: '',
                                              child_residency_copy_delete_flag: false,
                                            },
                                          });
                                          this.child_residency_copy.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .child_residency_copy) && this.state.admissionFormModal
                                          .child_residency_copy.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .child_residency_copy) && this.state.admissionFormModal
                                              .child_residency_copy.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .child_residency_copy_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .child_residency_copy_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .child_residency_copy_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.child_residency_copy.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.child_residency_copy}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='child_residency_copy'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Passport ID')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal.child_passport !==
                                    '' &&
                                    this.state.admissionFormModal
                                      .child_passport_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              child_passport: '',
                                              child_passport_prev: '',
                                              child_passport_delete_flag: false,
                                            },
                                          });
                                          this.child_passport.current.value = null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .child_passport) && this.state.admissionFormModal
                                          .child_passport.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .child_passport) && this.state.admissionFormModal
                                              .child_passport.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .child_passport_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .child_passport_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .child_passport_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.child_passport.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.child_passport}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='child_passport'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Valid Visa')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal.visa_page !== '' &&
                                    this.state.admissionFormModal.visa_page_prev !==
                                    '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              visa_page: '',
                                              visa_page_prev: '',
                                              visa_page_delete_flag: false,
                                            },
                                          });
                                          this.visa_page.current.value = null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .visa_page) && this.state.admissionFormModal
                                          .visa_page.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .visa_page) && this.state.admissionFormModal
                                              .visa_page.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .visa_page_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .visa_page_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .visa_page_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() => this.visa_page.current.click()}
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.visa_page}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='visa_page'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Birth Certificate')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal.birth_certcopy !==
                                    '' &&
                                    this.state.admissionFormModal
                                      .birth_certcopy_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              birth_certcopy: '',
                                              birth_certcopy_prev: '',
                                              birth_certcopy_delete_flag: false,
                                            },
                                          });
                                          this.birth_certcopy.current.value = null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .birth_certcopy) && this.state.admissionFormModal
                                          .birth_certcopy.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .birth_certcopy) && this.state.admissionFormModal
                                              .birth_certcopy.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .birth_certcopy_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .birth_certcopy_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .birth_certcopy_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.birth_certcopy.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.birth_certcopy}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='birth_certcopy'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Immunization Record')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .vaccination_copy !== '' &&
                                    this.state.admissionFormModal
                                      .vaccination_copy_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              vaccination_copy: '',
                                              vaccination_copy_prev: '',
                                              vaccination_copy_delete_flag: false,
                                            },
                                          });
                                          this.vaccination_copy.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .vaccination_copy) && this.state.admissionFormModal
                                          .vaccination_copy.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .vaccination_copy) && this.state.admissionFormModal
                                              .vaccination_copy.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .vaccination_copy_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .vaccination_copy_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .vaccination_copy_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.vaccination_copy.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.vaccination_copy}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='vaccination_copy'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Medical Insurance Card')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal.med_formcopy !==
                                    '' &&
                                    this.state.admissionFormModal
                                      .med_formcopy_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              med_formcopy: '',
                                              med_formcopy_prev: '',
                                              med_formcopy_delete_flag: false,
                                            },
                                          });
                                          this.med_formcopy.current.value = null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .med_formcopy) && this.state.admissionFormModal
                                          .med_formcopy.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .med_formcopy) && this.state.admissionFormModal
                                              .med_formcopy.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .med_formcopy_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .med_formcopy_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .med_formcopy_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.med_formcopy.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.med_formcopy}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='med_formcopy'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Sponsor Documents')}</h5>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('ID Front')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .father_id_attachment !== '' &&
                                    this.state.admissionFormModal
                                      .father_id_attachment_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              father_id_attachment: '',
                                              father_id_attachment_prev: '',
                                              father_id_attachment_delete_flag: false,
                                            },
                                          });
                                          this.father_id_attachment.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .father_id_attachment) && this.state.admissionFormModal
                                          .father_id_attachment.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .father_id_attachment) && this.state.admissionFormModal
                                              .father_id_attachment.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .father_id_attachment_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .father_id_attachment_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .father_id_attachment_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.father_id_attachment.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.father_id_attachment}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='father_id_attachment'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('ID Back')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .father_id_attachment_back !== '' &&
                                    this.state.admissionFormModal
                                      .father_id_attachment_back_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              father_id_attachment_back: '',
                                              father_id_attachment_back_prev: '',
                                              father_id_attachment_back_delete_flag: false,
                                            },
                                          });
                                          this.father_id_attachment_back.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .father_id_attachment_back) && this.state.admissionFormModal
                                          .father_id_attachment_back.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .father_id_attachment_back) && this.state.admissionFormModal
                                              .father_id_attachment_back.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .father_id_attachment_back_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .father_id_attachment_back_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .father_id_attachment_back_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.father_id_attachment_back.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.father_id_attachment_back}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='father_id_attachment_back'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Passport ID')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .father_passport_attachment !== '' &&
                                    this.state.admissionFormModal
                                      .father_passport_attachment_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              father_passport_attachment: '',
                                              father_passport_attachment_prev: '',
                                              father_passport_attachment_delete_flag: false,
                                            },
                                          });
                                          this.father_passport_attachment.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .father_passport_attachment) && this.state.admissionFormModal
                                          .father_passport_attachment.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .father_passport_attachment) && this.state.admissionFormModal
                                              .father_passport_attachment.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .father_passport_attachment_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .father_passport_attachment_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .father_passport_attachment_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.father_passport_attachment.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.father_passport_attachment}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='father_passport_attachment'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Valid Visa')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .father_visa_attachment !== '' &&
                                    this.state.admissionFormModal
                                      .father_visa_attachment_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              father_visa_attachment: '',
                                              father_visa_attachment_prev: '',
                                              father_visa_attachment_delete_flag: false,
                                            },
                                          });
                                          this.father_visa_attachment.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .father_visa_attachment) && this.state.admissionFormModal
                                          .father_visa_attachment.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .father_visa_attachment) && this.state.admissionFormModal
                                              .father_visa_attachment.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .father_visa_attachment_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .father_visa_attachment_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .father_visa_attachment_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.father_visa_attachment.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.father_visa_attachment}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='father_visa_attachment'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Spouse Documents')}</h5>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('ID Front')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .mother_id_attachment !== '' &&
                                    this.state.admissionFormModal
                                      .mother_id_attachment_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              mother_id_attachment: '',
                                              mother_id_attachment_prev: '',
                                              mother_id_attachment_delete_flag: false,
                                            },
                                          });
                                          this.mother_id_attachment.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .mother_id_attachment) && this.state.admissionFormModal
                                          .mother_id_attachment.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .mother_id_attachment) && this.state.admissionFormModal
                                              .mother_id_attachment.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .mother_id_attachment_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .mother_id_attachment_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .mother_id_attachment_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.mother_id_attachment.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.mother_id_attachment}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='mother_id_attachment'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('ID Back')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .mother_id_attachment_back !== '' &&
                                    this.state.admissionFormModal
                                      .mother_id_attachment_back_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              mother_id_attachment_back: '',
                                              mother_id_attachment_back_prev: '',
                                              mother_id_attachment_back_delete_flag: false,
                                            },
                                          });
                                          this.mother_id_attachment_back.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .mother_id_attachment_back) && this.state.admissionFormModal
                                          .mother_id_attachment_back.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .mother_id_attachment_back) && this.state.admissionFormModal
                                              .mother_id_attachment_back.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .mother_id_attachment_back_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .mother_id_attachment_back_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .mother_id_attachment_back_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.mother_id_attachment_back.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.mother_id_attachment_back}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='mother_id_attachment_back'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Passport ID')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .mother_passport_attachment !== '' &&
                                    this.state.admissionFormModal
                                      .mother_passport_attachment_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              mother_passport_attachment: '',
                                              mother_passport_attachment_prev: '',
                                              mother_passport_attachment_delete_flag: false,
                                            },
                                          });
                                          this.mother_passport_attachment.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .mother_passport_attachment) && this.state.admissionFormModal
                                          .mother_passport_attachment.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .mother_passport_attachment) && this.state.admissionFormModal
                                              .mother_passport_attachment.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .mother_passport_attachment_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .mother_passport_attachment_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .mother_passport_attachment_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.mother_passport_attachment.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.mother_passport_attachment}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='mother_passport_attachment'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Valid Visa')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .mother_visa_attachment !== '' &&
                                    this.state.admissionFormModal
                                      .mother_visa_attachment_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              mother_visa_attachment: '',
                                              mother_visa_attachment_prev: '',
                                              mother_visa_attachment_delete_flag: false,
                                            },
                                          });
                                          this.mother_visa_attachment.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .mother_visa_attachment) && this.state.admissionFormModal
                                          .mother_visa_attachment.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .mother_visa_attachment) && this.state.admissionFormModal
                                              .mother_visa_attachment.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .mother_visa_attachment_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .mother_visa_attachment_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .mother_visa_attachment_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.mother_visa_attachment.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.mother_visa_attachment}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='mother_visa_attachment'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Other Documents')}</h5>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Indemnity Form')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .indemnity_formcopy !== '' &&
                                    this.state.admissionFormModal
                                      .indemnity_formcopy_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              indemnity_formcopy: '',
                                              indemnity_formcopy_prev: '',
                                              indemnity_formcopy_delete_flag: false,
                                            },
                                          });
                                          this.indemnity_formcopy.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .indemnity_formcopy) && this.state.admissionFormModal
                                          .indemnity_formcopy.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .indemnity_formcopy) && this.state.admissionFormModal
                                              .indemnity_formcopy.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .indemnity_formcopy_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .indemnity_formcopy_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .indemnity_formcopy_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.indemnity_formcopy.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.indemnity_formcopy}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='indemnity_formcopy'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Child Last Year Report')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .child_lastyear_report !== '' &&
                                    this.state.admissionFormModal
                                      .child_lastyear_report_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              child_lastyear_report: '',
                                              child_lastyear_report_prev: '',
                                              child_lastyear_report_delete_flag: false,
                                            },
                                          });
                                          this.child_lastyear_report.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .child_lastyear_report) && this.state.admissionFormModal
                                          .child_lastyear_report.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .child_lastyear_report) && this.state.admissionFormModal
                                              .child_lastyear_report.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .child_lastyear_report_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .child_lastyear_report_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .child_lastyear_report_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.child_lastyear_report.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.child_lastyear_report}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='child_lastyear_report'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Child Transfer Document')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .child_transfer_doc !== '' &&
                                    this.state.admissionFormModal
                                      .child_transfer_doc_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              child_transfer_doc: '',
                                              child_transfer_doc_prev: '',
                                              child_transfer_doc_delete_flag: false,
                                            },
                                          });
                                          this.child_transfer_doc.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .child_transfer_doc) && this.state.admissionFormModal
                                          .child_transfer_doc.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .child_transfer_doc) && this.state.admissionFormModal
                                              .child_transfer_doc.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .child_transfer_doc_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .child_transfer_doc_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .child_transfer_doc_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.child_transfer_doc.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.child_transfer_doc}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='child_transfer_doc'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Sponsor NOC')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .sponsor_noc !== '' &&
                                    this.state.admissionFormModal
                                      .sponsor_noc_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              sponsor_noc: '',
                                              sponsor_noc_prev: '',
                                              sponsor_noc_delete_flag: false,
                                            },
                                          });
                                          this.sponsor_noc.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .sponsor_noc) && this.state.admissionFormModal
                                          .sponsor_noc.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .sponsor_noc) && this.state.admissionFormModal
                                              .sponsor_noc.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .sponsor_noc_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .sponsor_noc_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .sponsor_noc_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.sponsor_noc.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.sponsor_noc}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='sponsor_noc'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Document 1')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .document1 !== '' &&
                                    this.state.admissionFormModal
                                      .document1_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              document1: '',
                                              document1_prev: '',
                                              document1_delete_flag: false,
                                            },
                                          });
                                          this.document1.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .document1) && this.state.admissionFormModal
                                          .document1.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .document1) && this.state.admissionFormModal
                                              .document1.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .document1_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .document1_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .document1_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.document1.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.document1}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='document1'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Document 2')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .document2 !== '' &&
                                    this.state.admissionFormModal
                                      .document2_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              document2: '',
                                              document2_prev: '',
                                              document2_delete_flag: false,
                                            },
                                          });
                                          this.document2.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .document2) && this.state.admissionFormModal
                                          .document2.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .document2) && this.state.admissionFormModal
                                              .document2.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .document2_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .document2_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .document2_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.document2.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.document2}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='document2'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Document 3')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .document3 !== '' &&
                                    this.state.admissionFormModal
                                      .document3_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              document3: '',
                                              document3_prev: '',
                                              document3_delete_flag: false,
                                            },
                                          });
                                          this.document3.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .document3) && this.state.admissionFormModal
                                          .document3.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .document3) && this.state.admissionFormModal
                                              .document3.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .document3_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .document3_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .document3_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.document3.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.document3}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='document3'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Document 4')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .document4 !== '' &&
                                    this.state.admissionFormModal
                                      .document4_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              document4: '',
                                              document4_prev: '',
                                              document4_delete_flag: false,
                                            },
                                          });
                                          this.document4.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .document4) && this.state.admissionFormModal
                                          .document4.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .document4) && this.state.admissionFormModal
                                              .document4.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .document4_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .document4_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .document4_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.document4.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.document4}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='document4'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Document 5')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .document5 !== '' &&
                                    this.state.admissionFormModal
                                      .document5_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              document5: '',
                                              document5_prev: '',
                                              document5_delete_flag: false,
                                            },
                                          });
                                          this.document5.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .document5) && this.state.admissionFormModal
                                          .document5.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .document5) && this.state.admissionFormModal
                                              .document5.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .document5_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .document5_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .document5_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.document5.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.document5}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='document5'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Prev School Report')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .prev_school_rep_doc !== '' &&
                                    this.state.admissionFormModal
                                      .prev_school_rep_doc_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              prev_school_rep_doc: '',
                                              prev_school_rep_doc_prev: '',
                                              prev_school_rep_doc_delete_flag: false,
                                            },
                                          });
                                          this.prev_school_rep_doc.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .prev_school_rep_doc) && this.state.admissionFormModal
                                          .prev_school_rep_doc.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .prev_school_rep_doc) && this.state.admissionFormModal
                                              .prev_school_rep_doc.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .prev_school_rep_doc_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .prev_school_rep_doc_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .prev_school_rep_doc_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.prev_school_rep_doc.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.prev_school_rep_doc}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='prev_school_rep_doc'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Family Card')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal
                                    .family_card_doc !== '' &&
                                    this.state.admissionFormModal
                                      .family_card_doc_prev !== '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              family_card_doc: '',
                                              family_card_doc_prev: '',
                                              family_card_doc_delete_flag: false,
                                            },
                                          });
                                          this.family_card_doc.current.value =
                                            null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      {((Array.isArray(this.state.admissionFormModal
                                        .family_card_doc) && this.state.admissionFormModal
                                          .family_card_doc.type.includes('pdf')) || (!Array.isArray(this.state.admissionFormModal
                                            .family_card_doc) && this.state.admissionFormModal
                                              .family_card_doc.toString().toLowerCase().indexOf(".pdf") >= 0))
                                        ? (<div className="d-flex justify-content-center align-items-center"
                                          onClick={() => window.open(this.state.admissionFormModal
                                            .family_card_doc_prev)}
                                          style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
                                          <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: 50, color: '#dc3545' }} />
                                        </div>)
                                        : (<img src={this.state.admissionFormModal
                                          .family_card_doc_prev} onClick={() => window.open(this.state.admissionFormModal
                                            .family_card_doc_prev)} alt={t('Preview')} width='100' className="cursor-pointer" />)}
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        this.family_card_doc.current.click()
                                      }
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.family_card_doc}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='family_card_doc'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_three' && (
                        <Row className='m-0'>
                          <Col md={12}>
                            <h5>{t('About Your Child')}</h5>
                          </Col>
                          <Col md={2}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Position in family')}</Form.Label>
                              <Select
                                value={
                                  this.state.admissionFormModal
                                    .child_position_family
                                }
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={[
                                  { value: '1st Child', label: '1st Child' },
                                  { value: '2nd Child', label: '2nd Child' },
                                  { value: '3rd Child', label: '3rd Child' },
                                  { value: '4th Child', label: '4th Child' },
                                  { value: '5th Child', label: '5th Child' },
                                  { value: 'Other', label: 'Other' },
                                ]}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_position_family: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={5}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Has your child previously or is currently attending other settings?'
                                )}
                              </Form.Label>
                              <Select
                                value={
                                  this.state.admissionFormModal.child_prev_settings
                                }
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={[
                                  {
                                    value: 'Parents & toddlers',
                                    label: 'Parents & toddlers',
                                  },
                                  { value: 'Playground', label: 'Playground' },
                                  {
                                    value: 'Private nursery',
                                    label: 'Private nursery',
                                  },
                                  { value: 'Nanny', label: 'Nanny' },
                                ]}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_prev_settings: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={5}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Please name setting and number of hours/sessions attending'
                                )}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_prev_settings_details
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_prev_settings_details: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t("What is your child's first language?")}
                              </Form.Label>
                              <Select
                                value={this.state.admissionFormModal.first_lang}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={this.state.languages}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      first_lang: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t("What is your child's second language?")}
                              </Form.Label>
                              <Select
                                value={this.state.admissionFormModal.second_lang}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={this.state.languages}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      second_lang: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t("What is your child's third language?")}
                              </Form.Label>
                              <Select
                                value={this.state.admissionFormModal.third_lang}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={this.state.languages}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      third_lang: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t('Additional languages spoken at home')}
                              </Form.Label>
                              <Select
                                value={this.state.admissionFormModal.home_language}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={this.state.languages}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      home_language: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Additional requirements about religious observation, food, clothing?'
                                )}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_religion_food_clothing_desc
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_religion_food_clothing_desc:
                                        e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Previous Enroll')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0 pt-2'>
                                <Form.Check
                                  type='switch'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        previous_enroll:
                                          this.state.admissionFormModal
                                            .previous_enroll == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.previous_enroll == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Transport Required')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0 pt-2'>
                                <Form.Check
                                  type='switch'
                                  id='transport_required'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        transport_required:
                                          this.state.admissionFormModal
                                            .transport_required == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.transport_required == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t('Transport Additional Details?')}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .transport
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      transport:
                                        e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Dietary Requirements')}</h5>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t('What milk does your child take?')}
                              </Form.Label>
                              <Select
                                value={
                                  this.state.admissionFormModal.child_diet_milktype
                                }
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={[
                                  { value: "Not Applicable", label: "Not Applicable" },
                                  { value: "Cow's", label: "Cow's" },
                                  { value: 'Breast', label: 'Breast' },
                                  { value: 'Formula', label: 'Formula' },
                                ]}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_diet_milktype: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Quantity (ml)')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_diet_milktype_qty
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_diet_milktype_qty: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Frequency')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_diet_milktype_freq
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_diet_milktype_freq: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  "Is there a limit to the quantity of cow's milk given whilst at the setting?"
                                )}{' '}
                                <em>{t('(please specify)')}</em>
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_diet_milktype_preparation
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_diet_milktype_preparation:
                                        e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12} className='pt-3'>
                            <p className='mb-0'>
                              {t('Which weaning foods do you normally use?')}{' '}
                              <em>{t('(please specify)')}</em>
                            </p>
                          </Col>
                          <Col md={6}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Weaning foods')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.child_weaningfood
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_weaningfood: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Volume')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_weaningfood_volume
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_weaningfood_volume: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Frequency')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_weaningfood_freq
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_weaningfood_freq: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12} className='pt-3'>
                            <p className='mb-0'>
                              {t(
                                'If your child is weaned, please describe the types of food given'
                              )}{' '}
                              <em>{t('(please specify)')}</em>
                            </p>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Snacks')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_weaningfood_snack
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_weaningfood_snack: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Main course')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_weaningfood_maincourse
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_weaningfood_maincourse: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Puddings')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_weaningfood_puddings
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_weaningfood_puddings: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t('At what time does your child sleep?')}
                              </Form.Label>
                              <Form.Control
                                type='time'
                                defaultValue={
                                  this.state.admissionFormModal.child_sleep_time
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_sleep_time: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t('For how long does your child sleep? (Hours)')}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.child_sleep_mins
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_sleep_mins: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t('Does your child have any special comforters?')}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_sleep_comforters
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_sleep_comforters: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Personal Development')}</h5>
                          </Col>
                          <Col md={12}>
                            <p>
                              {t('Is your child able to use the toilet?')}{' '}
                              <em>{t('(please select one option from each)')}</em>
                            </p>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Select
                                value={
                                  this.state.admissionFormModal.child_use_toilet_0
                                }
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={[
                                  { value: 'Unaided', label: 'Unaided' },
                                  {
                                    value: 'Requires assistance',
                                    label: 'Requires assistance',
                                  },
                                  {
                                    value: 'Requires reminding',
                                    label: 'Requires reminding',
                                  },
                                ]}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_use_toilet_0: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Select
                                value={
                                  this.state.admissionFormModal.child_use_toilet_1
                                }
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={[
                                  { value: 'In nappies', label: 'In nappies' },
                                  { value: 'In pull-ups', label: 'In pull-ups' },
                                  { value: 'none', label: 'none' },
                                ]}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_use_toilet_1: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Select
                                value={
                                  this.state.admissionFormModal.child_use_toilet_2
                                }
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={[
                                  {
                                    value: 'Able to wash own hands',
                                    label: 'Able to wash own hands',
                                  },
                                  {
                                    value: 'Not able to wash own hands',
                                    label: 'Not able to wash own hands',
                                  },
                                ]}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_use_toilet_2: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t('Is your child able to drink from an open cup?')}
                              </Form.Label>
                              <div className='p-3 pb-0'>
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={t('No')}
                                  name='child_use_drinkcup'
                                  type='radio'
                                  id='child_use_drinkcup_1'
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_use_drinkcup: 'No',
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal
                                      .child_use_drinkcup == 'No'
                                  }
                                />
                                <Form.Check
                                  inline
                                  label={t('Yes')}
                                  name='child_use_drinkcup'
                                  type='radio'
                                  id='child_use_drinkcup_2'
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_use_drinkcup: 'Yes',
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal
                                      .child_use_drinkcup == 'Yes'
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Is your child able to use a spoon, knife & fork?'
                                )}
                              </Form.Label>
                              <Select
                                value={
                                  this.state.admissionFormModal.child_use_cutlery
                                }
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  control: (base) => ({
                                    ...base,
                                    ...styleV3_1.reactSelect
                                  })
                                }}
                                options={[
                                  { value: 'Unaided', label: 'Unaided' },
                                  {
                                    value: 'With assistance',
                                    label: 'With assistance',
                                  },
                                  { value: 'No', label: 'No' },
                                ]}
                                onChange={(obj) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_use_cutlery: obj,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Emotional Development')}</h5>
                          </Col>
                          <Col md={4} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Does your child relate well to other children?'
                                )}
                              </Form.Label>
                              <div className='p-3 pb-0'>
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={t('No')}
                                  name='child_relate_children'
                                  type='radio'
                                  id='child_relate_children_1'
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_relate_children: 0,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal
                                      .child_relate_children == 0
                                  }
                                />
                                <Form.Check
                                  inline
                                  label={t('Yes')}
                                  name='child_relate_children'
                                  type='radio'
                                  id='child_relate_children_2'
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_relate_children: 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal
                                      .child_relate_children == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Does your child relate well to familiar adults?'
                                )}
                              </Form.Label>
                              <div className='p-3 pb-0'>
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={t('No')}
                                  name='child_relate_familiar_adults'
                                  type='radio'
                                  id='child_relate_familiar_adults_1'
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_relate_familiar_adults: 0,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal
                                      .child_relate_familiar_adults == 0
                                  }
                                />
                                <Form.Check
                                  inline
                                  label={t('Yes')}
                                  name='child_relate_familiar_adults'
                                  type='radio'
                                  id='child_relate_familiar_adults_2'
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_relate_familiar_adults: 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal
                                      .child_relate_familiar_adults == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t('Is your child able to share and take turns?')}
                              </Form.Label>
                              <div className='p-3 pb-0'>
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={t('No')}
                                  name='child_take_turns'
                                  type='radio'
                                  id='child_take_turns_1'
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_take_turns: 0,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal
                                      .child_take_turns == 0
                                  }
                                />
                                <Form.Check
                                  inline
                                  label={t('Yes')}
                                  name='child_take_turns'
                                  type='radio'
                                  id='child_take_turns_2'
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_take_turns: 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal
                                      .child_take_turns == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Enjoyment and Curiosity')}</h5>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t("What are your child's favourite toys?")}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.child_toys
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_toys: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'What activities does your child most enjoy doing?'
                                )}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.child_activities
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_activities: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Is there anything that may cause undue distress to your child?'
                                )}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.child_distress
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_distress: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Is there additional information regarding your child/individual care plan which you would like to share with the setting?'
                                )}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.child_extra_info
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_extra_info: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_four' && (
                        <Row className='m-0'>
                          <Col md={12}>
                            <p>
                              {t(
                                'Give consent for photographs being taken of my child for use within:'
                              )}
                            </p>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Printing')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0'>
                                <Form.Check
                                  type='switch'
                                  id='pic_social'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        pic_social:
                                          this.state.admissionFormModal
                                            .pic_social == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.pic_social == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Advertising')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0'>
                                <Form.Check
                                  type='switch'
                                  id='pic_media'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        pic_media:
                                          this.state.admissionFormModal.pic_media ==
                                            1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.pic_media == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Social Media / Webiste')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0'>
                                <Form.Check
                                  type='switch'
                                  id='pic_nursery'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        pic_nursery:
                                          this.state.admissionFormModal
                                            .pic_nursery == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.pic_nursery == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Educore App')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0'>
                                <Form.Check
                                  type='switch'
                                  id='take_pictures'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        take_pictures:
                                          this.state.admissionFormModal
                                            .take_pictures == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.take_pictures == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Allow Picture')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0'>
                                <Form.Check
                                  type='switch'
                                  id='allow_pic'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        allow_pic:
                                          this.state.admissionFormModal
                                            .allow_pic == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.allow_pic == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_five' && (
                        <Row className='m-0'>
                          <Col md={12}>
                            <h5>{t('Health Declaration Form')}</h5>
                          </Col>
                          <Col md={12}>
                            <p className='mb-0'>
                              {t(
                                'Does your child suffer from any chronic illness?'
                              )}
                            </p>
                          </Col>
                          <Col md={12}>
                            <Row>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Chronic Disease')}</Form.Label>
                                  <Select
                                    value={
                                      this.state.admissionFormModal.childChronic
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (base) => ({
                                        ...base,
                                        ...styleV3_1.reactSelect
                                      })
                                    }}
                                    options={this.state.ddl_illnesses}
                                    onChange={(obj) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childChronic: obj,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>
                                    {t('Info, Treatments, Medications')}
                                  </Form.Label>
                                  <Form.Control
                                    type='text'
                                    value={
                                      this.state.admissionFormModal.childChronicDesc
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childChronicDesc: e.target.value,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Date')}</Form.Label>
                                  <Flatpickr
                                    options={{
                                      static: true,
                                    }}
                                    className='form-control'
                                    value={
                                      this.state.admissionFormModal.childChronicDate
                                    }
                                    onChange={([date]) => {
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childChronicDate:
                                            moment(date).format('YYYY-MM-DD'),
                                        },
                                      });
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={1}>
                                <Form.Group
                                  className='mb-2'
                                  style={{ paddingTop: 23 }}>
                                  <Button
                                    disabled={
                                      !this.state.admissionFormModal.childChronic ||
                                      !this.state.admissionFormModal
                                        .childChronicDesc ||
                                      !this.state.admissionFormModal
                                        .childChronicDate
                                    }
                                    onClick={() => this.addChronic()}
                                    variant='success'
                                    className='me-1'>
                                    <FontAwesomeIcon icon={faPlus} />
                                  </Button>
                                </Form.Group>
                              </Col>
                            </Row>
                            {this.state.admissionFormModal.childChronics.map(
                              (item, index) => (
                                <Row key={index}>
                                  <Col md={3} className='p-3'>
                                    {item.illness}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.desc}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.date}
                                  </Col>
                                  <Col md={1}>
                                    <Form.Group
                                      className='mb-2'
                                      style={{ paddingTop: 10 }}>
                                      <Button
                                        onClick={() =>
                                          this.deleteMedicalRecord(
                                            index,
                                            'childChronics'
                                          )
                                        }
                                        variant='danger'
                                        className='me-1'>
                                        <FontAwesomeIcon icon={faTrash} />
                                      </Button>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              )
                            )}
                          </Col>
                          {/* <Col md={12}>
                        <hr />
                      </Col>
                      <Col md={5} className='ps-0'>
                        <Form.Group className='mb-2'>
                          <Form.Label>
                            {t(
                              'Has anyone in your household been diagnosed with COVID-19?'
                            )}
                          </Form.Label>
                          <div className='p-3 pb-0'>
                            <Form.Check
                              className='me-4'
                              inline
                              label={t('No')}
                              name='radio_covid_diagnosed_family'
                              type='radio'
                              id='radio_covid_diagnosed_family_1'
                              onChange={(e) =>
                                this.setState({
                                  admissionFormModal: {
                                    ...this.state.admissionFormModal,
                                    radio_covid_diagnosed_family: 0,
                                  },
                                })
                              }
                              checked={
                                this.state.admissionFormModal
                                  .radio_covid_diagnosed_family == 0
                              }
                            />
                            <Form.Check
                              inline
                              label={t('Yes')}
                              name='radio_covid_diagnosed_family'
                              type='radio'
                              id='radio_covid_diagnosed_family_2'
                              onChange={(e) =>
                                this.setState({
                                  admissionFormModal: {
                                    ...this.state.admissionFormModal,
                                    radio_covid_diagnosed_family: 1,
                                  },
                                })
                              }
                              checked={
                                this.state.admissionFormModal
                                  .radio_covid_diagnosed_family == 1
                              }
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group className='mb-2'>
                          <Form.Label>{t('If yes, when?')}</Form.Label>
                          <Flatpickr
                            options={{
                              static: true,
                            }}
                            className='form-control'
                            value={
                              this.state.admissionFormModal.childChronicDate
                            }
                            onChange={([date]) => {
                              this.setState({
                                admissionFormModal: {
                                  ...this.state.admissionFormModal,
                                  covid_diagnosed_family:
                                    moment(date).format('YYYY-MM-DD'),
                                },
                              });
                            }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={12} className='ps-0'>
                        <Form.Group className='mb-2'>
                          <Form.Label>
                            {t(
                              'Has your child, in the past 14 days, come in close contact with someone diagnosed with COVID-19?'
                            )}
                          </Form.Label>
                          <div className='p-3 pb-0'>
                            <Form.Check
                              className='me-4'
                              inline
                              label={t('No')}
                              name='covid_close_contact'
                              type='radio'
                              id='covid_close_contact_1'
                              onChange={(e) =>
                                this.setState({
                                  admissionFormModal: {
                                    ...this.state.admissionFormModal,
                                    covid_close_contact: 0,
                                  },
                                })
                              }
                              checked={
                                this.state.admissionFormModal
                                  .covid_close_contact == 0
                              }
                            />
                            <Form.Check
                              inline
                              label={t('Yes')}
                              name='covid_close_contact'
                              type='radio'
                              id='covid_close_contact_2'
                              onChange={(e) =>
                                this.setState({
                                  admissionFormModal: {
                                    ...this.state.admissionFormModal,
                                    covid_close_contact: 1,
                                  },
                                })
                              }
                              checked={
                                this.state.admissionFormModal
                                  .covid_close_contact == 1
                              }
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={12} className='ps-0'>
                        <Form.Group className='mb-2'>
                          <Form.Label>
                            {t(
                              'Has your child has had any fever or respiratory symptoms "coughing, sneezing, loss of sense of smell or taste, trouble breathing, headache, sore throat, runny or stuffy nose, vomiting or diarrhea" in the past 3 days?'
                            )}
                          </Form.Label>
                          <div className='p-3 pb-0'>
                            <Form.Check
                              className='me-4'
                              inline
                              label={t('No')}
                              name='covid_symptoms'
                              type='radio'
                              id='covid_symptoms_1'
                              onChange={(e) =>
                                this.setState({
                                  admissionFormModal: {
                                    ...this.state.admissionFormModal,
                                    covid_symptoms: 0,
                                  },
                                })
                              }
                              checked={
                                this.state.admissionFormModal.covid_symptoms ==
                                0
                              }
                            />
                            <Form.Check
                              inline
                              label={t('Yes')}
                              name='covid_symptoms'
                              type='radio'
                              id='covid_symptoms_2'
                              onChange={(e) =>
                                this.setState({
                                  admissionFormModal: {
                                    ...this.state.admissionFormModal,
                                    covid_symptoms: 1,
                                  },
                                })
                              }
                              checked={
                                this.state.admissionFormModal.covid_symptoms ==
                                1
                              }
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6} className='ps-0'>
                        <Form.Group className='mb-2'>
                          <Form.Label>
                            {t(
                              'Has anyone in your household traveled to any other country in the past 21 days?'
                            )}
                          </Form.Label>
                          <div className='p-3 pb-0'>
                            <Form.Check
                              className='me-4'
                              inline
                              label={t('No')}
                              name='radio_covid_international_travel'
                              type='radio'
                              id='radio_covid_international_travel_1'
                              onChange={(e) =>
                                this.setState({
                                  admissionFormModal: {
                                    ...this.state.admissionFormModal,
                                    radio_covid_international_travel: 'No',
                                  },
                                })
                              }
                              checked={
                                this.state.admissionFormModal
                                  .radio_covid_international_travel == 'No'
                              }
                            />
                            <Form.Check
                              inline
                              label={t('Yes')}
                              name='radio_covid_international_travel'
                              type='radio'
                              id='radio_covid_international_travel_2'
                              onChange={(e) =>
                                this.setState({
                                  admissionFormModal: {
                                    ...this.state.admissionFormModal,
                                    radio_covid_international_travel: 'Yes',
                                  },
                                })
                              }
                              checked={
                                this.state.admissionFormModal
                                  .radio_covid_international_travel == 'Yes'
                              }
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group className='mb-2'>
                          <Form.Label>{t('If yes then specify')}</Form.Label>
                          <Form.Control
                            type='text'
                            defaultValue={
                              this.state.admissionFormModal
                                .covid_international_travel
                            }
                            onChange={(e) =>
                              this.setState({
                                admissionFormModal: {
                                  ...this.state.admissionFormModal,
                                  covid_international_travel: e.target.value,
                                },
                              })
                            }
                          />
                        </Form.Group>
                      </Col> */}
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Medical Emergency')}</h5>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Contact Name')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .medical_emergency_name
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      medical_emergency_name: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Family Doctor')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .medical_emergency_doc
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      medical_emergency_doc: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Clinic Name')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .medical_emergency_clinic
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      medical_emergency_clinic: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Contact Number')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .medical_emergency_phone
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      medical_emergency_phone: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Other')}</h5>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Child SEN')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0 pt-2'>
                                <Form.Check
                                  type='switch'
                                  id='child_sen'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_sen:
                                          this.state.admissionFormModal
                                            .child_sen == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.child_sen == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Medicines')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .medicines
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      medicines: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Allergies')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .allergies
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      allergies: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Health Condition')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0 pt-2'>
                                <Form.Check
                                  type='switch'
                                  id='health_condition'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        health_condition:
                                          this.state.admissionFormModal
                                            .health_condition == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.health_condition == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Blood Group')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .bloodgroup
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      bloodgroup: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Weight')}</Form.Label>
                              <Form.Control
                                type='number'
                                max={999}
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_weight
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_weight: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Height')}</Form.Label>
                              <Form.Control
                                type='number'
                                max={999}
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_height
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_height: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Health Insurance No.')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .health_insurance_num
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      health_insurance_num: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Health Insurance Company')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .health_insurance_company
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      health_insurance_company: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Health Insurance Type')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .health_insurance_type
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      health_insurance_type: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Medical File No.')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .medical_emergency_fileno
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      medical_emergency_fileno: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Evaluated By')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .child_evaluated_by
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      child_evaluated_by: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}></Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Admin Medication 1')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0 pt-2'>
                                <Form.Check
                                  type='switch'
                                  id='admin_medication_1'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        admin_medication_1:
                                          this.state.admissionFormModal
                                            .admin_medication_1 == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.admin_medication_1 == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Admin Medication 2')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0 pt-2'>
                                <Form.Check
                                  type='switch'
                                  id='admin_medication_2'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        admin_medication_2:
                                          this.state.admissionFormModal
                                            .admin_medication_2 == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.admin_medication_2 == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Medical Examination')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0 pt-2'>
                                <Form.Check
                                  type='switch'
                                  id='medical_examination'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        medical_examination:
                                          this.state.admissionFormModal
                                            .medical_examination == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.medical_examination == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('EEmergency Treatment')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0 pt-2'>
                                <Form.Check
                                  type='switch'
                                  id='emergency_treatment'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        emergency_treatment:
                                          this.state.admissionFormModal
                                            .emergency_treatment == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.emergency_treatment == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Medical Note')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .medical_note
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      medical_note: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Special Disabilities')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .special_disabilities
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      special_disabilities: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_six' && (
                        <Row className='m-0'>
                          <Col md={12}>
                            <h5>{t('Food & Other Allergy')}</h5>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className="mb-2">
                              <Form.Label>{t('Known Allergies')}</Form.Label>
                              <div className="p-3 pb-0">
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={t('No')}
                                  name="radio_leela_allergies"
                                  type='radio'
                                  id='radio_leela_allergies_1'
                                  onChange={(e) => this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      radio_leela_allergies: 'No'
                                    }
                                  })}
                                  checked={this.state.admissionFormModal.radio_leela_allergies == 'No'}
                                />
                                <Form.Check
                                  inline
                                  label={t('Yes')}
                                  name="radio_leela_allergies"
                                  type='radio'
                                  id='radio_leela_allergies_2'
                                  onChange={(e) => this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      radio_leela_allergies: 'Yes'
                                    }
                                  })}
                                  checked={this.state.admissionFormModal.radio_leela_allergies == 'Yes'}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('If yes then specify')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.leela_allergies
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      leela_allergies: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}></Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className="mb-2">
                              <Form.Label>{t('Dietary Intolerance')}</Form.Label>
                              <div className="p-3 pb-0">
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={t('No')}
                                  name="radio_leela_dietry_intolerances"
                                  type='radio'
                                  id='radio_leela_dietry_intolerances_1'
                                  onChange={(e) => this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      radio_leela_dietry_intolerances: 'No'
                                    }
                                  })}
                                  checked={this.state.admissionFormModal.radio_leela_dietry_intolerances == 'No'}
                                />
                                <Form.Check
                                  inline
                                  label={t('Yes')}
                                  name="radio_leela_dietry_intolerances"
                                  type='radio'
                                  id='radio_leela_dietry_intolerances_2'
                                  onChange={(e) => this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      radio_leela_dietry_intolerances: 'Yes'
                                    }
                                  })}
                                  checked={this.state.admissionFormModal.radio_leela_dietry_intolerances == 'Yes'}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('If yes then specify')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal
                                    .leela_dietry_intolerances
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      leela_dietry_intolerances: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={4}></Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className="mb-2">
                              <Form.Label>{t('Special Requirements')}</Form.Label>
                              <div className="p-3 pb-0">
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={t('No')}
                                  name="radio_leela_special_req"
                                  type='radio'
                                  id='radio_leela_special_req_1'
                                  onChange={(e) => this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      radio_leela_special_req: 'No'
                                    }
                                  })}
                                  checked={this.state.admissionFormModal.radio_leela_special_req == 'No'}
                                />
                                <Form.Check
                                  inline
                                  label={t('Yes')}
                                  name="radio_leela_special_req"
                                  type='radio'
                                  id='radio_leela_special_req_2'
                                  onChange={(e) => this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      radio_leela_special_req: 'Yes'
                                    }
                                  })}
                                  checked={this.state.admissionFormModal.radio_leela_special_req == 'Yes'}
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('If yes then specify')}</Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.leela_special_req
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      leela_special_req: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Allergy Alert')}</h5>
                          </Col>
                          <Col md={6}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Does your child have any known allergies? (please specify)'
                                )}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.allergies
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      allergies: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className='mb-2'>
                              <Form.Label>
                                {t(
                                  'Does your child have anaphylactic reactions to allergies? (please specify)'
                                )}
                              </Form.Label>
                              <Form.Control
                                type='text'
                                defaultValue={
                                  this.state.admissionFormModal.allergic_reactions
                                }
                                onChange={(e) =>
                                  this.setState({
                                    admissionFormModal: {
                                      ...this.state.admissionFormModal,
                                      allergic_reactions: e.target.value,
                                    },
                                  })
                                }
                              />
                            </Form.Group>
                          </Col>
                          <Col md={2} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Food Tasting')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0'>
                                <Form.Check
                                  type='switch'
                                  id='food_tasting'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        food_tasting:
                                          this.state.admissionFormModal
                                            .food_tasting == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.food_tasting == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_seven' && (
                        <Row className='m-0'>
                          <Col md={12}>
                            <h5>{t('Certificate of Immunization')}</h5>
                          </Col>
                          <Col md={12}>
                            <p className='mb-0'>
                              {t(
                                "Kindly indicate the immunization your child has received. Please attach a photocopy of your child's immunization record for verification."
                              )}
                            </p>
                          </Col>
                          <Col md={12}>
                            <Row>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Vaccine')}</Form.Label>
                                  <Select
                                    value={
                                      this.state.admissionFormModal
                                        .childImmuneVaccine
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (base) => ({
                                        ...base,
                                        ...styleV3_1.reactSelect
                                      })
                                    }}
                                    options={this.state.vaccines}
                                    onChange={(obj) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childImmuneVaccine: obj,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Dose')}</Form.Label>
                                  <Select
                                    value={
                                      this.state.admissionFormModal.childImmuneDose
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (base) => ({
                                        ...base,
                                        ...styleV3_1.reactSelect
                                      })
                                    }}
                                    options={[
                                      { value: '1st', label: '1st' },
                                      { value: '2nd', label: '2nd' },
                                      { value: '3rd', label: '3rd' },
                                      { value: '4th', label: '4th' },
                                      { value: '5th', label: '5th' },
                                    ]}
                                    onChange={(obj) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childImmuneDose: obj,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Date')}</Form.Label>
                                  <Flatpickr
                                    options={{
                                      static: true,
                                    }}
                                    className='form-control'
                                    value={
                                      this.state.admissionFormModal.childImmuneDate
                                    }
                                    onChange={([date]) => {
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childImmuneDate:
                                            moment(date).format('YYYY-MM-DD'),
                                        },
                                      });
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={1}>
                                <Form.Group
                                  className='mb-2'
                                  style={{ paddingTop: 23 }}>
                                  <Button
                                    disabled={
                                      !this.state.admissionFormModal
                                        .childImmuneVaccine ||
                                      !this.state.admissionFormModal
                                        .childImmuneDose ||
                                      !this.state.admissionFormModal.childImmuneDate
                                    }
                                    onClick={() => this.addImmunization()}
                                    variant='success'
                                    className='me-1'>
                                    <FontAwesomeIcon icon={faPlus} />
                                  </Button>
                                </Form.Group>
                              </Col>
                            </Row>
                            {this.state.admissionFormModal.childImmunizations.map(
                              (item, index) => (
                                <Row key={index}>
                                  <Col md={3} className='p-3'>
                                    {item.vaccine_name}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.dose_number}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.dose_date}
                                  </Col>
                                  <Col md={1}>
                                    <Form.Group
                                      className='mb-2'
                                      style={{ paddingTop: 10 }}>
                                      <Button
                                        onClick={() =>
                                          this.deleteMedicalRecord(
                                            index,
                                            'childImmunizations'
                                          )
                                        }
                                        variant='danger'
                                        className='me-1'>
                                        <FontAwesomeIcon icon={faTrash} />
                                      </Button>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              )
                            )}
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Child Illness')}</h5>
                          </Col>
                          <Col md={12}>
                            <Row>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Illness')}</Form.Label>
                                  <Select
                                    value={
                                      this.state.admissionFormModal.childIllness
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (base) => ({
                                        ...base,
                                        ...styleV3_1.reactSelect
                                      })
                                    }}
                                    options={this.state.ddl_illnesses}
                                    onChange={(obj) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childIllness: obj,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>
                                    {t('Treatments, Medications')}
                                  </Form.Label>
                                  <Form.Control
                                    type='text'
                                    value={
                                      this.state.admissionFormModal.childIllnessDesc
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childIllnessDesc: e.target.value,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Date')}</Form.Label>
                                  <Flatpickr
                                    options={{
                                      static: true,
                                    }}
                                    className='form-control'
                                    value={
                                      this.state.admissionFormModal.childIllnessDate
                                    }
                                    onChange={([date]) => {
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childIllnessDate:
                                            moment(date).format('YYYY-MM-DD'),
                                        },
                                      });
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={1}>
                                <Form.Group
                                  className='mb-2'
                                  style={{ paddingTop: 23 }}>
                                  <Button
                                    disabled={
                                      !this.state.admissionFormModal.childIllness ||
                                      !this.state.admissionFormModal
                                        .childIllnessDesc ||
                                      !this.state.admissionFormModal
                                        .childIllnessDate
                                    }
                                    onClick={() => this.addIllness()}
                                    variant='success'
                                    className='me-1'>
                                    <FontAwesomeIcon icon={faPlus} />
                                  </Button>
                                </Form.Group>
                              </Col>
                            </Row>
                            {this.state.admissionFormModal.childIllnesses.map(
                              (item, index) => (
                                <Row key={index}>
                                  <Col md={3} className='p-3'>
                                    {item.illness}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.desc}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.date}
                                  </Col>
                                  <Col md={1}>
                                    <Form.Group
                                      className='mb-2'
                                      style={{ paddingTop: 10 }}>
                                      <Button
                                        onClick={() =>
                                          this.deleteMedicalRecord(
                                            index,
                                            'childIllnesses'
                                          )
                                        }
                                        variant='danger'
                                        className='me-1'>
                                        <FontAwesomeIcon icon={faTrash} />
                                      </Button>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              )
                            )}
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Child Allergies')}</h5>
                          </Col>
                          <Col md={12}>
                            <Row>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Allergy')}</Form.Label>
                                  <Select
                                    value={
                                      this.state.admissionFormModal.childAllergy
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (base) => ({
                                        ...base,
                                        ...styleV3_1.reactSelect
                                      })
                                    }}
                                    options={this.state.ddl_allergies}
                                    onChange={(obj) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childAllergy: obj,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>
                                    {t('Treatments, Medications')}
                                  </Form.Label>
                                  <Form.Control
                                    type='text'
                                    value={
                                      this.state.admissionFormModal.childAllergyDesc
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childAllergyDesc: e.target.value,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Date')}</Form.Label>
                                  <Flatpickr
                                    options={{
                                      static: true,
                                    }}
                                    className='form-control'
                                    value={
                                      this.state.admissionFormModal.childAllergyDate
                                    }
                                    onChange={([date]) => {
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childAllergyDate:
                                            moment(date).format('YYYY-MM-DD'),
                                        },
                                      });
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={1}>
                                <Form.Group
                                  className='mb-2'
                                  style={{ paddingTop: 23 }}>
                                  <Button
                                    disabled={
                                      !this.state.admissionFormModal.childAllergy ||
                                      !this.state.admissionFormModal
                                        .childAllergyDesc ||
                                      !this.state.admissionFormModal
                                        .childAllergyDate
                                    }
                                    onClick={() => this.addAllergy()}
                                    variant='success'
                                    className='me-1'>
                                    <FontAwesomeIcon icon={faPlus} />
                                  </Button>
                                </Form.Group>
                              </Col>
                            </Row>
                            {this.state.admissionFormModal.childAllergies.map(
                              (item, index) => (
                                <Row key={index}>
                                  <Col md={3} className='p-3'>
                                    {item.allergy}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.desc}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.date}
                                  </Col>
                                  <Col md={1}>
                                    <Form.Group
                                      className='mb-2'
                                      style={{ paddingTop: 10 }}>
                                      <Button
                                        onClick={() =>
                                          this.deleteMedicalRecord(
                                            index,
                                            'childAllergies'
                                          )
                                        }
                                        variant='danger'
                                        className='me-1'>
                                        <FontAwesomeIcon icon={faTrash} />
                                      </Button>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              )
                            )}
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Child Condition')}</h5>
                          </Col>
                          <Col md={12}>
                            <Row>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Condition')}</Form.Label>
                                  <Select
                                    value={
                                      this.state.admissionFormModal.childCondition
                                    }
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                      control: (base) => ({
                                        ...base,
                                        ...styleV3_1.reactSelect
                                      })
                                    }}
                                    options={[
                                      { value: 'ADHD', label: 'ADHD' },
                                      { value: 'Allergies', label: 'Allergies' },
                                      {
                                        value: 'Bronchiole Asthma',
                                        label: 'Bronchiole Asthma',
                                      },
                                      {
                                        value: 'Congenital Heart Disease',
                                        label: 'Congenital Heart Disease',
                                      },
                                      {
                                        value: 'Diabetes Mellitus',
                                        label: 'Diabetes Mellitus',
                                      },
                                      {
                                        value: 'Vision Difficulty',
                                        label: 'Vision Difficulty',
                                      },
                                      { value: 'Eczema', label: 'Eczema' },
                                      {
                                        value: 'Epilepsy/Seizure',
                                        label: 'Epilepsy/Seizure',
                                      },
                                      {
                                        value: 'Febrile Convulsions',
                                        label: 'Febrile Convulsions',
                                      },
                                      {
                                        value: 'Gastric disorders',
                                        label: 'Gastric disorders',
                                      },
                                      {
                                        value: 'Hearing Difficulties',
                                        label: 'Hearing Difficulties',
                                      },
                                      {
                                        value: 'Serious Accidents',
                                        label: 'Serious Accidents',
                                      },
                                    ]}
                                    onChange={(obj) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childCondition: obj,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>
                                    {t('Treatments, Medications')}
                                  </Form.Label>
                                  <Form.Control
                                    type='text'
                                    value={
                                      this.state.admissionFormModal
                                        .childConditionDesc
                                    }
                                    onChange={(e) =>
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childConditionDesc: e.target.value,
                                        },
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={3}>
                                <Form.Group className='mb-2'>
                                  <Form.Label>{t('Date')}</Form.Label>
                                  <Flatpickr
                                    options={{
                                      static: true,
                                    }}
                                    className='form-control'
                                    value={
                                      this.state.admissionFormModal
                                        .childConditionDate
                                    }
                                    onChange={([date]) => {
                                      this.setState({
                                        admissionFormModal: {
                                          ...this.state.admissionFormModal,
                                          childConditionDate:
                                            moment(date).format('YYYY-MM-DD'),
                                        },
                                      });
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={1}>
                                <Form.Group
                                  className='mb-2'
                                  style={{ paddingTop: 23 }}>
                                  <Button
                                    disabled={
                                      !this.state.admissionFormModal
                                        .childCondition ||
                                      !this.state.admissionFormModal
                                        .childConditionDesc ||
                                      !this.state.admissionFormModal
                                        .childConditionDate
                                    }
                                    onClick={() => this.addCondition()}
                                    variant='success'
                                    className='me-1'>
                                    <FontAwesomeIcon icon={faPlus} />
                                  </Button>
                                </Form.Group>
                              </Col>
                            </Row>
                            {this.state.admissionFormModal.childConditions.map(
                              (item, index) => (
                                <Row key={index}>
                                  <Col md={3} className='p-3'>
                                    {item.condition}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.desc}
                                  </Col>
                                  <Col md={3} className='p-3'>
                                    {item.date}
                                  </Col>
                                  <Col md={1}>
                                    <Form.Group
                                      className='mb-2'
                                      style={{ paddingTop: 10 }}>
                                      <Button
                                        onClick={() =>
                                          this.deleteMedicalRecord(
                                            index,
                                            'childConditions'
                                          )
                                        }
                                        variant='danger'
                                        className='me-1'>
                                        <FontAwesomeIcon icon={faTrash} />
                                      </Button>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              )
                            )}
                          </Col>
                        </Row>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_eight' && (
                        <>
                          <Row className='m-0'>
                            <Col md={12}>
                              <p>
                                {t(
                                  'Please select your chosen days and timings from the options below. When available, you can also add additional days, or change timings, subject to availablility. Such changes can only be done by the Administration.'
                                )}
                              </p>
                              <p>{t('Type of Days Attending Nursery:')}</p>
                            </Col>
                          </Row>
                          <Row className='m-0'>
                            <Col md={1}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Monday')}</Form.Label>
                                <div
                                  style={{
                                    paddingLeft: 10,
                                  }}
                                  className='p-3 pb-0'>
                                  <Form.Check
                                    type='switch'
                                    id='monday'
                                    label={false}
                                    onChange={() =>
                                      this.handleAttendingDays('Monday')
                                    }
                                    checked={this.state.admissionFormModal.attending_days.includes(
                                      'Monday'
                                    )}
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                            <Col md={1}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Tuesday')}</Form.Label>
                                <div
                                  style={{
                                    paddingLeft: 10,
                                  }}
                                  className='p-3 pb-0'>
                                  <Form.Check
                                    type='switch'
                                    id='tuesday'
                                    label={false}
                                    onChange={() =>
                                      this.handleAttendingDays('Tuesday')
                                    }
                                    checked={this.state.admissionFormModal.attending_days.includes(
                                      'Tuesday'
                                    )}
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                            <Col md={1}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Wednesday')}</Form.Label>
                                <div
                                  style={{
                                    paddingLeft: 10,
                                  }}
                                  className='p-3 pb-0'>
                                  <Form.Check
                                    type='switch'
                                    id='wednesday'
                                    label={false}
                                    onChange={() =>
                                      this.handleAttendingDays('Wednesday')
                                    }
                                    checked={this.state.admissionFormModal.attending_days.includes(
                                      'Wednesday'
                                    )}
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                            <Col md={1}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Thursday')}</Form.Label>
                                <div
                                  style={{
                                    paddingLeft: 10,
                                  }}
                                  className='p-3 pb-0'>
                                  <Form.Check
                                    type='switch'
                                    id='thursday'
                                    label={false}
                                    onChange={() =>
                                      this.handleAttendingDays('Thursday')
                                    }
                                    checked={this.state.admissionFormModal.attending_days.includes(
                                      'Thursday'
                                    )}
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                            <Col md={1}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Friday')}</Form.Label>
                                <div
                                  style={{
                                    paddingLeft: 10,
                                  }}
                                  className='p-3 pb-0'>
                                  <Form.Check
                                    type='switch'
                                    id='friday'
                                    label={false}
                                    onChange={() =>
                                      this.handleAttendingDays('Friday')
                                    }
                                    checked={this.state.admissionFormModal.attending_days.includes(
                                      'Friday'
                                    )}
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className='m-0'>
                            <Col md={12} className='p-4'>
                              <div className='mb-3'>
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={'8:00am - 1:00pm'}
                                  name='attending_times'
                                  type='radio'
                                  id='attending_times_1'
                                  checked={
                                    this.state.admissionFormModal.attending_times ==
                                    '8:00am - 1:00pm'
                                  }
                                  onChange={() => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        attending_times: '8:00am - 1:00pm',
                                      },
                                    });
                                  }}
                                />
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={'8:00am - 2:00pm'}
                                  name='attending_times'
                                  type='radio'
                                  id='attending_times_2'
                                  checked={
                                    this.state.admissionFormModal.attending_times ==
                                    '8:00am - 2:00pm'
                                  }
                                  onChange={() => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        attending_times: '8:00am - 2:00pm',
                                      },
                                    });
                                  }}
                                />
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={'8:00am - 3:00pm'}
                                  name='attending_times'
                                  type='radio'
                                  id='attending_times_3'
                                  checked={
                                    this.state.admissionFormModal.attending_times ==
                                    '8:00am - 3:00pm'
                                  }
                                  onChange={() => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        attending_times: '8:00am - 3:00pm',
                                      },
                                    });
                                  }}
                                />
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={'8:00am - 4:00pm'}
                                  name='attending_times'
                                  type='radio'
                                  id='attending_times_4'
                                  checked={
                                    this.state.admissionFormModal.attending_times ==
                                    '8:00am - 4:00pm'
                                  }
                                  onChange={() => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        attending_times: '8:00am - 4:00pm',
                                      },
                                    });
                                  }}
                                />
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={'8:00am - 5:00pm'}
                                  name='attending_times'
                                  type='radio'
                                  id='attending_times_5'
                                  checked={
                                    this.state.admissionFormModal.attending_times ==
                                    '8:00am - 5:00pm'
                                  }
                                  onChange={() => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        attending_times: '8:00am - 5:00pm',
                                      },
                                    });
                                  }}
                                />
                                <Form.Check
                                  className='me-4'
                                  inline
                                  label={'8:00am - 6:00pm'}
                                  name='attending_times'
                                  type='radio'
                                  id='attending_times_6'
                                  checked={
                                    this.state.admissionFormModal.attending_times ==
                                    '8:00am - 6:00pm'
                                  }
                                  onChange={() => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        attending_times: '8:00am - 6:00pm',
                                      },
                                    });
                                  }}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row className='m-0'>
                            <Col md={3}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Joining Date')}</Form.Label>
                                <Flatpickr
                                  options={{
                                    static: true,
                                  }}
                                  className='form-control'
                                  value={this.state.admissionFormModal.joining_date}
                                  onChange={([date]) => {
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        joining_date:
                                          moment(date).format('YYYY-MM-DD'),
                                      },
                                    });
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={4}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Number of Days')}</Form.Label>
                                <Select
                                  value={{
                                    label:
                                      this.state.admissionFormModal.num_of_days,
                                    value:
                                      this.state.admissionFormModal.num_of_days,
                                  }}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                    control: (base) => ({
                                      ...base,
                                      ...styleV3_1.reactSelect
                                    })
                                  }}
                                  options={[
                                    { label: 1, value: 1 },
                                    { label: 2, value: 2 },
                                    { label: 3, value: 3 },
                                    { label: 4, value: 4 },
                                    { label: 5, value: 5 },
                                    { label: 6, value: 6 },
                                    { label: 7, value: 7 },
                                  ]}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        num_of_days: obj.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Row className='m-0'>
                            <Col md={3}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Reg Year')}</Form.Label>
                                <Select
                                  classNamePrefix='custom-styled-select'
                                  value={this.state.admissionFormModal.centerlic_id}
                                  options={this.state.ddl_centerlic}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        centerlic_id: obj,
                                      },
                                    })
                                  }
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  formatOptionLabel={(option) => (
                                    <div>
                                      {option.label}
                                      {option.reg_status == 1 && (
                                        <span
                                          className='badge'
                                          style={{
                                            position: 'relative',
                                            top: -1,
                                            marginLeft: 5,
                                            backgroundColor: '#00d045',
                                          }}>
                                          ACTIVE
                                        </span>
                                      )}
                                    </div>
                                  )}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Term')}</Form.Label>
                                <Select
                                  classNamePrefix='custom-styled-select'
                                  value={this.state.admissionFormModal.term_id}
                                  options={this.state.terms.filter((this_term) => this_term.value == this.state.admissionFormModal.centerlic_id?.value)}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        term_id: obj,
                                      },
                                    })
                                  }
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                  formatOptionLabel={(option) => (
                                    <div>
                                      {option.label}
                                      {option.term_active == 1 && (
                                        <span
                                          className='badge'
                                          style={{
                                            position: 'relative',
                                            top: -1,
                                            marginLeft: 5,
                                            backgroundColor: '#00d045',
                                          }}>
                                          ACTIVE
                                        </span>
                                      )}
                                    </div>
                                  )}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Term Default')}</Form.Label>
                                <Select
                                  classNamePrefix='custom-styled-select'
                                  value={this.state.admissionFormModal.term_d_id}
                                  options={this.state.ddl_terms_default}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        term_d_id: obj,
                                      },
                                    })
                                  }
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Grade')}</Form.Label>
                                <Select
                                  classNamePrefix='custom-styled-select'
                                  value={this.state.admissionFormModal.agegroup_id}
                                  options={this.state.ddl_agegroup}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        agegroup_id: obj,
                                      },
                                    })
                                  }
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-2'>
                                <Form.Label>{t('Financial Group')}</Form.Label>
                                <Select
                                  classNamePrefix='custom-styled-select'
                                  value={this.state.admissionFormModal.classmain_id}
                                  options={this.state.ddl_classmain}
                                  onChange={(obj) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        classmain_id: obj,
                                      },
                                    })
                                  }
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                  }}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                        </>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_nine' && (
                        <Row className='m-0'>
                          <Col md={12}>
                            <h5>{t('Terms & Conditions')}</h5>
                            <p style={{ lineHeight: '28px' }}>
                              • <a href='#'>{t('Settling In Policy')}</a>
                              <br />•{' '}
                              <a href='#'>
                                {t('Health, Illness and Emergency Policy')}
                              </a>
                              <br />• <a href='#'>{t('What to Bring')}</a>
                              <br />• <a href='#'>{t('Clinic Information Pack')}</a>
                              <br />• <a href='#'>{t('Fee Structure')}</a>
                            </p>
                          </Col>
                          <Col md={12}>
                            <hr />
                          </Col>
                          <Col md={12}>
                            <h5>{t('Acknowledgement')}</h5>
                          </Col>
                          <Col md={12} className='ps-0'>
                            <Form.Group className='mb-2'>
                              <Form.Label>{t('Acknowledged')}</Form.Label>
                              <div
                                style={{
                                  paddingLeft: 10,
                                }}
                                className='p-3 pb-0 pt-2'>
                                <Form.Check
                                  type='switch'
                                  id='check_acknowledgement'
                                  label={false}
                                  onChange={() =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        check_acknowledgement:
                                          this.state.admissionFormModal
                                            .check_acknowledgement == 1
                                            ? 0
                                            : 1,
                                      },
                                    })
                                  }
                                  checked={
                                    this.state.admissionFormModal.check_acknowledgement == 1
                                  }
                                />
                              </div>
                            </Form.Group>
                          </Col>
                          <Col md={3}>
                            <Form.Group className='mb-3'>
                              <Form.Label>{t('Signature')}</Form.Label>
                              <div
                                style={{
                                  flexDirection: 'column',
                                }}
                                className='pic-prev d-flex justify-content-center'>
                                <div
                                  style={{
                                    borderRadius: 5,
                                    borderStyle: 'dashed',
                                    borderWidth: 2,
                                    borderColor: '#ced4da',
                                    height: 150,
                                    display: 'flex',
                                    overflow: 'hidden',
                                  }}>
                                  {this.state.admissionFormModal.signature !== '' &&
                                    this.state.admissionFormModal.signature_prev !==
                                    '' ? (
                                    <div
                                      className='d-flex justify-content-center align-items-center'
                                      style={{
                                        flex: 1,
                                        position: 'relative',
                                      }}>
                                      <button
                                        style={{
                                          padding: 3,
                                          border: 3,
                                          background: 'none',
                                          position: 'absolute',
                                          top: 0,
                                          right: 0,
                                        }}
                                        onClick={() => {
                                          this.setState({
                                            admissionFormModal: {
                                              ...this.state.admissionFormModal,
                                              signature: '',
                                              signature_prev: '',
                                              signature_delete_flag: false,
                                            },
                                          });
                                          this.signature.current.value = null;
                                        }}>
                                        <FontAwesomeIcon
                                          icon={faTimesCircle}
                                          color='rgb(220, 53, 69)'
                                          style={{
                                            fontSize: 20,
                                          }}
                                        />
                                      </button>
                                      <img
                                        src={
                                          this.state.admissionFormModal
                                            .signature_prev
                                        }
                                        alt={t('Preview')}
                                        width='100'
                                      />
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() => this.signature.current.click()}
                                      style={{
                                        background: 'none',
                                        border: 0,
                                        flex: 1,
                                      }}>
                                      <FontAwesomeIcon
                                        icon={faPlus}
                                        style={{
                                          fontSize: 30,
                                        }}
                                      />
                                    </button>
                                  )}
                                </div>
                                <Form.Control
                                  className='d-none'
                                  ref={this.signature}
                                  type='file'
                                  onChange={this.previewFile}
                                  name='signature'
                                  accept='.jpg, .jpeg, .png'
                                />
                              </div>
                            </Form.Group>
                            <strong>{t("Today's Date")}:</strong>{' '}
                            {moment().format('DD-MM-YYYY')}
                          </Col>
                        </Row>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_ten' && (
                        <>
                          <Row className='m-0'>
                            <Col md={12}>
                              <h5 className='mb-3'>{t('Previous Schools and Countries of Residence')}</h5>
                            </Col>
                            <Col md={12}>
                              {this.state.admissionFormModal.admissioncountries.map((country, index) => (
                                <div key={index}
                                  className='mb-3'
                                  style={{
                                    background: '#f9f9f9',
                                    padding: '5px 20px',
                                    borderRadius: 7,
                                  }}>
                                  <Row>
                                    <Col md={3} className='my-2'>
                                      <strong>{t('Country')}</strong><br />
                                      {country.admcntr_country}
                                    </Col>
                                    <Col md={3} className='my-2'>
                                      <strong>{t('School Name')}</strong><br />
                                      { }{country.admcntr_school}
                                    </Col>
                                    <Col md={1} className='my-2'>
                                      <strong>{t('Year')}</strong><br />
                                      {country.admcntr_year}
                                    </Col>
                                    <Col md={2} className='my-2'>
                                      <strong>{t('Grade')}</strong><br />
                                      {country.admcntr_grade}
                                    </Col>
                                    <Col md={3} className='my-2'>
                                      <strong>{t('Language of Instruction')}</strong><br />
                                      {country.admcntr_instruction}
                                    </Col>
                                    <Col md={3} className='my-2'>
                                      <strong>{t('Reference Name')}</strong><br />
                                      {country.admcntr_referral}
                                    </Col>
                                    <Col md={3} className='my-2'>
                                      <strong>{t('Reference Position')}</strong><br />
                                      {country.admcntr_ref_title}
                                    </Col>
                                    <Col md={3} className='my-2'>
                                      <strong>{t('Reference Email')}</strong><br />
                                      {country.admcntr_email}
                                    </Col>
                                    <Col md={3} className='my-2'>
                                      <strong>{t('Reference Phone')}</strong><br />
                                      {country.admcntr_phone}
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                            </Col>
                          </Row>
                        </>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_eleven' && (
                        <>
                          <Alert>{('This section is depricated please add siblings in the section below.')}</Alert>
                          <Row className='m-0'>
                            <Col md={12}>
                              <h5 className='mb-3'>{t('Siblings')} <Badge bg="danger">Depricated</Badge></h5>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Sibling Name')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.child_siblings
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_siblings: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('Sibling Age')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal.child_siblings_age
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_siblings_age: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                            <Col md={3}>
                              <Form.Group className='mb-3'>
                                <Form.Label>{t('School Attending')}</Form.Label>
                                <Form.Control
                                  type='text'
                                  defaultValue={
                                    this.state.admissionFormModal
                                      .child_school_attending
                                  }
                                  onChange={(e) =>
                                    this.setState({
                                      admissionFormModal: {
                                        ...this.state.admissionFormModal,
                                        child_school_attending: e.target.value,
                                      },
                                    })
                                  }
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <h5>{t('Add new Sibling')} <Badge bg="info">New</Badge></h5>
                          <Row className='my-1 align-items-center'>
                            <Col md={3} className='my-2'>
                              <Form.Label>{t('Sibling Name')}</Form.Label>
                              <Form.Control
                                type='text'
                                value={siblingFields.adm_sib_name}
                                onChange={(e) =>
                                  this.setState({ siblingFields: { ...siblingFields, adm_sib_name: e.target.value } })
                                }
                              />
                            </Col>
                            <Col md={2} className='my-2'>
                              <Form.Label>{t('Sibling DOB')}</Form.Label>
                              <Flatpickr
                                options={{
                                  static: true,
                                }}
                                className='form-control'
                                value={siblingFields.adm_sib_dob}
                                onChange={([date]) => {
                                  this.setState({ siblingFields: { ...siblingFields, adm_sib_dob: moment(date).format('YYYY-MM-DD') } })
                                }}
                              />
                            </Col>
                            <Col md={2} className='my-2'>
                              <Form.Label>{t('Gender')}</Form.Label>
                              <Form.Check
                                type="switch"
                                id="custom-switch"
                                label={(siblingFields.adm_sib_gender == 'M') ? 'Male' : 'Female'}
                                checked={(siblingFields.adm_sib_gender == 'M')}
                                onChange={() =>
                                  this.setState({ siblingFields: { ...siblingFields, adm_sib_gender: (siblingFields.adm_sib_gender == 'M') ? 'F' : 'M' } })
                                }
                              />
                            </Col>
                            <Col md={3} className='my-2'>
                              <Form.Label>{t('School')}</Form.Label>
                              <Form.Control
                                type='text'
                                value={siblingFields.adm_sib_school}
                                onChange={(e) =>
                                  this.setState({ siblingFields: { ...siblingFields, adm_sib_school: e.target.value } })
                                }
                              />
                            </Col>
                            <Col md={1}>
                              <Button variant='primary' onClick={() => {
                                let admissionFormModal = this.state.admissionFormModal
                                admissionFormModal.siblings.push({ ...siblingFields })
                                this.setState({
                                  admissionFormModal,
                                  siblingFields: { ...this.siblingFields }
                                })
                              }}>
                                <FontAwesomeIcon icon={faPlus} />
                              </Button>
                            </Col>
                          </Row>
                          <Row className='my-1'>
                            <Col md={12}>
                              {this.state.admissionFormModal.siblings.map((sib, index) => (
                                <div key={index}
                                  className='mb-2'
                                  style={{
                                    background: '#f9f9f9',
                                    padding: '5px 20px',
                                    borderRadius: 7,
                                  }}>
                                  <Row>
                                    <Col md={3} className='my-2'>
                                      <strong>{t('Sibling Name')}</strong><br />
                                      {sib.adm_sib_name}
                                    </Col>
                                    <Col md={3} className='my-2'>
                                      <strong>{t('Sibling DOB')}</strong><br />
                                      {sib.adm_sib_dob}
                                    </Col>
                                    <Col md={1} className='my-2'>
                                      <strong>{t('Gender')}</strong><br />
                                      {sib.adm_sib_gender}
                                    </Col>
                                    <Col md={2} className='my-2'>
                                      <strong>{t('School')}</strong><br />
                                      {sib.adm_sib_school}
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                            </Col>
                          </Row>
                        </>
                      )}
                      {this.state.admissionFormModal.activeTab == 'tab_twelve' && (
                        <>
                          <Row className='m-0'>
                            <Col md={12}>
                              <h5 className='mb-3'>{t('Q&A')}</h5>
                            </Col>
                            <Col md={12}>
                              {this.state.admissionFormModal.qna.map((grp, grp_index) => (
                                // admg_title
                                // admg_title_ar
                                // admg_order
                                // admg_status
                                <div key={grp_index}
                                  className='mb-3'
                                  style={{
                                    background: '#f9f9f9',
                                    padding: '15px 20px 5px',
                                    borderRadius: 7,
                                  }}>
                                  <h5 className='mb-3'>{grp.admg_title}</h5>
                                  {grp.admg_title_ar &&
                                    <h5 className='mb-3'>{grp.admg_title_ar}</h5>
                                  }
                                  {/* adm_desc
                                adm_desc_ar
                                adm_mandatory
                                adm_tf
                                adm_order
                                adm_quest_status */}
                                  {/* adm_ans_answer
                                adm_ans_comment */}
                                  {grp.questions.map((q, q_index) => (
                                    <div key={q_index}>
                                      <h6>{q.adm_desc}</h6>
                                      {q.adm_desc_ar &&
                                        <h6>{q.adm_desc_ar}</h6>
                                      }
                                      {(q.adm_tf == 1 && q.adm_ans_id) &&
                                        <Badge bg={(q.adm_ans_answer == 1) ? 'primary' : 'danger'}>{(q.adm_ans_answer == 1) ? 'True' : 'False'}</Badge>
                                      }
                                      {q.adm_ans_comment ?? '-'}
                                    </div>
                                  ))}
                                </div>
                              ))}
                            </Col>
                          </Row>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
              )}
            </Modal.Body>
          }
          <Modal.Footer>
            <Button
              variant='secondary'
              onClick={this.handleCloseAdmissionFormModal}>
              {t('Close')}
            </Button>
            <Button
              variant='primary'
              data-tab-name='tab_finish'
              onClick={this.switchTab}>
              {t('Save')}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Tasks Modal */}
        <LeadTasks
          onHide={() => this.setState({ waitingObject: null })}
          waitingObject={this.state.waitingObject}
          noEnrReasons={this.state.noEnrReasons}
          fetch={() => this.fetch({
            search: '',
            limit: this.state.cdt.rows,
            order: this.state.cdt.order,
            dir: this.state.cdt.dir,
            page: this.state.cdt.page,
          })} />

        {/* Filters */}
        <Offcanvas show={this.state.filter.show} placement={'end'}
          onHide={() => this.setState({
            filter: {
              ...this.state.filter,
              show: false,
            }
          })}
          style={{
            width: 614
          }}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>{t('Filters')}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className='pt-0'>
            <div>
              <Row>
                <Col md={6} className='position-relative mb-3'>
                  <Form.Label className='w-100'>
                    <Row>
                      <Col>{t('Date Range')}</Col>
                      <Col md={'auto'} className='text-end'>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          label={null}
                          checked={this.state.filter.filter_date_range_enable}
                          onChange={() =>
                            this.setState({
                              filter: {
                                ...this.state.filter,
                                filter_date_range_enable: !this.state.filter.filter_date_range_enable,
                              },
                            })}
                        />
                      </Col>
                    </Row>
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      disabled={!this.state.filter.filter_date_range_enable}
                      onClick={() =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            showDateRange: true,
                          },
                        })
                      }
                      style={{
                        paddingLeft: 20,
                      }}
                      value={
                        moment(
                          this.state.filter.filter_date_range.startDate
                        ).format('DD-MM-YYYY') +
                        ' -- ' +
                        moment(
                          this.state.filter.filter_date_range.endDate
                        ).format('DD-MM-YYYY')
                      }
                      readOnly
                    />
                    <Button
                      disabled={!this.state.filter.filter_date_range_enable}
                      variant={
                        this.state.filter.showDateRange ? 'danger' : 'primary'
                      }
                      style={{ width: 40 }}
                      onClick={() =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            showDateRange: !this.state.filter.showDateRange,
                          },
                        })
                      }
                      id='button-addon2'>
                      <FontAwesomeIcon
                        icon={
                          this.state.filter.showDateRange
                            ? faXmark
                            : faCalendarAlt
                        }
                        style={{
                          fontSize: 16,
                          color:
                            brand_colors[this.props.defaultTheme.theme_id]
                              .color8,
                        }}
                      />
                    </Button>
                  </InputGroup>
                  {this.state.filter.showDateRange && (
                    <div
                      style={{
                        backgroundColor: '#fff',
                        padding: 10,
                        position: 'absolute',
                        border: '#F2F2F2 2px solid',
                        zIndex: 10,
                        top: 69,
                        borderRadius: 7,
                      }}>
                      <DateRangePicker
                        ranges={[this.state.filter.filter_date_range]}
                        onChange={(date) => {
                          this.setState({
                            filter: {
                              ...this.state.filter,
                              filter_date_range: {
                                startDate: new Date(date.selection.startDate),
                                endDate: new Date(date.selection.endDate),
                                key: 'selection',
                              },
                            },
                          });
                        }}
                        style={{ backgroundColor: '#fff' }}
                      />
                    </div>
                  )}
                </Col>
                <Col md={6} className='position-relative mb-3'>
                  <Form.Label className='w-100'>
                    <Row>
                      <Col>{t('Approved Date Range')}</Col>
                      <Col md={'auto'} className='text-end'>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          label={null}
                          checked={this.state.filter.filter_approved_date_enable}
                          onChange={() =>
                            this.setState({
                              filter: {
                                ...this.state.filter,
                                filter_approved_date_enable: !this.state.filter.filter_approved_date_enable,
                              },
                            })}
                        />
                      </Col>
                    </Row>
                  </Form.Label>
                  <InputGroup>
                    <Form.Control
                      disabled={!this.state.filter.filter_approved_date_enable}
                      onClick={() =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            showApprovedDateRange: true,
                          },
                        })
                      }
                      style={{
                        paddingLeft: 20,
                      }}
                      value={
                        moment(
                          this.state.filter.filter_approved_date.startDate
                        ).format('DD-MM-YYYY') +
                        ' -- ' +
                        moment(
                          this.state.filter.filter_approved_date.endDate
                        ).format('DD-MM-YYYY')
                      }
                      readOnly
                    />
                    <Button
                      disabled={!this.state.filter.filter_approved_date_enable}
                      variant={
                        this.state.filter.showApprovedDateRange ? 'danger' : 'primary'
                      }
                      style={{ width: 40 }}
                      onClick={() =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            showApprovedDateRange: !this.state.filter.showApprovedDateRange,
                          },
                        })
                      }
                      id='button-addon2'>
                      <FontAwesomeIcon
                        icon={
                          this.state.filter.showApprovedDateRange
                            ? faXmark
                            : faCalendarAlt
                        }
                        style={{
                          fontSize: 16,
                          color:
                            brand_colors[this.props.defaultTheme.theme_id]
                              .color8,
                        }}
                      />
                    </Button>
                  </InputGroup>
                  {this.state.filter.showApprovedDateRange && (
                    <div
                      style={{
                        backgroundColor: '#fff',
                        padding: 10,
                        position: 'absolute',
                        border: '#F2F2F2 2px solid',
                        zIndex: 10,
                        top: 69,
                        left: -290,
                        borderRadius: 7,
                      }}>
                      <DateRangePicker
                        ranges={[this.state.filter.filter_approved_date]}
                        onChange={(date) => {
                          this.setState({
                            filter: {
                              ...this.state.filter,
                              filter_approved_date: {
                                startDate: new Date(date.selection.startDate),
                                endDate: new Date(date.selection.endDate),
                                key: 'selection',
                              },
                            },
                          });
                        }}
                        style={{ backgroundColor: '#fff' }}
                      />
                    </div>
                  )}
                </Col>
                <Col md={6} className='mb-3'>
                  <Form.Group className='mb-2'>
                    <Form.Label>{t('Age Upto')}</Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      isClearable
                      value={this.state.filter.filter_age}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={Array(22)
                        .fill()
                        .map((_, i) => {
                          return {
                            value: i + 1,
                            label: i + 1 + ' Y',
                          };
                        })}
                      onChange={(obj) =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_age: obj,
                          },
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className='mb-3'>
                  <Form.Group className='mb-2'>
                    <Form.Label>{t('Nationality')}</Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      isClearable
                      value={this.state.filter.filter_nationality}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.state.countries}
                      onChange={(obj) =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_nationality: obj,
                          },
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className='mb-3'>
                  <Form.Group>
                    <Form.Label>{t('Source')}</Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      isClearable
                      value={this.state.filter.filter_source}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.state.visitbys}
                      onChange={(obj) =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_source: obj,
                          },
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className='mb-3'>
                  <Form.Group>
                    <Form.Label>{t('Referral')}</Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      isClearable
                      value={this.state.filter.filter_referral}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.state.referrals}
                      onChange={(obj) =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_referral: obj,
                          },
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className='mb-3 position-relative'>
                  <Form.Group>
                    <Form.Label>{t('Joining Date')}</Form.Label>
                    <Flatpickr
                      options={{
                        static: true,
                      }}
                      className='form-control'
                      value={this.state.filter.filter_joining_date}
                      onChange={([date]) => {
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_joining_date: moment(date).format('YYYY-MM-DD'),
                          },
                        })
                      }}
                    />
                    {this.state.filter.filter_joining_date &&
                      <FontAwesomeIcon icon={faTimes} style={{ position: 'absolute', top: 40, right: 22, cursor: 'pointer' }} onClick={() => this.setState({
                        filter: {
                          ...this.state.filter,
                          filter_joining_date: '',
                        },
                      })} />
                    }
                  </Form.Group>
                </Col>
                <Col md={6} className='mb-3'>
                  <Form.Group>
                    <Form.Label>{t('Class')}</Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      isClearable
                      value={this.state.filter.filter_class}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.state.classes}
                      onChange={(obj) =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_class: obj,
                          },
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className='mb-4'>
                  <Form.Group>
                    <Form.Label>{t('Admission')}</Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      isClearable
                      value={this.state.filter.filter_admission}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.filterAdmission}
                      onChange={(obj) =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_admission: obj,
                          },
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className='mb-4'>
                  <Form.Group>
                    <Form.Label>{t('Status')}</Form.Label>
                    <Select
                      classNamePrefix='custom-styled-select'
                      isClearable
                      value={this.state.filter.filter_status}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.filterStatus}
                      onChange={(obj) =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_status: obj,
                          },
                        })
                      }
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className='mb-4'>
                  <Form.Group>
                    <Form.Label>
                      {t('Flow')}
                    </Form.Label>
                    <Select
                      isMulti
                      classNamePrefix='custom-styled-select'
                      isClearable
                      value={this.state.filter.filter_leadstatus}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999,
                        }),
                      }}
                      options={this.state.leadStatusList}
                      onChange={(obj) =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_leadstatus: obj,
                          },
                        })
                      }
                      formatOptionLabel={({ ls_color, ls_abbreviation }) => (
                        <span
                          style={{
                            borderColor: ls_color,
                            borderWidth: 2,
                            borderStyle: 'solid',
                            color: ls_color,
                            padding: 1,
                            fontSize: 13,
                            borderRadius: 5,
                            paddingInline: 7,
                          }}>
                          {ls_abbreviation}
                        </span>
                      )}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={6} className='mb-3'>
                  <div className='d-grid gap-2'>
                    <Button
                      onClick={() =>
                        this.setState({
                          filter: {
                            ...this.filterFields,
                            show: true,
                            filter_enable: false,
                          }
                        }, () => this.fetch({
                          search: '',
                          limit: this.state.cdt.rows,
                          order: this.state.cdt.order,
                          dir: this.state.cdt.dir,
                          page: 0,
                        }))
                      }
                      variant='secondary'
                      size='sm'>
                      {t('Clear Filters')}
                    </Button>
                  </div>
                </Col>
                <Col md={6} className='mb-3'>
                  <div className='d-grid gap-2'>
                    <Button
                      onClick={() =>
                        this.setState({
                          filter: {
                            ...this.state.filter,
                            filter_enable: true,
                          }
                        }, () => this.fetch({
                          search: '',
                          limit: this.state.cdt.rows,
                          order: this.state.cdt.order,
                          dir: this.state.cdt.dir,
                          page: 0,
                        }))
                      }
                      variant='primary'
                      size='sm'>
                      {t('Filter')}
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Offcanvas.Body>
        </Offcanvas>

        {/* Delete Confirmation */}
        <SweetAlert show={this.state.deleteConfirm.show} warning showCancel confirmBtnText={t('Yes, delete it!')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.state.deleteConfirm.action} onCancel={() => this.setState({ deleteConfirm: { show: false, id: 0, action: () => { } } })} focusCancelBtn>
          {t('Confirm Delete!')}
        </SweetAlert>

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

export default connect(mapStateToProps, null)(Leads);
